export default {
  common: { loading: 'Ładowanie…', noData: 'Brak danych', clear: 'Wyczyść', delete: 'Usuń' },
  errors: { /* notices-i18n */
    generic: 'Coś poszło nie tak. Proszę spróbować ponownie.',    codes: {
      // The clock card's refusals (time-api /timer/start and /timer/stop): the card
      // shows the specific reason, as time-ui's own clock button does (issue 700).
      leave_day: 'Na ten dzień przypada zatwierdzona całodniowa nieobecność — nie można na niego zarejestrować czasu pracy.',
      // A person her contract frees from booking working time (issue 981): time-api refuses the clock-in with this code.
      work_time_booking_off: 'Zgodnie z umową rejestrowany jest tylko czas projektu, nie czas pracy.',
      week_approved: 'Ten tydzień jest już zatwierdzony i zablokowany – zmiany tylko przez wniosek o korektę.',
      week_submitted: 'Ten tydzień został złożony i czeka na decyzję – zmiany dopiero po jego wycofaniu lub odesłaniu.',
      already_clocked_in: 'Rozpoczęcie pracy zostało już zarejestrowane. Proszę najpierw zakończyć trwający czas pracy.',
      block_overlap: 'Ten czas pracy nakłada się na inny.',
      block_locked: 'Ten czas pracy jest zablokowany przez zatwierdzony tydzień. Proszę zamiast tego złożyć wniosek o korektę.',
      // user-api's SSO connection PUT (#882): issuer and client are frozen while SSO is enforced.
      sso_enforced: 'Proszę wyłączyć „Wymagaj logowania tylko przez SSO”, zanim zmienią Państwo URL wydawcy lub Client ID.',
      // The SSO connection PUT of user-api (issue 926): a list entry that is not a domain.
      invalid_domain: 'Jedna z domen e-mail nie jest domeną. Proszę wpisać domeny takie jak example.com, bez symboli wieloznacznych i adresów stron.',
      // ats-api reports this flat on the envelope; `errorKeyFor` prefers a
      // curated code entry over the status fallback, which is how the custom-field
      // dialog keeps its one specific message without reading the backend string.
      CUSTOM_FIELD_SENSITIVITY_LOCKED: 'To pole zostało zadeklarowane jako szczególna kategoria; deklaracji nie można wycofać.',
      LEGAL_NOTICE_BLANK_EMPTY: 'Pola nie można wypełnić niczym.',
      LEGAL_NOTICE_BLANK_UNKNOWN: 'Ta informacja nie ma pola o tej nazwie.',
      LEGAL_NOTICE_BLANK_TOKEN: 'Wartość nie może sama zawierać niewypełnionego pola.',
      // The employee-notice gate (issue 576 M3): the invite refusal names WHO
      // can clear it, so an admin sent here knows the fix is not theirs to retry.
      EMPLOYEE_NOTICE_INCOMPLETE: 'Zaproszenia są wstrzymane, dopóki wszystkie pola informacji dla pracowników w sekcji Informacje prawne nie zostaną uzupełnione. Proszę poprosić właściciela obszaru roboczego, administrację suite lub inspektora ochrony danych o ich uzupełnienie.',
      LEGAL_READINESS_UNAVAILABLE: 'Nie mogliśmy sprawdzić, czy informacje dla pracowników są kompletne. Proszę spróbować ponownie za kilka minut.',
    } as Record<string, string>,
  },
  billing: {
    title: 'Rozliczenia', status: 'Status', paymentMethod: 'Metoda płatności',
    updateCard: 'Wymień kartę', addCard: 'Dodaj kartę',
    invoices: 'Faktury', charges: 'Płatności',
    noInvoices: 'Brak faktur.', noCharges: 'Brak płatności.',
    noCard: 'Brak zapisanej', validUntil: 'ważna do {date}',
    trialDaysLeft: 'Pozostało {days} dni okresu próbnego', trialExpired: 'Okres próbny wygasł',
    trialDaysLeftUntil: 'Pozostało {days} dni okresu próbnego — kończy się {date}',
    // A free_months promo account (issue 808): the whole cardless run, never "trial end" at d2.
    trialDaysLeftFree: 'Pozostało {days} dni za darmo — do {date}',
    nextChargeOn: 'Następne obciążenie: {date}',
    exempt: { badge: 'Zwolnienie z opłat', note: 'lumi ustalił, że w tej chwili ten obszar roboczy nie jest obciążany opłatami.' },
    download: 'Pobierz', dangerZone: 'Strefa zagrożenia',
    col: { date: 'Data', period: 'Okres', net: 'Netto', vat: 'VAT', gross: 'Brutto', status: 'Status', kind: 'Typ', amount: 'Kwota', document: 'Faktura' },
    statusLabel: { trialing: 'Okres próbny', active: 'Aktywny', delinquent: 'Płatność zaległa', closed: 'Zamknięty', canceled: 'Anulowany' },
    tab: { plans: 'Plany', paymentMethod: 'Metoda płatności', invoices: 'Faktury i płatności', referral: 'Polecenia', externalPostings: 'Ogłoszenia o pracę', dangerZone: 'Rezygnacja i usunięcie' },
    externalPostings: {
      title: 'Ogłoszenia w zewnętrznych serwisach pracy',
      intro: 'Ogłoszenia w zewnętrznych serwisach pracy zamawia się pojedynczo i są rozliczane za każde zamówienie — nawet po kilka tysięcy euro. Gdy ta opcja jest włączona, takie zamówienia może składać każdy, czyja rola w rekrutacji ma uprawnienie „Publikować zewnętrznie (płatne)” — na początku tylko administratorzy rekrutacji; każde z nich obciąża tę przestrzeń roboczą.',
      switchLabel: 'Zezwalaj na zamawianie ogłoszeń w zewnętrznych serwisach pracy',
      saving: 'Zapisywanie',
      offHint: 'Wyłączenie zatrzymuje wyłącznie nowe zamówienia. Ogłoszenia już emitowane pozostają online i są nadal rozliczane do końca swojego okresu.',
      offHintOpenOrders: 'Obecnie trwa emisja ogłoszeń. Wyłączenie zatrzymuje wyłącznie nowe zamówienia — trwające ogłoszenia pozostają online i są nadal rozliczane do końca swojego okresu.',
      roleNote: 'To ustawienie może zmienić wyłącznie właściciel przestrzeni roboczej, menedżer płatności lub administrator pakietu. Osoby, które nie powinny zamawiać ogłoszeń, zatrzymuje się po stronie rekrutacji — odbierając ich roli uprawnienie „Publikować zewnętrznie (płatne)”.',
      demoNote: 'To jest demonstracyjna przestrzeń robocza. Jej ustawienia zostaną zastąpione przy właściwej konfiguracji, dlatego przełącznik pozostaje do tego czasu zablokowany.',
      noCardTitle: 'Brak zapisanej metody płatności',
      noCardBody: 'Może Pan/Pani włączyć tę opcję już teraz, ale zamówienie ogłoszenia będzie mogło zostać opłacone dopiero po zapisaniu karty.',
      noCardCta: 'Dodaj kartę',
      savedOn: 'Ogłoszenia zewnętrzne są włączone. Rekruterzy zobaczą sekcję zamawiania przy następnym wczytaniu strony.',
      savedOff: 'Ogłoszenia zewnętrzne są wyłączone. Nie można zamawiać nowych ogłoszeń; już emitowane pozostają online i są nadal rozliczane.',
    },
    invoiceStatus: { draft: 'W przygotowaniu', issued: 'Wystawiona', sent: 'Wysłana', canceled: 'Anulowana' },
    chargeKind: { subscription: 'Abonament', proration: 'Rozliczenie proporcjonalne', posting: 'Ogłoszenie o pracę', recovery: 'Dopłata' },
    posting: { orderRef: 'Zamówienie {ref}', invoice: 'Pobierz fakturę' },
    chargeStatus: { created: 'Utworzono', pending: 'Oczekuje', paid: 'Opłacono', failed: 'Nieudana', authorized: 'Zablokowana', order_placed: 'Złożono', capture_requested: 'Zażądano pobrania', captured: 'Opłacona', settled: 'Opłacona', refunded: 'Zwrócona', chargeback: 'Obciążenie zwrotne', voided: 'Nieudana' },
    bill: { label: 'Faktura {number}', labelMany: 'Faktury {number}', unnumbered: 'Faktura w przygotowaniu', paid: 'Opłacona', closed: 'Zamknięta', retry: 'Ponowna próba', projected: 'Przewidywana' },
    // The promo (issue 808, ADR 0100): one line for the phase the account is in.
    promo: { trial: 'Okres próbny do {start} · potem 1 miesiąc gratis do {end} · kod {code} | Okres próbny do {start} · potem miesiące gratis: {n}, do {end} · kod {code}', run: 'Miesiące gratis do {end} · kod {code}', discount: 'Okres próbny do {start} · potem rabat {percent} % na miejsca i moduły przez {n} mies. · kod {code}', discountRun: 'Rabat {percent} % na miejsca i moduły do {end} · kod {code}', invoiceLine: 'Kod promocyjny {code} −{percent} %', referralLine: 'Bonus za polecenie −{percent} %', referralLineCapped: 'Bonus za polecenie −{percent} % (z limitem)' },
    // A module code typed in the add-module dialog (issue 1029, M2).
    modulePromo: { label: 'Kod promocyjny (opcjonalnie)', apply: 'Zastosuj', remove: 'Usuń', applied: '{code}: rabat {percent} % na {module} na 1 fakturę | {code}: rabat {percent} % na {module}, liczba faktur: {n}', savesToday: 'Kod obniża dzisiejszą opłatę o {amount}.', rateLimited: 'Zbyt wiele prób. Poczekaj kilka minut i spróbuj ponownie.', checkFailed: 'Nie można teraz sprawdzić kodu. Możesz dodać moduł bez niego.', notBooked: 'Nic nie zostało zamówione – możesz dodać moduł bez kodu.', addedWithoutDiscount: 'Nie udało się zastosować kodu, więc rabatu nie ma.', module: { time_tracking: 'Ewidencja czasu pracy' }, trimmed: '{code} daje {percent} %, ale na Twojej fakturze jest już rabat – na {module} dostajesz {effective} % (wszystkie rabaty na jednej fakturze mają limit).', trimmedNothing: '{code} daje {percent} %, ale na Twojej fakturze jest już rabat – ten kod nic teraz nie dodaje.', pending: 'Nadal potwierdzamy Twój kod – pojawi się na następnej fakturze, gdy zostanie potwierdzony.', invoiceLine: 'Kod promocyjny {code} −{percent} % ({module})', running: '{code}: rabat {percent} % na jeszcze 1 fakturę | {code}: rabat {percent} % na kolejne faktury: {n}', reason: { unknown: 'Nie znamy tego kodu. Sprawdź pisownię.', disabled: 'Ten kod został wyłączony.', notYetValid: 'Ten kod jeszcze nie obowiązuje.', expired: 'Ten kod wygasł.', exhausted: 'Ten kod został już przez Ciebie użyty albo jest wyczerpany.', moduleNotEligible: 'Ten kod nie obejmuje modułu {module}.', wrongCheckout: 'Ten kod jest dla nowych rejestracji, nie do dodawania modułu.', unavailable: 'Tego kodu nie można tu użyć.' } },
    // The billing door (issue 824): a promo code entered on a running workspace.
    // The workspace's own referral code (issue 824), shown to those who manage billing.
    referral: { title: 'Twój kod polecający', copy: 'Kopiuj kod', copyLink: 'Kopiuj link do zamówienia', copied: 'Skopiowano kod polecający', linkCopied: 'Skopiowano link do zamówienia', friendGets: 'Kto użyje go na początku, płaci o {percent} % mniej przez pierwsze {n} mies.', youGet: 'Gdy ta firma zacznie płacić, dostajesz rabat {percent} % na Twoje faktury (liczba faktur: {n}).', rules: 'Kilka bonusów sumuje się — do {ceiling} % na jednej fakturze.', rulesCapped: 'Kilka bonusów sumuje się — do {ceiling} % na jednej fakturze, maksymalnie {cap} na bonus.', paused: 'Twój kod jest wstrzymany, dopóki dla Twojej przestrzeni roboczej otwarty jest wniosek o usunięcie. Zadziała ponownie, gdy tylko zostanie wycofany.', disabled: 'Ten kod został wyłączony i nie można go już użyć.', none: { trialing: 'Kod polecający pojawi się, gdy przestrzeń robocza zacznie płacić, czyli po okresie próbnym.', free_run: 'Kod polecający pojawi się, gdy skończą się darmowe miesiące i przestrzeń robocza zacznie płacić.', not_billing: 'Kod polecający pojawi się, gdy przestrzeń robocza będzie miała aktywną subskrypcję.' }, loading: 'Wczytywanie Twojego kodu polecającego …', error: 'Nie udało się teraz odczytać kodu polecającego. Spróbuj ponownie później.', list: { title: 'Twoje polecenia', empty: 'Tu pojawi się każda firma, która użyje Twojego kodu — razem z tym, co Ci przynosi.', emptyHint: 'Najpierw testuje, potem płaci, a Twój bonus czeka tu na odebranie.', since: 'Polecenie z dnia {date}', pill: { testing: 'Jeszcze testuje', paying: 'Płaci', ready: 'Gotowy', running: 'Trwa {x}/{y}' }, invoices: 'faktur: {n}', sentence: { testing: 'Twój bonus pojawi się, gdy firma zacznie płacić.', paying: 'Firma płaci od {date} — Twój bonus jest w drodze.', ready: 'Firma płaci od {date} — dostajesz rabat {percent} % ({invoices}){cap}.', readyCap: ', maksymalnie {cap} na fakturę', startsOn: 'Twój bonus zaczyna się od faktury z dnia {date}.', startsNext: 'Twój bonus zaczyna się od następnej faktury.', waits: 'Twój bonus czeka na miejsce na jednej z kolejnych faktur.', carried: 'Bonus był już na fakturach za: {months}', nextLast: 'ostatnia to faktura z dnia {date}', nextThen: 'następna to faktura z dnia {date}, potem jeszcze: {n}', toCome: 'zostało: {n}', done: 'Firma płaci od {date} — Twój bonus był na fakturach za: {months}.', doneNone: 'Firma płaci od {date} — Twój bonus został wykorzystany.' }, done: { line: 'Zakończone polecenia: {n} — każde przyniosło Ci rabat {percent} % ({invoices})', lineMixed: 'Zakończone polecenia: {n}', show: 'Pokaż', hide: 'Ukryj' }, carries: { items: 'Następna faktura z dnia {date} zawiera: {items}.', itemsNoDate: 'Następna faktura zawiera: {items}.', none: 'Następna faktura z dnia {date}: bez rabatu.', noneNoDate: 'Następna faktura: bez rabatu.', readyNote: 'Odebrany znaczy: od tej faktury.' } }, bonus: { collect: 'Odbierz', capped: 'z limitem', running: { promo: '{percent} % z kodu promocyjnego', module: '{percent} % z kodu modułu', referral: '{percent} % z bonusu za polecenie' }, collected: 'Odebrano — bonus będzie teraz odliczany od kolejnych faktur.', alreadyRunning: 'Ten bonus już działa.', collectFailed: 'Nie udało się teraz odebrać bonusu. Spróbuj ponownie.', hint: { lead: 'Jeszcze nie.', tail: '— bonus czeka tutaj, nic nie przepada.', ceiling: 'Następna faktura zawiera już {running}, a z tym bonusem przekroczyłaby limit {ceiling} %', ceilingRunning: 'Następna faktura zawiera już {running}, więc nie ma miejsca na ten bonus', ceilingLimit: 'Z tym bonusem następna faktura przekroczyłaby limit {ceiling} %', ceilingPlain: 'Rabaty na następnej fakturze nie zostawiają miejsca na ten bonus', roomNext: 'Trwający bonus kończy się wraz z następną fakturą', roomLater: 'Najwcześniej kończący się bonus ma jeszcze faktur: {n}', notActive: 'Twoja przestrzeń robocza jest teraz nieaktywna', deletion: 'Dla Twojej przestrzeni roboczej otwarty jest wniosek o usunięcie', unavailable: 'Nie można teraz sprawdzić, czy ten bonus da się odebrać; spróbuj za chwilę' } } },
    errors: { setupFailed: 'Nie udało się skonfigurować karty.', loadFailed: 'Nie udało się załadować danych rozliczeniowych.', ownerOnly: 'Rozliczeniami może zarządzać tylko właściciel przestrzeni roboczej.', planChangeFailed: 'Nie udało się zmienić planu. Proszę spróbować ponownie.', paymentStanding: 'Przed przejściem na wyższy plan należy uregulować zaległą płatność.', cardRequired: 'Przed przejściem na wyższy plan należy dodać ważną kartę.', addModuleFailed: 'Nie udało się dodać modułu. Proszę spróbować ponownie.', cancellationPending: 'Subskrypcja Pana/Pani wkrótce się zakończy. Proszę najpierw wybrać „Zachowaj subskrypcję”, a następnie dodać moduł.', removeFailed: 'Nie udało się zaplanować usunięcia. Proszę spróbować ponownie.' },
    retry: 'Spróbuj ponownie',
    common: { close: 'Zamknij' },
    card: {
      label: 'Karta', title: 'Metoda płatności',
      remove: 'Usuń kartę', removed: 'Karta została usunięta.',
      inUse: 'Ta karta została już rozliczona i można ją jedynie wymienić, a nie usunąć.',
      removeConfirmTitle: 'Usunąć kartę?', removeConfirmBody: 'Spowoduje to usunięcie zapisanej karty. Nową można dodać w dowolnym momencie.',
      removeError: 'Nie udało się usunąć karty.',
      handoff: 'Wyślij link do płatności innej osobie', handoffTitle: 'Link do płatności',
      handoffHint: '„Dodaj/wymień kartę”: dane karty wprowadza się samodzielnie. „Wyślij link do płatności innej osobie”: należy wysłać jednorazowy link osobie, która skonfiguruje kartę – np. do działu księgowości.',
      handoffBody: 'Proszę udostępnić ten jednorazowy link osobie konfigurującej kartę. Wygasa on {date}.',
      copy: 'Kopiuj', copied: 'Skopiowano', handoffCopied: 'Link do płatności skopiowany', handoffError: 'Nie udało się utworzyć linku do płatności.',
    },
    recovery: {
      title: 'Płatność oczekuje · {amount}',
      body: 'Bank musi potwierdzić tę płatność. Proszę potwierdzić ją teraz, aby zachować dostęp.',
      cta: 'Potwierdź płatność',
      paid: 'Płatność otrzymana – dostęp został przywrócony.',
      failed: 'Płatność nie została zakończona. Można spróbować ponownie w dowolnym momencie.',
      checking: 'Wciąż sprawdzamy płatność…',
      startError: 'Nie udało się teraz rozpocząć płatności. Proszę spróbować ponownie za chwilę.',
    },
    plan: {
      title: 'Plan i moduły', subtitle: 'Zarządzanie planem dla każdego aktywnego modułu.',
      currentPlan: 'Bieżący plan', current: 'Bieżący',
      perMonth: '{amount}/mies.', perUserMonth: '{amount} za użytkownika/mies.', perApprenticeMonth: '{amount} za praktykanta/mies.', volumeHint: 'Rabat ilościowy: większe obszary robocze płacą automatycznie mniej za stanowisko.',
      perUpgradeMonth: '{amount} za rozszerzenie/mies.',
      upgrade: 'Podwyższ plan', downgrade: 'Obniż plan', apply: 'Zmień plan',
      downgradeNote: 'Obniżenie planu wchodzi w życie na początku następnego cyklu rozliczeniowego.',
      fixCardCta: 'Popraw metodę płatności',
      enterprise: { title: 'Potrzebują Państwo więcej?', body: 'Warunki dla większych zespołów oraz indywidualne ustalenia uzgadniamy z naszym zespołem.', cta: 'Skontaktuj się z działem sprzedaży' },
      provisioning: 'Trwa konfiguracja — może to potrwać minutę.',
      provisioningFailed: 'Konfiguracja nie powiodła się — zajmujemy się tym.',
      removeModule: 'Usuń moduł', removeConfirmTitle: 'Usunąć moduł?',
      removeConfirmBody: 'Moduł {module} zostanie usunięty na koniec bieżącego okresu rozliczeniowego. Do tego czasu można cofnąć tę zmianę.',
      removeScheduled: 'Zaplanowano usunięcie modułu {module}.',
      addTitle: 'Dodaj moduł', addSubtitle: 'Przestrzeń roboczą można rozszerzyć o kolejny moduł.',
      addCta: 'Dodaj moduł', addConfirmTitle: 'Dodać moduł?',
      moduleLabel: 'Moduł', planLabel: 'Plan',
      // The booking table's column heads and its sum row's start date (#409 F12).
      booking: { price: 'Cena', seats: 'Stanowiska', monthly: 'Miesięcznie', from: 'od {date}' },
      apprenticeSeats: 'Zarezerwowane stanowiska praktykantów',
      apprenticeSeatsHint: 'Co najmniej 1 stanowisko praktykanta dla modułu kształcenia.',
      apprenticeSeatsCeiling: 'Powyżej {max} stanowisk praktykantów nie ma taryfy samoobsługowej – ustalamy ją bezpośrednio z Państwem:',
      apprenticeSeatAdjustment: 'Przed usunięciem tego modułu mieli Państwo zarezerwowane {booked} stanowisk praktykantów, dlatego moduł został ponownie dodany z {booked} stanowiskami zamiast żądanych {requested}. Mogą je Państwo zmniejszyć od następnego obciążenia.',
      added: 'Dodano moduł {module}.',
      addedPaymentRetrying: 'Moduł {module} został dodany i jest gotowy do użycia. Nie udało się teraz pobrać płatności — spróbujemy automatycznie ponownie.',
      alreadyActive: 'Moduł {module} jest już w planie.',
    },
    seats: {
      title: 'Zarezerwowane stanowiska',
      userSeats: 'Stanowiska użytkowników', apprenticeSeats: 'Stanowiska praktykantów',
      stepUp: 'Więcej stanowisk', stepDown: 'Mniej stanowisk',
      bookMore: 'Zarezerwuj więcej stanowisk',
      confirmTitle: 'Zarezerwować więcej stanowisk?', confirmCta: 'Zarezerwuj stanowiska',
      chargeNote: 'Rezerwacja dodatkowych stanowisk spowoduje naliczenie kwoty proporcjonalnej do pozostałej części bieżącego cyklu rozliczeniowego.',
      confirmTitleDecrease: 'Zmniejszyć liczbę zarezerwowanych stanowisk?',
      reduceCta: 'Zmniejsz liczbę stanowisk',
      decreaseNote: 'Dziś nic nie zostanie naliczone ani zwrócone — rezerwacja zmieni się {date}.',
      decreaseNoteImmediate: 'Nic nie zostanie naliczone ani zwrócone — rezerwacja zmieni się natychmiast.',
      decreaseScheduled: 'Zmniejszenie liczby stanowisk zaplanowano na {date}.',
      mixedDirection: 'Prosimy rezerwować dodatkowe stanowiska i zmniejszać ich liczbę w osobnych krokach: dodane stanowiska są naliczane dziś, a zmniejszenie obowiązuje od następnego okresu rozliczeniowego.',
      belowUsage: 'Ta przestrzeń robocza używa większej liczby stanowisk. Prosimy zachować co najmniej {count}.',
      usageCheckUnavailable: 'Nie udało się teraz sprawdzić, ile stanowisk jest zajętych. Prosimy spróbować ponownie za chwilę.',
      leaveFreelancer: 'To oznacza wyjście z trybu freelancera.',
      returnFreelancer: 'To oznacza powrót do trybu freelancera — jedna osoba, jedno stanowisko.',
      booked: 'Zarezerwowane stanowiska zostały zaktualizowane.',
      bookedPaymentRetrying: 'Stanowiska zostały zarezerwowane i są gotowe do użycia. Nie udało się teraz pobrać płatności — spróbujemy automatycznie ponownie.',
      bookFailed: 'Nie udało się zarezerwować stanowisk. Proszę spróbować ponownie.',
    },
    seatPanel: {
      inUse: '{used} z {booked} w użyciu',
      bookedOnly: 'zarezerwowano {booked}',
      useUnknown: 'Nie udało się teraz odczytać, ile stanowisk jest w użyciu.',
      manage: 'Zarządzanie stanowiskami',
      pendingUsers: 'Liczba stanowisk użytkowników zmieni się {date} na {target} — do tego czasu zarezerwowano {current}.',
      pendingApprentices: 'Liczba stanowisk praktykantów zmieni się {date} na {target} — do tego czasu zarezerwowano {current}.',
      reflooredUsers: 'Obniżenie do {requested} stanowisk użytkowników zostało zastosowane na poziomie {booked}: w tym obszarze roboczym jest {used} osób, a każda zajmuje jedno stanowisko. Prosimy usunąć osoby, które nie są już potrzebne, a następnie ponowić obniżenie.',
      reflooredApprentices: 'Obniżenie do {requested} stanowisk praktykantów zostało zastosowane na poziomie {booked}: trwa {used} praktyk. Prosimy zakończyć te, które nie są już potrzebne, a następnie ponowić obniżenie.',
      // A demo workspace's apprentices hold no booked seat (issue 364 F4/F30):
      // the creation gate ignores the booking while the demo runs, so the count
      // excludes them and this row says so.
      demoNotCounted: 'Uczniowie z danych demonstracyjnych nie zajmują zarezerwowanych stanowisk — nie są tu liczeni i znikną po przeniesieniu demo do właściwej konfiguracji.',
    },
    // The seat price calculator (issue 364 F30). Every FIGURE it shows arrives
    // from the API; these are only the words around them.
    calc: {
      title: 'Ile kosztuje ta rezerwacja',
      includes: 'Co obejmuje rezerwacja i ile kosztuje miesięcznie.',
      userSeatsCount: '{count} stanowisk użytkownika',
      apprenticeSeatsCount: '{count} stanowisk ucznia',
      aiQuotaUpgradesCount: '{count} × rozszerzenie',
      subtotal: 'Suma częściowa',
      volumeDiscount: 'Rabat ilościowy',
      monthlyTotal: 'Razem miesięcznie',
      currentTotal: 'Obecnie płacą Państwo {amount} miesięcznie.',
      newMonthlyTotal: 'Od następnej faktury: {amount} miesięcznie.',
      netNote: 'Ceny nie zawierają VAT. Rezerwacja dodatkowych stanowisk oznacza również jednorazową kwotę proporcjonalną za pozostałą część bieżącego okresu rozliczeniowego.',
    },
    // The AI quota card (#665). Every figure it shows arrives from the API.
    aiQuota: {
      title: 'Przydział AI',
      usageLink: 'Na co jest wykorzystywany',
      ownKey: 'Ta przestrzeń robocza korzysta z lumi z własnym kluczem dostawcy AI, dlatego nie ma przydziału AI — dostawca rozlicza każdy token bezpośrednio.',
      suspended: 'Przydział AI jest wstrzymany, dopóki przestrzeń robocza jest zawieszona.',
      unlimited: 'Dla tej przestrzeni roboczej nie obowiązuje przydział AI — lumi zniosło limit.',
      intro: 'lumi, funkcje AI wszystkich modułów i zewnętrzni agenci AI podłączani przez członków korzystają ze wspólnego przydziału: do {limit} tokenów na cykl rozliczeniowy. Przydział odnawia się na początku każdego cyklu rozliczeniowego; niewykorzystane tokeny nie przechodzą na kolejny cykl.',
      included: 'W cenie',
      includedDerived: 'w ramach zarezerwowanych stanowisk',
      includedOverride: 'ustalony przez lumi dla tej przestrzeni roboczej',
      tokensValue: '{tokens} tokenów na cykl',
      upgrades: 'Rozszerzenia przydziału',
      upgradesNone: 'Brak',
      upgradesValue: 'Zarezerwowane: {count} · +{tokens} tokenów',
      used: 'Wykorzystano w tym cyklu',
      usedValue: '{used} z {limit} tokenów',
      usedNoLimit: '{used} tokenów do tej pory',
      resetsOn: 'Odnowienie: {date}',
      stepPrice: 'Jedno rozszerzenie dodaje {tokens} tokenów na cykl rozliczeniowy za {amount} miesięcznie.',
      stepUp: 'O jedno rozszerzenie więcej',
      stepDown: 'O jedno rozszerzenie mniej',
      removeCta: 'Usuń z następną datą rozliczenia',
      confirmTitle: 'Dodać rozszerzenie przydziału AI?',
      confirmTitleDecrease: 'Usunąć rozszerzenie przydziału AI?',
      confirmCta: 'Zarezerwuj rozszerzenie',
      trialWarning: 'To kosztuje prawdziwe pieniądze, także w okresie próbnym: karta zostanie dziś obciążona proporcjonalnie za resztę okresu próbnego, najwyżej za jeden miesiąc, a potem co miesiąc.',
      cardRequired: 'Rozszerzenie przydziału AI wymaga aktywnej karty, także w okresie próbnym. Proszę najpierw dodać kartę — po jej potwierdzeniu można zarezerwować rozszerzenie.',
      promoExcluded: 'Kod nie obejmuje przydziału AI: rozszerzenie nigdy nie podlega rabatowi i jest rozliczane po cenie katalogowej.',
      chargeNote: 'Rozszerzenie spowoduje naliczenie kwoty proporcjonalnej do pozostałej części bieżącego cyklu rozliczeniowego i działa od razu.',
      decreaseNote: 'Dziś nic nie zostanie naliczone ani zwrócone. Rozszerzenie obowiązuje do {date}; potem obowiązuje mniejszy przydział.',
      decreaseNoteGeneric: 'Dziś nic nie zostanie naliczone ani zwrócone — rozszerzenie kończy się z następną datą rozliczenia.',
      newQuota: 'Następnie: do {limit} tokenów na cykl rozliczeniowy.',
      changeDelta: '{tokens} tokenów · {amount} / mies.',
      addCtaPrice: 'Dodaj rozszerzenie przydziału · {amount} / mies.',
      booked: 'Rozszerzenia przydziału AI zostały zaktualizowane.',
      bookedPaymentRetrying: 'Rozszerzenie przydziału AI zostało zarezerwowane i działa od razu. Nie udało się teraz pobrać płatności — spróbujemy automatycznie ponownie.',
      decreaseScheduled: 'Rozszerzenie przydziału AI kończy się {date}.',
      pending: 'Liczba rozszerzeń przydziału zmieni się {date} na {target} — do tego czasu zarezerwowano {current}.',
      bookFailed: 'Nie udało się zmienić rozszerzeń przydziału AI. Proszę spróbować ponownie.',
    },
    scheduled: {
      resizeTo: 'Przełącz na {plan}', remove: 'Usuń moduł',
      effective: 'obowiązuje od {date}', revert: 'Cofnij', reverted: 'Zaplanowana zmiana została cofnięta.',
    },
    proration: {
      title: 'Potwierdzenie zmiany planu', stepFrom: 'Bieżący', stepTo: 'Nowy',
      chargeNote: 'Podwyższenie planu teraz spowoduje naliczenie kwoty proporcjonalnej do pozostałej części bieżącego cyklu rozliczeniowego.',
      freeNote: 'Ta zmiana obowiązuje natychmiast, bez dodatkowych kosztów w okresie próbnym.',
      confirm: 'Potwierdź i podwyższ plan', cancel: 'Anuluj',
      charged: 'Naliczono {amount}.', appliedImmediate: 'Nowy plan jest aktywny.',
      appliedScheduled: 'Zaplanowano — obowiązuje od {date}.',
      calculating: 'Trwa ustalanie dokładnej kwoty…',
      chargeExact: 'Dziś zostanie pobrana kwota {amount}.',
      noChargeToday: 'Dziś nic nie zostanie pobrane.',
    },
    profile: {
      title: 'Dane rozliczeniowe', subtitle: 'Proszę uzupełnić dane do faktury, aby aktywować płatność.',
      legalName: 'Pełna nazwa firmy', addressLine1: 'Adres', addressLine2: 'Adres (wiersz 2)',
      postalCode: 'Kod pocztowy', city: 'Miasto', vatId: 'NIP (VAT-ID)',
      vatOptional: 'Opcjonalnie — wymagane przy odwrotnym obciążeniu w obrębie UE.',
      save: 'Zapisz dane', edit: 'Edytuj dane rozliczeniowe', error: 'Nie udało się zapisać danych rozliczeniowych.',
      saved: 'Dane rozliczeniowe zapisane.',
      vatPending: 'Nie udało się teraz zweryfikować numeru VAT-ID. Proszę spróbować ponownie za chwilę.',
      vatInvalid: 'Nie udało się zweryfikować tego numeru VAT-ID. Proszę go sprawdzić.',
      vatRequired: 'Dla Państwa kraju wymagany jest ważny numer VAT-ID przed dodaniem karty.',
      completeFirst: 'Przed dodaniem karty należy uzupełnić dane rozliczeniowe.',
    },
    cancel: {
      title: 'Anulowanie subskrypcji',
      body: 'Anulowanie subskrypcji. Przestrzeń robocza pozostaje aktywna do końca bieżącego cyklu rozliczeniowego.',
      reason: 'Powód (opcjonalnie)', confirm: 'Anuluj subskrypcję', confirmTitle: 'Anulować subskrypcję?',
      confirmBody: 'Subskrypcja zakończy się {date}. Do tego czasu wszystko działa bez zmian.',
      note: 'Do tego czasu wszystko działa, także eksport całej przestrzeni roboczej. Potem przestrzeń robocza zostaje zamknięta; jej dane są przez jakiś czas zachowane, a właściciele dostają informację, zanim cokolwiek zostanie usunięte. Jeśli ma zniknąć wcześniej, użyj opcji „{deletion}”.',
      pending: 'Anulowanie zaplanowane — subskrypcja kończy się {date}.', pendingNoDate: 'Anulowanie zaplanowane.',
      revert: 'Zachowaj subskrypcję', error: 'Nie udało się anulować subskrypcji.',
      done: 'Anulowanie zaplanowane. Przestrzeń robocza pozostaje aktywna do końca bieżącego okresu rozliczeniowego.', revertDone: 'Anulowanie cofnięte. Subskrypcja jest kontynuowana normalnie.',
    },
    deletion: {
      title: 'Usunięcie przestrzeni roboczej (RODO)',
      body: 'Żądanie trwałego usunięcia tej przestrzeni roboczej wraz ze wszystkimi jej danymi. Po krótkim okresie karencji operacji tej nie można cofnąć.',
      request: 'Zażądaj usunięcia', reason: 'Powód (opcjonalnie)',
      confirmTitle: 'Zażądać usunięcia przestrzeni roboczej?',
      confirmBody: 'Wszystkie dane zostaną trwale usunięte po krótkim okresie karencji. Operacji tej nie można cofnąć.',
      pending: 'Zażądano usunięcia — dane zostaną usunięte po {date}.', pendingNoDate: 'Zażądano usunięcia — oczekuje na rozpatrzenie.',
      cancel: 'Anuluj żądanie usunięcia', error: 'Nie udało się złożyć żądania usunięcia.',
      requested: 'Zażądano usunięcia. Usuniemy przestrzeń roboczą po okresie karencji.', canceled: 'Żądanie usunięcia wycofane. Przestrzeń robocza zostaje zachowana.',
      confirmType: 'Aby potwierdzić, prosimy wpisać nazwę przestrzeni roboczej ({name})',
      cancelConfirmTitle: 'Wycofać żądanie usunięcia?',
      cancelConfirmBody: 'Przestrzeń robocza i wszystkie dane zostają zachowane. Może Pan/Pani ponownie zażądać usunięcia w dowolnym momencie.',
    },
    moduleNames: { core: 'lumi-HR Core', ats: 'Rekrutacja', time_tracking: 'Czas', apprenticeship: 'Ausbildung' },
    planNames: {
      ats: { seat: 'Za użytkownika', enterprise: 'Enterprise', unknown: '—' },
      time: { seat: 'Za użytkownika', enterprise: 'Enterprise', unknown: '—' },
      apprenticeship: { seat: 'Za praktykanta', enterprise: 'Enterprise', unknown: '—' },
      // People Pro is retired (#596), but issued invoices keep their `peoplePro.seat`
      // line (GoBD) and render through this entry — keep it while any exists.
      peoplePro: { seat: 'Za użytkownika', enterprise: 'Enterprise', unknown: '—' },
      // The AI quota upgrade line (#665): its displayKey is `ai_quota.upgrade`.
      ai_quota: { upgrade: 'Rozszerzenie przydziału AI (+1 000 000 tokenów na cykl rozliczeniowy)' },
    },
    onboard: {
      // Three honest branches, never a CTA without a control (#364 F18/F23).
      // `exempt` is checked FIRST, ahead of demo: an operator-granted exemption
      // is a deliberate state, not a broken signup and not a demo limitation.
      exempt: { title: 'Ten obszar roboczy jest zwolniony z opłat', body: 'lumi ustalił, że ten obszar roboczy nie jest obciążany opłatami, dlatego nie ma konta rozliczeniowego i nic nie jest ani nie będzie naliczane. Zmienić to może wyłącznie lumi — tutaj nie ma nic do skonfigurowania.' },
      demo: { title: 'Rozliczenia nie są dostępne w trybie demo', body: 'Ta przestrzeń robocza działa na danych demonstracyjnych, więc nie ma jeszcze czego rozliczać. Rozliczenia będzie można skonfigurować po przekształceniu demo w prawdziwą konfigurację — rozpoczyna to baner demo u góry strony.' },
      // The stranded signup's real recovery is the buyer redoing the SAME checkout,
      // which resumes THIS workspace (issue 364 F25) — support is the fallback, and
      // for anyone who is not the buyer it is the only route they have.
      stranded: { title: 'Konfiguracja rozliczeń nie została ukończona', buyerBody: 'Rejestracja nie została ukończona, dlatego ta przestrzeń robocza nie ma jeszcze konta rozliczeniowego i nic nie jest naliczane. Może Pan/Pani dokończyć to samodzielnie: proszę wrócić do zamówienia i ponownie wykupić te same moduły — ta przestrzeń robocza zostanie wznowiona, zamiast powstać druga. Jeśli nadal się nie uda, prosimy o kontakt, dokończymy to wspólnie.', otherBody: 'Rejestracja nie została ukończona, dlatego ta przestrzeń robocza nie ma jeszcze konta rozliczeniowego i nic nie jest naliczane. Dokończyć może to wyłącznie osoba, która zarejestrowała tę przestrzeń roboczą — wracając do zamówienia i wykupując ponownie te same moduły. Prosimy poprosić ją o to lub skontaktować się z nami, dokończymy to wspólnie.', checkoutCta: 'Wróć do zamówienia', cta: 'Skontaktuj się z pomocą techniczną' },
    },
    // The four documents this workspace's billing relationship is
    // governed by, on the landing host (#576 M2) — not a "version you
    // accepted" claim, just the current published text.
    contractDocuments: {
      title: 'Dokumenty umowne',
      terms: 'Regulamin',
      avv: 'Umowa powierzenia przetwarzania danych (AVV)',
      tom: 'Środki techniczne i organizacyjne (TOM)',
      subprocessors: 'Podprocesorzy',
    },
  },
  login: {
    ssoApple: 'Zaloguj się przez Apple',
    passkeySignIn: 'Zaloguj się kluczem dostępu',
    passkeySigningIn: 'Logowanie…',
    passkeyFailed: 'Logowanie kluczem dostępu nie powiodło się. Spróbuj ponownie lub użyj hasła.',
    title: 'lumi-HR Suite',
    subtitle: 'Proszę się zalogować, aby kontynuować',
    email: 'E-mail',
    emailPlaceholder: "imie{'@'}firma.pl",
    password: 'Hasło',
    passwordPlaceholder: 'Państwa hasło',
    signIn: 'Zaloguj się',
    signingIn: 'Logowanie…',
    failed: 'Logowanie nie powiodło się',
    forgotPassword: 'Nie pamiętają Państwo hasła?',
    lostPhone: 'Zgubiony telefon?',
    orContinueWith: 'lub kontynuuj przez',
    ssoGoogle: 'Zaloguj się przez Google',
    ssoMicrosoft: 'Zaloguj się przez Microsoft',
    ssoEnterprise: 'Zaloguj się przez firmowe SSO',
    ssoOnly: 'Logowanie do tej przestrzeni roboczej odbywa się przez firmowe SSO Państwa organizacji.',
    adminLogin: 'Logowanie administratora',
    ssoError: 'Logowanie SSO nie powiodło się. Proszę spróbować ponownie.',
    ssoSeatLimit: 'W tym obszarze roboczym nie ma wolnego stanowiska użytkownika, więc nie mogliśmy utworzyć konta. O zarezerwowanie kolejnego stanowiska należy poprosić właściciela obszaru roboczego lub Billing Managera — ponowna próba logowania nic nie da, dopóki to nie nastąpi.',
    ssoLinkRequired: 'Nie udało się automatycznie połączyć tego logowania firmowego z Twoim kontem lumi. Zaloguj się w inny sposób, a potem połącz logowanie firmowe w sekcji Konto i bezpieczeństwo.',
    ssoEmployeeNoticeIncomplete: 'Ten obszar roboczy nie jest jeszcze gotowy: informacje dla pracowników wciąż mają niewypełnione pola. Proszę poprosić właściciela obszaru roboczego, administrację suite lub inspektora ochrony danych o uzupełnienie ich w sekcji Informacje prawne — ponowna próba logowania nic nie da, dopóki to nie nastąpi.',
    ssoLegalReadinessUnavailable: 'Nie mogliśmy teraz sprawdzić, czy ten obszar roboczy jest gotowy. Proszę spróbować ponownie za kilka minut.',
    ssoOperatorPasswordOnly: 'Konta administratorów systemu logują się hasłem i aplikacją uwierzytelniającą, a nie przez tego dostawcę.',
    mfaTitle: 'Wprowadź kod uwierzytelniający',
    mfaIntro: 'To jest konto administratora systemu. Wprowadź 6-cyfrowy kod z aplikacji uwierzytelniającej lub jeden z kodów odzyskiwania.',
    mfaCode: 'Kod',
    mfaSubmit: 'Zaloguj się',
    mfaBack: 'Wstecz',
    mfaInvalid: 'Ten kod jest nieprawidłowy.',
    mfaReused: 'Ten kod został już użyty. Poczekaj na następny w aplikacji.',
    mfaExpired: 'To logowanie wygasło. Zaloguj się ponownie hasłem.',
    mfaEnrolOnConsole: 'To konto administratora systemu nie ma jeszcze aplikacji uwierzytelniającej. Najpierw zaloguj się do konsoli lumi, aby ją skonfigurować.',
    tenantLogoAlt: 'Logo obszaru roboczego',
    poweredBy: 'Obsługiwane przez',
  },
  loginBranding: {
    nav: 'Strona logowania',
    title: 'Strona logowania',
    intro: 'Strona logowania tego obszaru roboczego może mieć własne logo, kolor i obraz tła. Widzą je wszyscy, którzy się tutaj logują.',
    retry: 'Spróbuj ponownie',
    loadFailed: 'Nie udało się wczytać bieżących ustawień.',
    form: {
      title: 'Wygląd',
      logo: 'Logo',
      logoHint: 'PNG, JPEG, WebP lub GIF, do 2 MB. Zostaw puste, aby zachować logo lumi.',
      image: 'Obraz tła',
      imageHint: 'Wyświetlany za kartą logowania. PNG, JPEG, WebP lub GIF, do 8 MB.',
      upload: 'Prześlij',
      replace: 'Zamień',
      remove: 'Usuń',
      empty: 'Brak obrazu',
      uploaded: 'Obraz przesłany.',
      removed: 'Obraz usunięty.',
      tooLarge: 'Ten plik jest za duży.',
      wrongType: 'Akceptowane są tylko obrazy PNG, JPEG, WebP i GIF.',
      uploadFailed: 'Nie udało się przesłać obrazu. Spróbuj ponownie.',
      removeFailed: 'Nie udało się usunąć obrazu. Spróbuj ponownie.',
      removeConfirm: 'Obraz zostanie usunięty ze strony logowania i skasowany. Tej operacji nie można cofnąć.',
      primaryColor: 'Kolor podstawowy',
      primaryColorHint: 'Barwi nazwę obszaru roboczego, linki i przycisk logowania.',
      boxColor: 'Kolor ramki',
      boxColorHint: 'Ramka, w której znajduje się formularz logowania.',
      boxColorInvalid: 'Proszę wpisać kolor szesnastkowy, np. #ffffff.',
      boxOpacity: 'Krycie ramki',
      boxTone: 'Tekst i pola',
      boxToneHint: 'Proponowane na podstawie koloru ramki. Proszę przełączyć, jeśli tekst jest słabo czytelny.',
      toneLight: 'Jasna ramka, ciemny tekst',
      toneDark: 'Ciemna ramka, jasny tekst',
      nothingToSave: 'Nie ma czego zapisać: od ostatniego zapisu nic się nie zmieniło.',
      fixFirst: 'Proszę najpierw poprawić zaznaczone pole.',
      colorPlaceholder: 'np. 1a2b3c',
      colorInvalid: 'Proszę podać kolor szesnastkowy, np. 1a2b3c.',
      clear: 'Wyczyść',
      save: 'Zapisz',
      saved: 'Strona logowania została zaktualizowana.',
      discard: 'Odrzuć',
      liveNote: 'Zapisane zmiany będą widoczne przy kolejnym otwarciu strony logowania.',
    },
    preview: {
      title: 'Podgląd',
      hint: 'Tak wygląda strona logowania z powyższymi wartościami.',
      logoAlt: 'Podgląd logo',
    },
  },
  authFlow: {
    forgot: {
      title: 'Resetowanie hasła',
      subtitle: 'Wyślemy Państwu link do jego zresetowania.',
      email: 'E-mail',
      submit: 'Wyślij link',
      done: 'Jeśli istnieje konto z tym adresem e-mail, wysłaliśmy link do resetu.',
      backToLogin: 'Powrót do logowania',
    },
    reset: {
      title: 'Ustawienie nowego hasła',
      password: 'Nowe hasło',
      confirm: 'Potwierdź hasło',
      submit: 'Zapisz hasło',
      success: 'Hasło zostało zmienione. Mogą się Państwo teraz zalogować.',
      goToLogin: 'Przejdź do logowania',
      invalid: 'Ten link jest nieprawidłowy lub wygasł.',
      mismatch: 'Hasła nie są zgodne.',
      tooShort: 'Hasło musi mieć co najmniej 8 znaków.',
      missingToken: 'Nie znaleziono prawidłowego tokenu.',
    },
    invite: {
      title: 'Konfiguracja konta',
      subtitle: 'Proszę wybrać hasło, aby aktywować konto.',
      forTenant: 'Zaproszenie do {tenant}',
      password: 'Hasło',
      confirm: 'Potwierdź hasło',
      submit: 'Aktywuj konto',
      submitting: 'Aktywowanie…',
      invalid: 'To zaproszenie jest nieprawidłowe lub wygasło.',
      mismatch: 'Hasła nie są zgodne.',
      tooShort: 'Hasło musi mieć co najmniej 8 znaków.',
      passkey: {
        title: 'Konfiguracja logowania',
        intro: 'Logowanie do lumi odbywa się kluczem dostępu: odciskiem palca, twarzą lub PIN-em urządzenia. Bez hasła do zapamiętania.',
        sentTo: 'Wysłano na numer {phone}',
        create: 'Utwórz klucz dostępu',
        creating: 'Oczekiwanie na urządzenie…',
        instead: 'Użyj zamiast tego klucza dostępu',
        or: 'lub',
        unsupported: 'Ta przeglądarka nie może utworzyć klucza dostępu. Proszę otworzyć link na telefonie lub w aktualnej przeglądarce.',
        unavailable: 'Klucze dostępu nie są tu dostępne dla tej przestrzeni roboczej. Proszę skontaktować się z administratorem.',
        expired: 'Trwało to zbyt długo. Proszę spróbować ponownie.',
        alreadyRegistered: 'To urządzenie ma już klucz dostępu do lumi.',
        failed: 'Nie udało się utworzyć klucza dostępu. Proszę spróbować ponownie.',
      },
    },
    recover: {
      title: 'Zgubiony telefon?',
      subtitle: 'Proszę podać numer telefonu komórkowego, a wyślemy SMS-em link do skonfigurowania nowego klucza dostępu.',
      phone: 'Numer telefonu komórkowego',
      phoneHint: 'Z numerem kierunkowym kraju, np. +48 512 345 678',
      submit: 'Wyślij link',
      done: 'Jeśli ten numer należy do konta w tym miejscu, wysłaliśmy na niego link. Jest ważny przez 15 minut.',
      enrolTitle: 'Konfiguracja nowego klucza dostępu',
      enrolSubtitle: 'Proszę utworzyć klucz dostępu na tym urządzeniu. Wszystkie inne sesje konta zostaną wylogowane.',
      create: 'Utwórz nowy klucz dostępu',
      invalid: 'Ten link jest nieprawidłowy lub wygasł. Proszę poprosić o nowy.',
    },
    verify: {
      verifying: 'Potwierdzanie adresu e-mail…',
      success: 'Adres e-mail został potwierdzony.',
      invalid: 'Ten link potwierdzający jest nieprawidłowy lub wygasł.',
      backToLogin: 'Przejdź do logowania',
    },
  },
  account: {
    // AI agent connections on the account page (ADR 0103 rule 13).
    agentConnections: {
      title: 'Połączenia z agentami AI',
      hint: 'Klienci AI, którym pozwalasz działać w Twoim imieniu w przestrzeni roboczej. Każdy działa dokładnie z Twoimi uprawnieniami, a to, co odczyta, trafia do dostawcy danego klienta.',
      none: 'Żaden agent AI nie jest połączony.',
      inWorkspace: 'w przestrzeni roboczej {workspace}',
      scope: {
        read: 'odczyt',
        act: 'działanie z potwierdzeniem',
        ask: 'pytania do lumi',
      },
      lastUsed: 'Ostatnio użyto {when}',
      connectedOn: 'Połączono {when}, jeszcze nieużywane',
      standing: {
        label: 'Wykonuj działania na moich własnych rekordach bez pytania',
        hint: 'Nigdy nie obejmuje rekordów innych osób ani niekorzystnych decyzji.',
        notOffered: 'Dla tego połączenia nie można udzielić stałej zgody.',
        failed: 'Nie udało się zmienić ustawienia. Spróbuj ponownie.',
      },
      rolePins: {
        notHeld: 'Nie masz już tej roli w tym module.',
        failed: 'Nie udało się zmienić roli. Spróbuj ponownie.',
      },
      disconnect: 'Rozłącz',
      disconnectConfirm: '„{client}” natychmiast traci dostęp do {workspace}. Aby znów z niego korzystać, połącz go ponownie z poziomu klienta.',
      disconnected: 'Rozłączono {client}.',
      disconnectFailed: 'Nie udało się zakończyć połączenia. Spróbuj ponownie.',
    },
    passkeys: {
      removeConfirm: 'Ten klucz dostępu zostanie usunięty. Urządzenie, które go używa, nie będzie mogło się nim już logować.',
      title: 'Klucze dostępu',
      hint: 'Klucz dostępu loguje Cię za pomocą urządzenia — odcisku palca, twarzy lub PIN-u. Nic do zapamiętania i nic do wyłudzenia.',
      none: 'Brak kluczy dostępu.',
      add: 'Dodaj klucz dostępu',
      remove: 'Usuń',
      unnamed: 'Klucz dostępu',
      lastUsed: 'Ostatnio użyty {when}',
      neverUsed: 'Nigdy nieużywany',
      added: 'Klucz dostępu dodany.',
      removed: 'Klucz dostępu usunięty.',
      addFailed: 'Nie udało się dodać klucza dostępu. Spróbuj ponownie.',
      removeFailed: 'Nie udało się usunąć klucza dostępu. Spróbuj ponownie.',
      alreadyRegistered: 'To urządzenie ma już klucz dostępu do lumi.',
      lastMethod: 'Nie możesz usunąć jedynej metody logowania. Najpierw ustaw hasło lub dodaj kolejny klucz dostępu.',
      lostDevice: 'Zgubiony telefon lub inne urządzenie? Usuń jego klucz dostępu z tej listy — dopiero to odcina mu dostęp do konta.',
    },
    currentPassword: 'Bieżące hasło',
    phone: {
      title: 'Numer logowania',
      hint: 'Twoje konto loguje się kluczem dostępu. Na ten numer trafiają linki z zaproszeniem i do odzyskania dostępu.',
    },
    email: {
      title: 'Adres logowania',
      hint: 'Adres, którym się logujesz. Jego zmiana zmienia też adres, który pokazują Twoje przestrzenie robocze.',
      newLabel: 'Nowy adres',
      submit: 'Poproś o zmianę',
      pending: 'Czekamy na potwierdzenie na {email}. Kliknij link, który tam wysłaliśmy.',
      cancel: 'Anuluj tę zmianę',
      cancelled: 'Oczekująca zmiana adresu została anulowana.',
      sent: 'Sprawdź nową skrzynkę. Nic się nie zmieni, dopóki nie klikniesz linku.',
      refused: 'Tego adresu nie można użyć dla tego konta. Jedna z Twoich przestrzeni roboczych dopuszcza tylko adresy we własnych domenach.',
      failed: 'Nie udało się zgłosić zmiany. Spróbuj ponownie.',
      ssoManaged: 'Twój adres logowania jest zarządzany przez dostawcę tożsamości.',
    },
    password: {
      title: 'Hasło',
      hint: 'Zmiana hasła wylogowuje Cię na wszystkich innych urządzeniach.',
      newLabel: 'Nowe hasło',
      confirmLabel: 'Powtórz nowe hasło',
      submit: 'Zmień hasło',
      changed: 'Hasło zostało zmienione. Pozostałe urządzenia zostały wylogowane.',
      wrongCurrent: 'Bieżące hasło jest nieprawidłowe.',
      failed: 'Nie udało się zmienić hasła. Spróbuj ponownie.',
      tooShort: 'Nowe hasło musi mieć co najmniej 8 znaków.',
      mismatch: 'Nowe hasła nie są takie same.',
      ssoOnly: 'To konto loguje się przez dostawcę tożsamości, więc nie ma hasła. Możesz ustawić je awaryjnie — wyślemy Ci link.',
      sendLink: 'Wyślij mi link do ustawienia hasła',
      linkSent: 'Jeśli dla tego konta można ustawić hasło, link jest już w drodze.',
      linkFailed: 'Nie udało się wysłać żądania. Spróbuj ponownie.',
    },
    confirmEmail: {
      title: 'Potwierdź nowy adres',
      working: 'Potwierdzanie…',
      success: 'Adres logowania został zmieniony. Zaloguj się ponownie nowym adresem.',
      goToLogin: 'Przejdź do logowania',
      backToAccount: 'Wróć do Konto i bezpieczeństwo',
      missingToken: 'Ten link jest niekompletny. Otwórz go bezpośrednio z wiadomości e-mail.',
      invalid: 'Ten link potwierdzający jest nieprawidłowy lub wygasł.',
      unavailable: 'Tej zmiany nie można już zastosować. Poproś o nią ponownie.',
    },
    // The undo half (#420): the notice mailed to the address being LEFT
    // BEHIND carries this link, and it only ever restores the status quo.
    cancelEmailChange: {
      title: 'Anuluj zmianę adresu logowania',
      working: 'Anulowanie…',
      success: 'Zmiana została anulowana. Nadal logujesz się dotychczasowym adresem.',
      goToLogin: 'Przejdź do logowania',
      missingToken: 'Ten link jest niekompletny. Otwórz go bezpośrednio z wiadomości e-mail.',
      invalid: 'Ten link jest nieprawidłowy lub wygasł — nie ma już zmiany do anulowania.',
    },
    title: 'Konto i bezpieczeństwo',
    identities: 'Powiązane metody logowania',
    noIdentities: 'Brak powiązanych zewnętrznych metod logowania.',
    unlink: 'Usuń',
    // #882: removing a linked sign-in method asks first, as removing a passkey does.
    unlinkConfirm: 'Ta metoda logowania zostanie usunięta. Nie będą się Państwo mogli już nią logować do swojego konta.',
    linkGoogle: 'Powiąż Google',
    linkMicrosoft: 'Powiąż Microsoft',
    linkApple: 'Powiąż Apple',
    lastMethod: 'Nie mogą Państwo usunąć jedynej metody logowania. Proszę najpierw ustawić hasło.',
    linked: 'Metoda logowania powiązana.',
    unlinked: 'Metoda logowania usunięta.',
    linkFailed: 'Powiązanie nie powiodło się.',
  },
  workspace: {
    title: 'Przestrzeń robocza',
    subtitle: 'Proszę wybrać tenant i moduł',
    brandName: 'lumi-HR Workspace',
    themeDark: 'Przełącz na tryb ciemny',
    themeLight: 'Przełącz na tryb jasny',
    welcomeTitle: 'Witamy w przestrzeni roboczej',
    welcomeSubtitle: 'Proszę wybrać tenant i moduł aplikacji, aby rozpocząć.',
    availableModules: 'Dostępne moduły',
    comingSoonSection: 'Wkrótce w lumi-HR',
    adminMode: 'Tryb administratora',
    aiUsage: {
      title: 'Wykorzystanie AI',
      pageIntro: 'Czy lumi jest dostępne w tym obszarze roboczym i ile AI zużyła w tym miesiącu.',
      loading: 'Ładowanie zużycia…',
      remaining: 'Pozostało {n}',
      periodLabel: 'Cykl rozliczeniowy',
      historyTitle: 'Cykle rozliczeniowe',
      usedThisPeriod: 'Wykorzystano w tym cyklu rozliczeniowym',
      split: 'W cenie: {included} · z rozszerzeń przydziału: +{upgrades}',
      resetsOn: 'Odnowienie: {date}',
      periodFrom: 'Cykl rozliczeniowy od {date}',
      nearLimit: 'Przydział AI w tym cyklu rozliczeniowym jest prawie wykorzystany. Rozszerzenie przydziału w sekcji Rozliczenia zwiększa go od razu.',
      unlimited: 'Dla tej przestrzeni roboczej nie obowiązuje przydział AI.',
      ownKey: 'Ta przestrzeń robocza korzysta z lumi z własnym kluczem dostawcy AI, dlatego nie ma przydziału AI.',
      noUsageYet: 'W tym cyklu rozliczeniowym nie wykorzystano jeszcze AI.',
      upgradeLink: 'Dodaj rozszerzenie przydziału w sekcji Rozliczenia',
      modules: {
        ats: 'Rekrutacja',
        time: 'Czas',
        time_tracking: 'Czas',
        apprentice: 'Ausbildung',
        apprenticeship: 'Ausbildung',
        assistant: 'Asystent lumi',
        mcp: 'Agenci zewnętrzni',
      },
    },
    active: 'Aktywny',
    systemAdmin: 'Administrator systemu',
    user: 'Użytkownik',
    admin: 'Administracja',
    comingSoon: 'Wkrótce',
    noTenants: 'Brak dostępnych tenantów',
    createViaCheckout: 'Utwórz przestrzeń roboczą przez zamówienie',
    loadFailed: 'Nie udało się załadować tenantów',
    planKlein: 'Mały',
    planMedium: 'Średni',
    planEnterprise: 'Enterprise',
    retry: 'Spróbuj ponownie',
    logout: 'Wyloguj się',
    noAccess: 'Brak dostępu',
  },
  support: {
    title: 'Zgłoszenia wsparcia',
    myTickets: 'Moje zgłoszenia',
    myTicketsTitle: 'Moje zgłoszenia wsparcia',
    inbox: 'Skrzynka',
    inboxTitle: 'Skrzynka wsparcia',
    inboxSubtitle: 'Zgłoszenia z tenantów, które obsługujesz',
    ticket: 'Zgłoszenie',
    newTicket: 'Nowe zgłoszenie wsparcia',
    newTicketTitle: 'Nowe zgłoszenie wsparcia',
    newTicketIntro: 'Proszę opisać problem, a my się odezwiemy.',
    sent: 'Zgłoszenie zostało wysłane.',
    goToMyRequests: 'Przejdź do moich zgłoszeń wsparcia',
    subject: 'Temat',
    subjectPlaceholder: 'Krótkie podsumowanie',
    message: 'Wiadomość',
    messagePlaceholder: 'Proszę opisać, co się stało…',
    consentLabel: 'Przyjmuję do wiadomości, że moje dane są przetwarzane w celu obsługi tego zgłoszenia',
    send: 'Wyślij',
    reply: 'Odpowiedz',
    markComplete: 'Oznacz jako rozwiązane',
    reopen: 'Otwórz ponownie',
    replyPlaceholder: 'Proszę napisać odpowiedź…',
    escalate: 'Eskaluj',
    escalated: 'Eskalowane',
    deescalate: 'Cofnij eskalację',
    deescalateBlocked: 'Do tego zgłoszenia nadal przypisany jest otwarty dostęp wsparcia. Najpierw go cofnij, potem cofnij eskalację.',
    close: 'Zamknij',
    statusLabel: 'Status',
    module: 'Moduł',
    tenant: 'Tenant',
    requester: 'Zgłaszający',
    updated: 'Zaktualizowano',
    backToTickets: 'Powrót do moich zgłoszeń',
    status: {
      open: 'Otwarte',
      in_progress: 'W toku',
      answer: 'Odpowiedziane',
      closed: 'Zamknięte',
    },
    author: {
      user: 'Ty',
      support: 'Wsparcie',
      systemAdmin: 'Administrator systemu',
    },
    empty: {
      myTitle: 'Brak zgłoszeń',
      myBody: 'Gdy utworzysz zgłoszenie wsparcia, pojawi się tutaj.',
      inboxTitle: 'Nic do obsłużenia',
      inboxBody: 'Nie mają Państwo obecnie żadnych zgłoszeń wsparcia w swoich tenantach.',
      notFoundTitle: 'Zgłoszenie niedostępne',
      notFoundBody: 'Nie udało się załadować tego zgłoszenia. Mogło zostać usunięte lub nie mają Państwo do niego dostępu.',
    },
  },
  notifications: {
    nav: 'Powiadomienia',
    title: 'Powiadomienia',
    subtitle: 'Sprawy wymagające Państwa uwagi.',
    settings: 'Ustawienia',
    backToWorkspace: 'Powrót do obszaru roboczego',
    area: 'Obszar',
    areaAll: 'Wszystkie obszary',
    status: 'Status',
    statusAll: 'Wszystkie',
    statusUnread: 'Nieprzeczytane',
    statusRead: 'Przeczytane',
    perPage: 'Na stronę',
    markRead: 'Oznacz jako przeczytane',
    markUnread: 'Oznacz jako nieprzeczytane',
    markAllRead: 'Oznacz wszystkie jako przeczytane',
    loading: 'Ładowanie…',
    empty: 'Wszystko na bieżąco.',
    pageInfo: '{from}–{to} z {total}',
    prev: 'Poprzednia',
    next: 'Następna',
    retentionHint: 'Powiadomienia są przechowywane przez 6 miesięcy.',
    settingsTitle: 'Konfiguruj powiadomienia dla obszarów',
    settingsSubtitle: 'Proszę wybrać, jak chcą Państwo otrzymywać powiadomienia w każdym obszarze.',
    // #445 M4 packet 2: the settings screen must say plainly what it cannot
    // switch off, and what a switched-off Area still lets through.
    mustReachIntro: 'Kilka powiadomień dotyczących bezpieczeństwa, pieniędzy, umów, przestrzeni roboczej i terminów prawnych zawsze trafia do osób, których dotyczą — pojawiają się również przy dzwonku.',
    // A phone-only account (issue 698): no address, so the mail half never goes out.
    noMailAddress: 'Twoje konto nie ma adresu e-mail, dlatego powiadomienia docierają do Ciebie w aplikacji (oraz jako powiadomienia push, jeśli je dopuszczono). „{mailMode}” działa więc jak „{inAppMode}”: nic nie jest wysyłane e-mailem.',
    mustReachStillReaches: 'Nawet po wyłączeniu tej opcji {list} nadal będą docierać, gdy Państwa dotyczą.',
    mandatoryReason: {
      billing: 'Nie można wyłączyć: informacje o zaległych płatnościach muszą trafić do osoby odpowiedzialnej.',
      legal: 'Nie można wyłączyć: zmiany w umowie muszą do Państwa trafić, zgodnie z warunkami umowy.',
    },
    mustReachFamily: {
      identity: 'powiadomienia dotyczące bezpieczeństwa',
      money: 'powiadomienia dotyczące rozliczeń',
      legal: 'powiadomienia dotyczące umowy',
      workspace: 'powiadomienia o stanie przestrzeni roboczej',
      privacy: 'przypomnienia o terminach ochrony danych',
      participation: 'wnioski do przedstawicielstwa pracowników',
    },
    backToList: 'Powrót do powiadomień',
    modeOff: 'Wcale',
    modeInApp: 'Tylko w aplikacji',
    modeMailInApp: 'E-mail i w aplikacji',
    saved: 'Zapisano.',
    saveError: 'Nie udało się zapisać. Ustawienie zostało przywrócone.',
    openTarget: 'Otwórz powiązany element',
    opening: 'Otwieranie…',
    openFailed: 'Nie udało się otworzyć tego powiadomienia.',
    areas: {
      system: 'System',
      timecard: 'Czas',
      ats: 'Rekrutacja',
      apprentice: 'Ausbildung',
      people: 'Kadry',
      support: 'Wsparcie',
      postings: 'Ogłoszenia o pracę',
      // Subscription, invoices, payment problems. A MANDATORY Area — the
      // row renders without a mode selector (review finding 3).
      billing: 'Rozliczenia',
      // #373 M5: the contract-rollout notices (AGB, AVV, subprocessors). A
      // MANDATORY Area — the row renders without a mode selector.
      legal: 'Dokumenty umowne',
    },
  },
  homebase: {
    // The owner's own details, asked for on Suite Home until given (issue 812); skipping asks first.
    ownDetails: {
      save: 'Zapisz moje dane',
      later: 'Później',
      saved: 'Dziękujemy — dane zostały zapisane.',
      skip: {
        title: 'Pominąć dane?',
        body: 'Dopóki dane nie zostaną uzupełnione, własny rekord w Kadrach pozostaje niepotwierdzony. Oznacza to: nie można do niego dodać danych pracowniczych, takich jak umowa, urlop czy wynagrodzenie, nie można zostać wskazanym jako czyjś przełożony, a w Kadrach rekord jest oznaczony jako „niepotwierdzony”. Dane można uzupełnić w każdej chwili — przypomnienie wróci jutro.',
        fill: 'Uzupełnij teraz',
        skip: 'Pomiń na razie',
      },
    },
    // The quiet "set up Lumi" panel on Suite Home: one fixed table of entries,
    // each a title + one benefit line; the rows are looked up per entry key.
    setup: {
      title: 'Konfiguracja lumi',
      subtitle: 'Nic z tego nie jest obowiązkowe. Wszystko się opłaca, gdy przyjdzie na to pora.',
      hide: 'Nie potrzebuję tego już',
      viewAll: 'Zobacz wszystko, co potrafi lumi',
      rareHeading: 'Rzadziej potrzebne',
      page: {
        title: 'Co potrafi lumi.',
        subtitle: 'Wszystko, co można skonfigurować. Najpierw to, co najważniejsze, resztę, gdy będzie potrzebna.',
        tipsTitle: 'Wskazówki na stronie głównej',
        tipsShown: 'Panel jest na górze strony głównej, dopóki nie będzie już potrzebny.',
        tipsHidden: 'Panel jest ukryty. Tutaj można go przywrócić.',
        emptyTitle: 'Nie ma tu nic do skonfigurowania.',
        emptyBody: 'To, co można skonfigurować, ustawiają osoby odpowiedzialne w zespole. W razie braków warto się z nimi skontaktować.',
      },
      sections: {
        suite: 'Start',
        ats: 'Rekrutacja',
        time: 'Czas',
        people: 'Kadry',
        apprentice: 'Ausbildung',
      },
      entries: {
        login_branding: { title: 'Wygląd strony logowania', hint: 'Logo i kolory, by zespół widział, że jest we właściwym miejscu.' },
        portal_design: { title: 'Wygląd portalu kariery', hint: 'Tak kandydaci po raz pierwszy widzą Państwa firmę.' },
        email_templates: { title: 'Szablony e-mail', hint: 'Potwierdzenie, zaproszenie, odmowa: napisać raz, używać zawsze.' },
        job_posting_settings: { title: 'Dane do ogłoszeń o pracę', hint: 'Logo i osoba kontaktowa. Zewnętrzne portale ogłoszeniowe potrzebują obu.' },
        work_time_models: { title: 'Modele czasu pracy', hint: 'Kto pracuje ile godzin i w jakie dni.' },
        company_holidays: { title: 'Przerwy w pracy firmy', hint: 'Dni, w których firma jest zamknięta.' },
        data_import: { title: 'Import osób', hint: 'Przeniesienie istniejących list zamiast wpisywania wszystkiego ręcznie.' },
        company_profile: { title: 'Profil firmy', hint: 'Adres i dane podstawowe, z których lumi korzysta w wielu miejscach.' },
        org_units: { title: 'Jednostki organizacyjne', hint: 'Działy i lokalizacje, według których porządkuje się wiele rzeczy.' },
        payroll_handover: { title: 'Przekazanie płac (DATEV)', hint: 'lumi dostarcza godziny, wynagrodzenie oblicza doradca podatkowy.' },
        training_occupations: { title: 'Zawody szkoleniowe', hint: 'W jakich zawodach prowadzone jest szkolenie.' },
        workflows: { title: 'Workflows', hint: 'Własne kroki i akceptacje w procesie rekrutacji.' },
        application_forms: { title: 'Formularze aplikacyjne', hint: 'Na jakie pytania odpowiadają kandydaci.' },
        offer_templates: { title: 'Szablony ofert', hint: 'Przygotowywanie ofert umów z symbolami zastępczymi.' },
        custom_fields: { title: 'Pola niestandardowe', hint: 'Dodatkowe dane przy ofertach pracy i aplikacjach.' },
        booking_types: { title: 'Typy rejestracji', hint: 'Co można rejestrować oprócz czasu pracy.' },
        leave_types: { title: 'Typy nieobecności', hint: 'Urlop, choroba i Państwa własne typy.' },
        api_settings: { title: 'Interfejs (API)', hint: 'Przekazywanie czasu do własnych programów przez API. Przekazanie płac jest w Kadry.' },
        time_clock: { title: 'Zegar czasu pracy', hint: 'Otwarcie w przeglądarce tabletu na miejscu: każda osoba loguje się tam własnym dostępem do lumi i rejestruje wejście lub wyjście.' },
        sso: { title: 'Single Sign-on', hint: 'Logowanie kontem firmowym.' },
        onboarding_templates: { title: 'Szablony wdrożenia', hint: 'Listy kontrolne na pierwsze dni nowych pracowników.' },
        recruiting_options: { title: 'Listy opcji', hint: 'Formy zwracania się, rodzaje umów i miejsca pracy, z których wybiera zespół.' },
      },
    },
    greeting: { morning: 'Dzień dobry', day: 'Dzień dobry', evening: 'Dobry wieczór' },
    // Wiersz z datą pod powitaniem ("Poniedziałek, 21 września · Tydzień 39",
    // workspace-start M2) zastępuje statyczny podtytuł.
    dateLine: { week: 'Tydzień {n}' },
    open: 'Otwórz',
    recents: 'Ostatnie',
    recentKinds: { report: 'Raport tygodniowy', job: 'Stanowisko', application: 'Aplikacja' },
    moreActions: 'Więcej działań',
    clockedInSince: 'W pracy od {time}',
    clockedOut: 'Poza pracą',
    clockOut: 'Odbij wyjście',
    clockIn: 'Odbij wejście',
    projectRunning: 'Czas projektu biegnie',
    projectRunningSince: 'Od {time}',
    startProject: 'Uruchom projekt',
    // The clock tile for a person freed from booking working time (issue 981): the sentence, then the way to a project.
    workTimeFree: 'Zgodnie z umową rejestrowany jest tylko czas projektu, nie czas pracy.',
    // The Stempeluhr's project choice once clocked in (Zeit's "Woran arbeitest du?"): the tile's field and its sheet.
    clockProject: {
      title: 'Nad czym Pan/Pani pracuje?',
      none: 'Bez projektu',
      noneSub: 'Liczy się jako „Nieprzypisane”',
      choose: 'Wybierz projekt i czynność',
      fieldLabel: 'Nad czym Pan/Pani pracuje? Teraz: {current}',
      runningWith: '{activity} · od {time}',
      runningSince: 'Od {time}',
      activityStep: 'Jaka czynność?',
      back: 'Wszystkie projekty',
      defaultActivity: 'Domyślna',
      search: 'Szukaj projektu',
      noMatch: 'Nie znaleziono projektu',
      close: 'Zamknij',
    },
    provisioning: 'Trwa konfiguracja — może to potrwać minutę.',
    preferences: 'Preferencje',
    seeMyOrg: 'Moja organizacja',
    // What each module Lumi still sells actually does (issue 261 M2). Longer than the
    // launcher's one-liners (app-kit's `lumiModules.<key>.description`): this is one
    // app, so the home can say it in the module's own vocabulary.
    teaser: {
      about: {
        ats: 'Ogłoszenia o pracę, aplikacje i lejek rekrutacyjny — od pierwszego CV po podpisaną umowę.',
        time_tracking: 'Rejestracja wejść i wyjść, konta czasu pracy, nieobecności i nadgodziny, gotowe do ewidencji czasu pracy.',
        apprenticeship: 'Cyfrowe dzienniczki praktyk, plany szkoleń i oceny dla każdego ucznia.',
      },
      heading: 'Więcej modułów',
    },
    empty: 'Nie ma tu jeszcze nic — otwórz moduł, aby zacząć.',
    unavailable: 'Nie można teraz załadować.',

    goToModule: 'Przejdź do {module}', expand: 'Rozwiń {module}', collapse: 'Zwiń {module}',
    themeLight: 'Jasny',
    themeDark: 'Ciemny',
    people: { selfService: 'Moje dane' },
    myDocuments: {
      title: 'Moje dokumenty',
      downloadFailed: 'Pobieranie nie powiodło się – spróbuj ponownie później.',
      showAll: 'Pokaż wszystkie ({count})',
      showLess: 'Pokaż mniej',
      handIn: 'Przekaż dokument',
      empty: 'Na razie nic tu nie ma. Możesz przekazać świadectwo, zaświadczenie, zwolnienie lekarskie lub kopię dokumentu tożsamości do swoich akt.',
      kindLabel: 'Co to jest?',
      fileLabel: 'Plik – wybierz lub zrób zdjęcie',
      send: 'Wyślij',
      cancel: 'Anuluj',
      handedIn: 'Przekazano {date} · czeka na HR',
      accepted: 'Przekazano {date} · przyjęto',
      sentBack: 'Zwrócono {date}: „{reason}”',
      handInAgain: 'Przekaż ponownie',
      dismiss: 'Ukryj',
      error: {
        file_refused: 'Nie udało się przyjąć tego pliku – spróbuj innego pliku.',
        file_too_large: 'Ten plik jest za duży – limit to 25 MB.',
        file_empty: 'Ten plik jest pusty – wybierz inny plik.',
        file_missing: 'Najpierw wybierz plik.',
        quota_exceeded: 'Twoje akta osiągnęły limit miejsca – skontaktuj się z HR.',
        invalid_category: 'Wybierz, jakiego rodzaju jest to dokument.',
        not_possible: 'Przekazanie jest teraz niemożliwe – skontaktuj się z HR.',
        generic: 'Przekazanie nie powiodło się – spróbuj ponownie później.',
        scan_unavailable: 'Nie udało się teraz sprawdzić pliku. Spróbuj ponownie za chwilę.',
      },
      category: {
        contract: 'Umowa o pracę',
        contract_amendment: 'Aneks do umowy',
        certificate: 'Świadectwo pracy',
        attestation: 'Zaświadczenie',
        payslip: 'Pasek wynagrodzeń',
        health_certificate: 'Zwolnienie lekarskie / zaświadczenie lekarskie',
        identification: 'Dokument tożsamości',
        other: 'Inne',
      },
    },
    admin: {
      users: 'Użytkownicy',
      usersMoved: {
        title: 'Zarządzanie użytkownikami przeniesiono do Kadr',
        redirecting: 'Otwieranie Kadr…',
        noPeople: 'Dostępem do tego obszaru roboczego zarządza się przy każdej osobie w Kadrach. Kadry nie są tu dla Państwa dostępne – proszę zwrócić się do właściciela obszaru roboczego.',
      },
    },
    verwaltung: { heading: 'Administracja' },
    nav: { home: 'Panel', billing: 'Rozliczenia', logout: 'Wyloguj', language: 'Język', administration: 'Administracja', sso: 'Single Sign-On', audit: 'Dziennik audytu', supportAccess: 'Dostęp wsparcia', aiUsage: 'Wykorzystanie AI', dataProcessing: 'Przetwarzanie danych', dataRequests: 'Wnioski osób, których dane dotyczą', legalNotices: 'Informacje prawne', statutoryRules: 'Przepisy ustawowe', trainingOccupations: 'Zawody szkoleniowe', externalAgents: 'Zewnętrzni agenci AI', setup: 'Konfiguracja' },
    // The running week against its Sollstunden (#403). `hoursUnit` is a
    // separate key because the figures are formatted with Intl and the unit
    // trails them in every language this app ships.
    week: {
      title: 'W tym tygodniu',
      hoursUnit: 'godz.',
      balance: 'Konto czasu pracy, stan na {date}: {balance}',
      balanceHint: 'Przepracowane godziny minus godziny do przepracowania do tego dnia włącznie.',
      noTarget: 'Nie ustalono wymiaru tygodniowego.',
      trustBased: 'Obowiązuje Pana/Panią czas pracy oparty na zaufaniu: rejestruje Pan/Pani początek i koniec pracy, a wymiaru czasu pracy ani konta czasu pracy nie ma.',
      projectsMore: 'i jeszcze {n}',
      days: 'Dni tygodnia',
    },
    heute: {
      clock: 'Rejestracja czasu',
      attention: 'Wymaga uwagi',
      news: 'Nowe',
      leaveRemaining: 'Pozostały urlop',
      days: 'Dzień | Dni',
      kind: { interview: 'Rozmowa kwalifikacyjna', leave: 'Nieobecności', holiday: 'Święto', exam: 'Egzamin', station: 'Zmiana działu' },
    },
    facts: {
      ats: { total_jobs: 'Oferty', total_applications: 'Aplikacje', open_tasks: 'Otwarte zadania', new_applicants: 'Nowi kandydaci', create_job: 'Utwórz ofertę', add_application: 'Dodaj aplikację', create_task: 'Utwórz zadanie', pipeline: 'Lejek', pipeline_closed: '{n} zamkniętych', stage_other: 'Pozostałe' },
      time: { week_hours: 'Godziny w tym tygodniu', today_hours: 'Godziny dzisiaj', timesheet: 'Moja karta czasu', request_leave: 'Złóż wniosek urlopowy', approvals: 'Zatwierdzenia', team: 'Zespół', pending_approvals: 'Oczekujące zatwierdzenia', leave_remaining: 'Pozostały urlop', proof_open: 'Brak potwierdzenia' },
      apprentice: { waiting: 'Do sprawdzenia', active: 'Uczniowie', overdue: 'Brakujące tygodnie', this_week: 'Ten tydzień', badges: 'Umiejętności', write: 'Uzupełnij tydzień', skills: 'Tablica umiejętności', review: 'Sprawdź raporty', onboard: 'Dodaj ucznia', reports: 'Dzienniczki', report_approved: 'Zatwierdzone', report_submitted: 'Do sprawdzenia', report_rejected: 'Zwrócone', report_missing: 'Brakujące' },
    },
  },
  preferences: {
    appearance: 'Wygląd',
    theme: 'Motyw',
    themeHint: 'Jasny lub ciemny interfejs.',
    language: 'Język',
    languageHint: 'Język używany w całym obszarze.',
    attributions: 'Informacje o otwartych danych',
    placesCredit: 'Dane o miejscowościach © {source}, na licencji {licence}.',
    bankCodesCredit: "Numery rozliczeniowe banków: źródło {bundesbank}; austriackie © {oenb}, na licencji {licence}; szwajcarskie i liechtensteińskie © {six}.",
    healthInsurersCredit: "Kasy chorych: plik danych podstawowych ubezpieczeń społecznych {gkv}.",
  },
  onboarding: {
    actions: { add: 'Dodaj', back: 'Wstecz', next: 'Dalej', remove: 'Usuń' },
    modules: {
      ats: 'Rekrutacja',
      time_tracking: 'Czas',
      apprenticeship: 'Ausbildung',
    },
    fork: {
      // The headline is two keys: the lead and `titleMark`, the final beat that sits
      // on the highlighter stroke. The mark is always the LAST beat of the sentence.
      eyebrow: 'Witamy w lumi',
      title: 'Miło nam, że',
      titleMark: 'są Państwo z nami.',
      subtitle: 'Jak chcą Państwo zacząć? Decyzję można zmienić w każdej chwili.',
      // From a live demo the same page is the way out of it.
      eyebrowDemo: 'Wyjście z wersji demo',
      titleDemo: 'Dość już prób.',
      titleDemoMark: 'Teraz naprawdę.',
      subtitleDemo: 'Przy konfiguracji z przewodnikiem firma demonstracyjna zostaje, dopóki Państwo nie zakończą.',
      reassure: 'Nie mają Państwo pewności? Proszę zacząć od wersji demo – do prawdziwej konfiguracji mogą Państwo przejść w każdej chwili.',
      seedFailed: 'Przygotowanie danych demonstracyjnych nie zostało ukończone. Proszę spróbować ponownie.',
      seedFailedNotEmpty:
        'Wersja demonstracyjna wymaga pustych modułów, a jeden z modułów zawiera już dane. Proszę najpierw je usunąć albo wybrać opcję „Skonfiguruj pakiet”.',
      // #364 F19: why the fork opened mid-Finish. The wizard hands an admin back
      // here when the AVV is still unsigned; landing with nothing said is what
      // made a refused Finish read as a silent drop.
      avvRequiredNotice:
        'Konfigurację można zakończyć dopiero po zaakceptowaniu umowy powierzenia przetwarzania danych (AVV). Prosimy zaakceptować ją tutaj — nastąpi powrót do kreatora konfiguracji.',
      // #364 F21 / ADR 0032 Decision 2: the fork is now also reached FROM a live
      // demo, so it needs the wizard's way out. Leaving costs nothing.
      backToDemo: 'Powrót do wersji demonstracyjnej',
      demo: {
        eyebrow: 'Wypróbowanie',
        title: 'Poznaj z danymi demonstracyjnymi',
        body: 'Wypełniamy Państwa moduły jedną spójną, fikcyjną firmą. Mogą Państwo przeklikać wszystko, niczego przy tym nie psując.',
        modulesHint: 'Wykupione moduły są zawsze uwzględnione.',
        cta: 'Poznaj demo',
      },
      guided: {
        eyebrow: 'Konfiguracja',
        title: 'Przeprowadź mnie krok po kroku',
        body: 'Krok po kroku do prawdziwego pakietu. Mogą Państwo wstrzymać, pominąć krok albo najpierw przejść do wersji demo – wszystko jest możliwe.',
        bodyDemo: 'Krok po kroku do prawdziwego pakietu. Po zamknięciu okna wracają Państwo do wersji demo.',
        pointSaved: 'Państwa postęp zostaje zapisany',
        pointOptional: 'Każdy krok jest opcjonalny',
        cta: 'Przeprowadź mnie',
      },
      empty: {
        eyebrow: 'Na własną rękę',
        titleFresh: 'Zacznij od zera',
        titleDemo: 'Usuń demo i zacznij od zera',
        bodyFresh: 'Pusta przestrzeń. Wszystko konfigurują Państwo stopniowo, we własnym tempie.',
        bodyDemo: 'Firma demonstracyjna zostanie usunięta, a Państwo zaczynają od pustej bazy.',
        warnDemo: 'Dzieje się to natychmiast i nie można tego cofnąć.',
        cta: 'Zacznij od zera',
      },
    },
    exitGate: {
      title: 'Przed opuszczeniem wersji demonstracyjnej',
      intro: 'Oto, co ma zarezerwowane Państwa przestrzeń robocza, i na jakim etapie jest okres próbny. Moduł można dodać teraz lub później w sekcji Rozliczenia — konfiguracja działa w obu przypadkach.',
      booked: { title: 'Zarezerwowane' },
      // The colleagues invited from the demo bar, named before the owner ends the demo
      // (issue 669); `fallback` stands in when the roster could not be read.
      guests: {
        title: 'Współpracownicy zaproszeni do demo',
        lead: 'Ci współpracownicy stracą dostęp, gdy demo się zakończy:',
        fallback: 'Współpracownicy zaproszeni do demo stracą dostęp, gdy się ono zakończy.',
        people: 'Prawdziwy zespół zaprasza się z modułu Kadry po skonfigurowaniu przestrzeni roboczej.',
      },
      // What only the gate can say about a module booked at it (#409 F12): whether
      // its setup-guide section is there yet. The booking rows themselves are the
      // billing section's.
      bookedHere: {
        settingUp: 'Przygotowywanie modułu {module}…',
        booked: 'Moduł {module} jest zarezerwowany i ma własną sekcję w przewodniku konfiguracji.',
        bookedPending: 'Moduł {module} jest zarezerwowany. Jego sekcja pojawi się w przewodniku konfiguracji, gdy tylko moduł będzie gotowy.',
      },
      noManage: 'Moduły mogą rezerwować tylko właściciel przestrzeni roboczej, osoba odpowiedzialna za rozliczenia lub administrator przestrzeni. Można jednak kontynuować bez rezerwacji.',
      enforcement: 'W tej przestrzeni roboczej jest nieuregulowana płatność. Rezerwacje są wstrzymane do czasu jej uregulowania — konfiguracja pakietu nie.',
      factsUnavailable: 'Nie udało się teraz wczytać Państwa rezerwacji. Można mimo to kontynuować; wszystko znajduje się na stronie Rozliczenia.',
      trial: {
        title: 'Państwa okres próbny',
        range: 'Okres próbny rozpoczął się {start} i kończy się {end}.',
        endOnly: 'Okres próbny kończy się {end}.',
        rangeFree: 'Bezpłatnie od {start} do {end}.',
        endOnlyFree: 'Bezpłatnie do {end}.',
        charge: 'Od {end} za rezerwację pobierane będzie {amount} miesięcznie, na początku każdego miesiąca rozliczeniowego.',
        chargeNoTotal: 'Od {end} rezerwacja będzie rozliczana miesięcznie, na początku każdego miesiąca rozliczeniowego.',
        firstCharge: 'Pierwsza płatność zostanie pobrana {date}.',
        demoCounted: 'Czas spędzony w wersji demonstracyjnej został zaliczony do okresu próbnego.',
        over: 'Okres próbny dobiegł końca, a rezerwacja jest rozliczana miesięcznie.',
        monthly: 'To {amount} miesięcznie.',
        nextCharge: 'Następna płatność zostanie pobrana {date}.',
      },
      continue: 'Przejdź do konfiguracji',
    },
    avv: {
      modalTitle: 'Akceptacja umowy powierzenia przetwarzania danych (AVV)',
      modalBody:
        'Konfiguracja pakietu z prawdziwymi danymi oznacza, że lumi przetwarza dane osobowe w Państwa imieniu. Przed kontynuowaniem prosimy zapoznać się z aktualną umową powierzenia przetwarzania danych (AVV) i ją zaakceptować.',
      modalLinkText: 'Przeczytaj pełną treść AVV',
      modalCheckboxLabel: 'Zapoznałem/-am się z aktualną umową AVV i ją akceptuję.',
      modalCancel: 'Jeszcze nie',
      modalAccept: 'Akceptuję i kontynuuję',
    },
    preparing: {
      first: {
        title: 'Przygotowujemy Państwa wersję demonstracyjną.',
        body: 'Tworzymy spójną, fikcyjną firmę we wszystkich Państwa modułach. To potrwa tylko chwilę.',
      },
      reset: {
        title: 'Resetujemy Państwa wersję demonstracyjną.',
        body: 'Opróżniamy firmę demonstracyjną i budujemy ją od nowa. Państwa przestrzeń robocza i współpracownicy pozostają bez zmian. To potrwa tylko chwilę.',
      },
      stuck: {
        note: 'To trwa dłużej niż zwykle.',
        cta: 'Skonfiguruj ręcznie',
      },
    },
    nonAdmin: {
      title: 'Już prawie',
      titleMark: 'gotowe.',
      body: 'Państwa administrator lub administratorka jeszcze konfiguruje pakiet. Gdy tylko skończy, wejdą Państwo tutaj od razu.',
    },
    wizard: {
      title: 'Skonfiguruj pakiet',
      subtitle: 'Wszystko tutaj jest opcjonalne, a Państwa postęp jest zapisywany. Proszę skonfigurować, co Państwo chcą, zakończyć konfigurację lub wrócić do wersji demonstracyjnej, zamykając to okno.',
      subtitleCommitting: 'Konfiguracja jest właśnie stosowana. Jeśli któryś krok się nie powiedzie, mogą Państwo go pominąć i ustawić później w ustawieniach.',
      crossRef: 'Używane w {modules} — można zmienić później w {owner}.',
      crossRefOwnerDefault: 'Kadry',
      recovery: 'Nie udało się zastosować kroku „{step}”. Proszę sprawdzić tam wprowadzone dane i ponownie zakończyć.',
      details: {
        step: 'Państwa dane',
        title: 'Państwa dane',
        subtitle: 'Państwa własny rekord w Kadrach. Proszę sprawdzić imię i nazwisko – zapisanie ich potwierdza rekord.',
        loading: 'Wczytywanie rekordu…',
        confirmed: 'Państwa rekord jest potwierdzony jako {name}. Można go później zmienić w Kadrach.',
        unavailable: 'Nie udało się teraz wczytać Państwa rekordu. Można go potwierdzić później w Kadrach.',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        required: 'Proszę podać imię i nazwisko.',
        hq: {
          title: 'Siedziba firmy',
          why: 'Lumi nie obejdzie się bez lokalizacji: potrzebuje siedziby firmy jako pierwszej lokalizacji, na przykład dla ofert pracy.',
          street: 'Ulica',
          postalCode: 'Kod pocztowy',
          city: 'Miejscowość',
          country: 'Kraj',
          countryNone: 'Nie wybrano kraju',
          required: 'Proszę podać ulicę, kod pocztowy, miejscowość i kraj siedziby firmy.',
        },
      },
      general: {
        title: 'Ogólne',
        company: {
          title: 'Profil firmy',
        },
        name: {
          label: 'Nazwa firmy',
          hint: 'Wstępnie wypełnione z zamówienia — w razie potrzeby proszę zmienić. Wymagane.',
          required: 'Nazwa firmy jest wymagana.',
        },
        profile: {
          industry: 'Branża',
          employeeCountRange: 'Wielkość firmy',
          employeeCountPlaceholder: 'np. 50–200',
          foundedYear: 'Rok założenia',
          foundedYearPlaceholder: 'np. 2010',
          legalForm: 'Forma prawna',
          websiteUrl: 'Strona internetowa',
        },
        place: {
          hint: 'Proszę wybrać miejscowość z listy jako nazwę lokalizacji — lub wpisać własną nazwę i zatwierdzić klawiszem Enter albo +.',
        },
        org: {
          title: 'Struktura organizacji',
          subtitle: 'Działy, lokalizacje i miejsca powstawania kosztów, do których należą pracownicy.',
          departments: 'Działy',
          locations: 'Lokalizacje',
          costCenters: 'Miejsca powstawania kosztów',
          empty: 'Jeszcze żadnych',
          addDepartment: 'Nowy dział',
          addLocation: 'Nowa lokalizacja, np. Warszawa',
          addCostCenter: 'Nowe miejsce powstawania kosztów',
        },
      },
      finish: {
        cta: 'Zakończ konfigurację',
        step: 'Zakończenie',
        title: 'Zakończ konfigurację',
        body: 'Zakończenie powoduje zastosowanie Państwa odpowiedzi. Wszystko można później zmienić w każdym module.',
        nextTitle: 'Następnie: zaproszenie zespołu',
        nextBody: 'Po konfiguracji proszę otworzyć obszar administracyjny, aby zaprosić pierwszych użytkowników i przypisać im role.',
        demoWarning: 'Zakończenie powoduje usunięcie firmy demonstracyjnej i wszystkich użytkowników zaproszonych podczas jej przeglądania.',
      },
      sections: {
        ats: {
          title: 'Rekrutacja',
          subtitle: 'Proszę ustawić działanie aplikacji i e-maili rekrutacyjnych.',
          fields: {
            fromName: { label: 'Nazwa nadawcy', hint: 'Wyświetlana w e-mailach do kandydatów.' },
            signature: { label: 'Podpis e-mail', hint: 'Dołączany do wychodzących e-maili do kandydatów.' },
          },
          jobPosting: {
            title: 'Ogłoszenie o pracę',
            hint: 'Kontakt do kandydatów i logo wyświetlane w zewnętrznych ogłoszeniach o pracę (opcjonalne — można to skonfigurować także później).',
            contactName: 'Nazwa kontaktu',
            contactEmail: 'E-mail kontaktowy',
            logo: 'Logo ogłoszenia',
            uploadLogo: 'Prześlij logo',
            removeLogo: 'Usuń',
            rePick: 'Logo nie zostało jeszcze przesłane — proszę wybrać je ponownie.',
            contactEmailInvalid: 'Proszę podać prawidłowy adres e-mail.',
          },
          workflow: {
            title: 'Proces rekrutacji',
            participantsQuestion: 'Kto jest zaangażowany w ogłoszenia o pracę i zgłoszenia?',
            worksCouncil: 'Rada pracownicza',
            sbv: 'Przedstawicielstwo osób z niepełnosprawnościami',
            legalSignOff: 'Dział prawny – zatwierdza ogłoszenie o pracę przed jego publikacją',
            assessmentCentreQuestion: 'Czy korzystają Państwo z assessment center?',
            assessmentCentre: 'Tak, korzystamy z assessment center',
            hint: 'Proces można później zawsze edytować i aktualizować w ATS.',
          },
        },
        time_tracking: {
          title: 'Czas',
          subtitle: 'Rodzaje księgowań i zasady czasu pracy.',
          fields: {
            bookingTypes: { label: 'Rodzaje księgowań', hint: 'Proszę dodać rodzaje księgowań, których Państwo używają.', placeholder: 'np. Praca' },
          },
          companyHolidays: {
            title: 'Przerwy urlopowe firmy',
            hint: 'Dni, w które firma jest zamknięta – na przykład pół dnia w Wigilię i w sylwestra. W te dni nie naliczają się godziny planowane. Dla każdego wpisu decydują Państwo, czy jest odliczany od urlopu; można to później zmienić w ustawieniach Czasu.',
            empty: 'Nie wpisano jeszcze żadnej przerwy urlopowej firmy.',
            suggestions: 'Propozycje:',
            christmasEve: 'Wigilia',
            newYearsEve: 'Sylwester',
            name: 'Nazwa',
            namePlaceholder: 'np. Między świętami a Nowym Rokiem',
            from: 'Od',
            to: 'Do (opcjonalnie)',
            halfDay: 'Pół dnia',
            yearly: 'Co roku',
            deductsFromLeave: 'Odliczaj od urlopu',
            rangeReversed: 'Data końcowa jest wcześniejsza niż początkowa.',
          },
        },
        apprenticeship: {
          title: 'Ausbildung',
          subtitle: 'Zawody szkoleniowe.',
          fields: {
            professions: { label: 'Zawody szkoleniowe', hint: 'Zawody praktyk, w których Państwo szkolą.', placeholder: 'np. Technik informatyk' },
          },
        },
        people: {
          title: 'Kadry',
          subtitle: 'Wspólne słownictwo używane w całym pakiecie.',
          fields: {
            salutations: { label: 'Formy grzecznościowe', hint: 'Proszę dodać formy grzecznościowe oprócz zestawu standardowego.', placeholder: 'np. Osoba' },
            contractTypes: { label: 'Rodzaje umów', hint: 'Proszę dodać rodzaje umów oprócz zestawu standardowego.', placeholder: 'np. Student pracujący' },
            workTimeModels: { label: 'Modele czasu pracy', hint: 'Proszę dodać modele oprócz zestawu standardowego.', placeholder: 'np. Podział etatu' },
            workLocationTypes: { label: 'Miejsca pracy', hint: 'Proszę dodać rodzaje miejsc pracy oprócz zestawu standardowego.', placeholder: 'np. Praca w terenie' },
          },
        },
      },
    },
    commit: {
      wiping: {
        title: 'Usuwanie demonstracji…',
        body: 'Usuwanie firmy demonstracyjnej, aby prawdziwa konfiguracja zaczęła się od czystego stanu.',
      },
      applying: {
        title: 'Konfigurowanie pakietu…',
        body: 'Stosowanie Państwa odpowiedzi. To potrwa tylko chwilę.',
      },
      steps: {
        company: 'Profil firmy',
      },
      error: 'Podczas stosowania konfiguracji coś poszło nie tak.',
      retry: 'Spróbuj ponownie',
      backToSetup: 'Powrót do konfiguracji',
      skipStep: 'Zakończ bez tego kroku',
      skipped: 'Pominięto: {steps}. Mogą to Państwo ustawić w dowolnym momencie w ustawieniach.',
      resume: 'Wznów konfigurację',
      stalled: 'To trwa dłużej niż oczekiwano.',
      wipeFailed: 'Nie udało się usunąć demonstracji. Proszę spróbować ponownie, aby kontynuować.',
      logoMissing: 'Logo nie zostało przesłane (utracone po ponownym załadowaniu) — można je dodać później w ustawieniach ogłoszeń o pracę.',
      workflowFailed: 'Nie udało się wygenerować łańcucha rekrutacji, dlatego przestrzeń pracy startuje z łańcuchem standardowym. Wszystko inne zostało zastosowane — proszę otworzyć ustawienia workflow w module rekrutacji, aby ponownie uruchomić generator.',
      workflowDrafted: 'Twój proces rekrutacji został zapisany jako wersja robocza, ponieważ {roles} nie ma jeszcze przypisanej osoby. Proszę otworzyć ustawienia workflow w module rekrutacji, aby go aktywować, gdy rola zostanie obsadzona.',
      workflowRoles: {
        ats_works_council: 'rada pracownicza',
        ats_sbv: 'przedstawicielstwo osób z niepełnosprawnościami',
        ats_legal: 'dział prawny',
      },
      continue: 'Przejdź do obszaru roboczego',
    },
  },
  tenants: {
    switcherLabel: 'Zmień przestrzeń roboczą',
    supportAccessBadge: 'Wsparcie',
    supportAccessUntil: 'Tymczasowy dostęp wsparcia do {until}',
    supportAccessBanner: 'Wsparcie lumi ma obecnie tymczasowy dostęp do tej przestrzeni.',
    supportAccessReview: 'Sprawdź',
  },
  dataProtection: {
    blockedErasure: {
      title: 'Co blokuje usunięcie',
      intro: 'Dokumenty pracownicze bez okresu przechowywania są przechowywane bezterminowo: nikt nie rozstrzygnął, jak długo należy je przechowywać, a dokument bez rozstrzygnięcia nigdy nie jest usuwany automatycznie. Są tu wymienione, aby mogli Państwo ustawić te terminy.',
      sensitivePlaceholder: 'Dokument wrażliwy',
      categories: {
        contract: 'Umowa',
        contract_amendment: 'Aneks do umowy',
        certificate: 'Świadectwo',
        attestation: 'Zaświadczenie',
        warning: 'Upomnienie',
        other: 'Inny dokument',
      },
      outcomes: {
        refused: 'Odmowa usunięcia',
        partial: 'Usunięto częściowo',
      },
      list: {
        title: 'Dokumenty bez okresu przechowywania',
        fixHint: 'Najstarsze na górze. Proszę ustawić okres przechowywania przy dokumencie w aktach osobowych, a zniknie on z tej listy.',
        loading: 'Wczytywanie dokumentów…',
        loadError: 'Nie udało się wczytać listy. Prosimy spróbować ponownie — to nie oznacza „nic nie znaleziono”.',
        empty: 'Każdy dokument w tej przestrzeni roboczej ma okres przechowywania.',
        uploadedLabel: 'Przesłano',
        truncated: 'Wyświetlanych jest tylko {count} najstarszych dokumentów. Kolejne czekają na okres przechowywania.',
      },
    },
    myData: {
      title: 'Moje dane',
      intro: 'Tutaj mogą Państwo zapytać, jakie dane na Państwa temat przechowuje ta przestrzeń robocza, poprosić o ich sprostowanie albo o ich usunięcie. Każdy wniosek jest rejestrowany i rozpatrywany przez osoby odpowiedzialne w tej przestrzeni za ochronę danych, a jego przebieg widać w tym miejscu.',
      requests: {
        title: 'Moje wnioski',
        loading: 'Trwa wczytywanie wniosków…',
        loadError: 'Nie udało się wczytać wniosków. Mimo to mogą Państwo złożyć wniosek poniżej.',
        empty: 'Nie złożyli Państwo jeszcze żadnego wniosku.',
        filedLabel: 'Złożono',
        dueLabel: 'Termin odpowiedzi',
        outcomeLabel: 'Wynik',
        awaitingRelease: 'Kopia jest sprawdzana',
      },
      kinds: {
        access: 'Kopia moich danych',
        rectification: 'Sprostowanie',
        erasure: 'Usunięcie',
      },
      statuses: {
        received: 'Przyjęty',
        verifying: 'Weryfikacja tożsamości',
        in_progress: 'W trakcie rozpatrywania',
        awaiting_subject: 'Oczekuje na Państwa odpowiedź',
        completed: 'Zakończony',
        refused: 'Odmowa',
        withdrawn: 'Wycofany',
      },
      outcomes: {
        erased: 'Dane usunięte',
        suppressed: 'Dane usunięte, pozostaje minimalny wpis',
        refused: 'Odmowa',
        partial: 'Częściowo zrealizowany',
        answered: 'Udzielono odpowiedzi',
      },
      actions: {
        access: {
          title: 'Wniosek o kopię moich danych',
          body: 'Mogą Państwo poprosić o kopię danych, które ta przestrzeń robocza przechowuje na Państwa temat. Nie jest to pobranie od razu: kopia jest najpierw przygotowywana, a o jej gotowości zostaną Państwo powiadomieni.',
          where: 'Gotowa kopia nigdy nie jest wysyłana jako załącznik do wiadomości. Otrzymają Państwo e-mail, a następnie po zalogowaniu się na konto lumi HR pobiorą ją Państwo z tego konta.',
          cta: 'Poproś o kopię',
          detailLabel: 'Uzupełnienie (opcjonalnie)',
          detailHint: 'Na przykład wtedy, gdy chodzi tylko o część danych.',
        },
        rectification: {
          title: 'Wniosek o sprostowanie',
          body: 'Jeżeli dane przechowywane w tej przestrzeni roboczej na Państwa temat są nieprawidłowe lub nieaktualne, mogą Państwo poprosić o ich sprostowanie.',
          cta: 'Poproś o sprostowanie',
          detailLabel: 'Co jest nieprawidłowe i jak powinno brzmieć?',
          detailHint: 'Prosimy opisać dane możliwie dokładnie, aby można je było odnaleźć i sprawdzić.',
          selfTitle: 'Część danych mogą Państwo zmienić samodzielnie',
          selfFields: 'Imię i nazwisko oraz formę grzecznościową, płeć, kontaktowy adres e-mail, telefon, adres, obywatelstwo, stan cywilny i język zmieniają Państwo samodzielnie w swoim profilu.',
          selfLink: 'Otwórz mój profil',
          askBody: 'W pozostałych sprawach – data urodzenia, numer pracownika, dane umowy, wynagrodzenia lub podatkowe, dokumenty – prosimy skorzystać z wniosku poniżej.',
        },
        erasure: {
          title: 'Wniosek o usunięcie moich danych',
          body: 'Mogą Państwo poprosić tę przestrzeń roboczą o usunięcie danych, które przechowuje na Państwa temat.',
          cta: 'Poproś o usunięcie',
          confirm: 'Wniosek zostanie rozpatrzony przez osoby odpowiedzialne w tej przestrzeni roboczej. Danych, które muszą być przechowywane na podstawie przepisów prawa albo są nadal potrzebne w związku z Państwa zatrudnieniem, nie można usunąć. Zostaną Państwo poinformowani, co zostało usunięte, a co pozostaje.',
          detailLabel: 'Uzupełnienie (opcjonalnie)',
          detailHint: 'Na przykład o które dane chodzi, jeżeli nie o wszystkie.',
        },
      },
      form: {
        submit: 'Wyślij wniosek',
        submitting: 'Wysyłanie…',
        cancel: 'Anuluj',
        success: 'Wniosek został zarejestrowany. Znajdą go Państwo powyżej w sekcji „Moje wnioski”.',
        errorGeneric: 'Nie udało się wysłać wniosku. Nic nie zostało zarejestrowane – prosimy spróbować ponownie.',
        errorRateLimit: 'W krótkim czasie wysłano kilka wniosków. Prosimy spróbować później.',
      },
    },
    export: {
      title: 'Eksport tej przestrzeni roboczej',
      intro: 'W dowolnej chwili może Pan/Pani pobrać pełną kopię wszystkiego, co przechowuje ta przestrzeń robocza — w formacie nadającym się do odczytu maszynowego i bez pytania nas o zgodę.',
      contents: {
        title: 'Co zawiera ten plik',
        body: 'Archiwum zawiera dane wszystkich osób w postaci jawnej, a obok nich aktywne klucze dostępu tej przestrzeni roboczej: klucz AI, linki do kalendarzy wraz z tokenami oraz dane dostępowe podłączonych dostawców. Archiwum zawiera też, dla modułów Kadry, Rekrutacja i Czas, dokument HR Open Standards (HR-JSON) — wspólny format na wypadek zmiany dostawcy.',
        handling: 'Proszę przechowywać je równie starannie jak same klucze. Kto ma plik i hasło, ma wszystko, co się w nim znajduje.',
      },
      roleRequired: {
        title: 'Ten eksport wymaga roli „Ochrona danych”',
        body: 'Archiwum zawiera każdy plik przechowywany w tej przestrzeni roboczej — w tym paski wynagrodzeń, zaświadczenia lekarskie i dokumenty tożsamości — obok danych osobowych wszystkich osób oraz aktywnych kluczy dostępu tej przestrzeni roboczej.',
        hint: 'Sama własność przestrzeni roboczej już nie wystarczy: osoba uruchamiająca eksport musi mieć dodatkowo rolę „Ochrona danych”. Rola ta jest przydzielana razem z pozostałymi rolami pakietu w administracji użytkowników i może zostać przydzielona również Panu/Pani.',
      },
      start: {
        title: 'Rozpoczęcie eksportu',
        body: 'Proszę wybrać hasło. Archiwum zostanie nim zaszyfrowane i tylko nim można je otworzyć.',
        passphraseWarning: 'Nie przechowujemy hasła i nie możemy go odzyskać. Po jego utracie archiwum nie da się już otworzyć — nie ma możliwości zresetowania.',
        passphraseLabel: 'Hasło',
        passphraseHint: 'Co najmniej {min} znaków. Proszę wybrać coś długiego, co da się bezpiecznie przechować.',
        confirmLabel: 'Powtórzenie hasła',
        submit: 'Rozpocznij eksport',
        submitting: 'Rozpoczynanie…',
        success: 'Eksport został rozpoczęty. Powstaje w tle i pojawi się poniżej, gdy będzie gotowy.',
        errorTooShort: 'Hasło musi mieć co najmniej {min} znaków.',
        errorMismatch: 'Oba hasła nie są takie same.',
        errorAlreadyRunning: 'Eksport tej przestrzeni roboczej już trwa. Proszę poczekać na jego zakończenie przed rozpoczęciem kolejnego.',
        errorTooMany: 'Ta przestrzeń robocza rozpoczęła na razie maksymalną liczbę eksportów. Proszę spróbować później.',
        errorGeneric: 'Nie udało się potwierdzić, że eksport został rozpoczęty. Proszę sprawdzić poniższą listę przed rozpoczęciem kolejnego.',
      },
      list: {
        title: 'Eksporty tej przestrzeni roboczej',
        loading: 'Wczytywanie eksportów…',
        loadError: 'Nie udało się wczytać eksportów.',
        empty: 'Ta przestrzeń robocza nie była jeszcze eksportowana.',
        linkHint: 'Link do pobrania jest ważny tylko przez chwilę. Jeśli przestanie działać, proszę ponownie użyć przycisku.',
        retentionHint: 'Każde archiwum jest usuwane automatycznie po wygaśnięciu — data jest podana obok.',
        startedLabel: 'Rozpoczęto',
        expiresLabel: 'Dostępne do',
        download: 'Pobierz',
        preparing: 'Przygotowywanie…',
        downloadError: 'Nie udało się przygotować pobierania. Archiwum może już nie istnieć.',
        gone: 'Archiwum zostało usunięte. Proszę rozpocząć nowy eksport, jeśli potrzebna jest kolejna kopia.',
        failedHint: 'Ten eksport nie został ukończony. Można rozpocząć nowy.',
        runningHint: 'Ten eksport jest jeszcze przygotowywany.',
      },
      statuses: {
        requested: 'Zgłoszony',
        exporting: 'W przygotowaniu',
        exported: 'Gotowy',
        failed: 'Nieudany',
        expired: 'Usunięty',
      },
    },
    settingsPanel: {
      title: 'Przetwarzanie danych',
      body: 'Mogą Państwo poprosić o usunięcie lub sprostowanie swoich danych albo o ich kopię {link}.',
      linkLabel: 'tutaj',
    },
  },
  // Administration › Data subject requests (issue 789): the DSAR work list.
  dataRequests: {
    forbidden: {
      title: 'Ta lista jest przeznaczona dla roli ochrony danych',
      description: 'Wnioski osób, których dane dotyczą, rozpatruje właściciel przestrzeni roboczej lub osoba z rolą „Ochrona danych”.',
    },
    intro: {
      title: 'Wnioski osób, których dane dotyczą',
      body: 'Wnioski osób dotyczące danych, które ta przestrzeń robocza o nich przechowuje. Na każdy trzeba odpowiedzieć w ciągu miesiąca od otrzymania (art. 12 ust. 3 RODO). Przy złożonym wniosku termin można dwukrotnie przedłużyć o miesiąc — z uzasadnieniem, które należy przekazać tej osobie.',
    },
    filters: {
      label: 'Pokaż wnioski',
      open: 'Otwarte',
      overdue: 'Po terminie',
      dueSoon: 'Termin w ciągu 7 dni',
      closed: 'Ostatnio rozpatrzone',
    },
    empty: {
      title: 'Brak wniosków osób, których dane dotyczą',
      description: 'Gdy ktoś zapyta o swoje dane — w lumi, e-mailem, pocztą lub telefonicznie — wniosek pojawi się tutaj wraz z terminem.',
    },
    emptyFilter: 'Brak wniosków w tym widoku.',
    truncated: 'Nie wszystkie wnioski mieszczą się na tej stronie. Najbliższe terminy są wyświetlane jako pierwsze.',
    badges: {
      overdue: 'Po terminie',
      dueSoon: 'Termin wkrótce',
      legalHold: 'Obowiązek zachowania',
      reviewReady: 'Gotowe do sprawdzenia',
      reviewReleased: 'Zwolniona',
      reviewDelivered: 'Doręczona',
    },
    row: {
      received: 'Otrzymano',
      due: 'Odpowiedź do',
      closed: 'Zamknięto',
      subject: 'Dotyczy',
      channel: 'Wpłynął przez',
      outcome: 'Wynik',
      extensions: 'Przedłużenia terminu: {count} z 2',
      postponed: 'Przypomnienia wstrzymane do {date}',
      vetoWindow: 'Usunięcie można jeszcze zatrzymać do {date}',
      reviewFlagged: 'Wymagana jest decyzja Pana/Pani: {flagged} z {total} wpisów',
      reviewNoneFlagged: 'Brak oznaczonych wpisów',
      reviewEmpty: 'Kopia nie zawiera wpisów',
      reviewOpen: 'Sprawdź',
      reviewReleased: 'Zwolniona, trwa doręczanie',
      reviewDelivered: 'Doręczona, wniosek jest zamykany',
    },
    legalHold: {
      tenant: 'Obowiązuje obowiązek zachowania danych dla całej przestrzeni roboczej ({reason}).',
      subject: 'Ta osoba jest objęta obowiązkiem zachowania danych ({reason}).',
      consequence: 'Danych nie wolno usunąć. Zgodną z prawem odpowiedzią jest odmowa wskazująca tę podstawę — obowiązek nie wstrzymuje terminu.',
    },
    automated: {
      pending: 'lumi sam odpowiada na ten wniosek: gdy sprawdzą Państwo tożsamość osoby i ustawią wniosek na „W trakcie”, lumi przygotuje kopię jej danych. Kopia czeka wtedy na Państwa sprawdzenie. Po jej zwolnieniu osoba dowie się, gdzie ją pobrać, a wniosek zamknie się sam.',
      running: 'lumi przygotowuje kopię danych tej osoby. Następnie czeka ona na Państwa sprawdzenie — osoba dowie się, gdzie ją pobrać, dopiero po jej zwolnieniu.',
    },
    detail: {
      show: 'Pokaż, kto złożył wniosek',
      hide: 'Ukryj szczegóły',
      loading: 'Ładowanie szczegółów…',
      loadError: 'Nie udało się wczytać szczegółów tego wniosku.',
      subjectLabel: 'Podane imię i nazwisko',
      subjectEmail: 'Adres e-mail',
      subjectPhone: 'Numer telefonu',
      requestDetail: 'O co poproszono',
      onBehalfReason: 'Zarejestrowano w imieniu osoby, ponieważ',
      extensionReason: 'Powód przedłużenia',
      outcomeBasis: 'Wskazana podstawa',
      nothingOnFile: 'Kontakt',
      nothingOnFileValue: 'Dla tego wniosku nie zapisano imienia, adresu ani wiadomości.',
    },
    kinds: {
      access: 'Kopia własnych danych',
      rectification: 'Sprostowanie danych',
      erasure: 'Usunięcie danych',
      restriction: 'Ograniczenie przetwarzania',
      portability: 'Przenoszenie danych',
      objection: 'Sprzeciw wobec przetwarzania',
    },
    statuses: {
      received: 'Otrzymany',
      verifying: 'Weryfikacja tożsamości',
      in_progress: 'W trakcie',
      awaiting_subject: 'Oczekiwanie na osobę',
      completed: 'Zakończony',
      refused: 'Odrzucony',
      withdrawn: 'Wycofany',
    },
    outcomes: {
      erased: 'Dane usunięte',
      suppressed: 'Dane usunięte, zachowano minimalny zapis',
      refused: 'Odrzucony',
      partial: 'Zrealizowany częściowo',
      answered: 'Udzielono pełnej odpowiedzi',
    },
    subjectTypes: {
      person: 'Akta pracownicze',
      tenant_user: 'Członek bez akt pracowniczych',
      candidate: 'Kandydat',
      unlinked: 'Nieprzypisany do żadnego rekordu',
    },
    channels: {
      'self-service': 'Złożony przez osobę w lumi',
      'candidate-portal': 'Portal kandydatów',
      email: 'E-mail',
      post: 'Poczta',
      phone: 'Telefon',
      unknown: 'Nie zapisano',
    },
    actions: {
      advance: {
        verifying: 'Sprawdź tożsamość',
        in_progress: 'Rozpocznij realizację',
        awaiting_subject: 'Czekaj na osobę',
      },
      extend: 'Przedłuż termin',
      close: 'Zamknij wniosek',
      postpone: 'Wstrzymaj przypomnienia',
      veto: 'Otwórz okres weta',
      hold: 'Zachowaj dane osoby',
      restrict: 'Ogranicz przetwarzanie',
      record: 'Zarejestruj wniosek',
    },
    confirmAutomated: {
      title: 'Przygotować kopię danych tej osoby?',
      body: 'Ustawienie wniosku na „W trakcie” zleca lumi zebranie wszystkiego, co ta przestrzeń robocza przechowuje o tej osobie. Kopia nie trafia jeszcze do osoby: czeka na Państwa sprawdzenie, a osoba dowie się, gdzie ją pobrać, dopiero po jej zwolnieniu. Proszę to zrobić dopiero po potwierdzeniu jej tożsamości.',
      confirm: 'Rozpocznij',
    },
    toast: {
      advanced: 'Wniosek ustawiono na „{status}”.',
      extended: 'Termin przedłużono do {date}.',
      closed: 'Wniosek zamknięto.',
      postponed: 'Przypomnienia wstrzymane do {date}.',
      vetoOpened: 'Okres weta otwarty. Usunięcie czeka 72 godziny.',
      holdPlaced: 'Obowiązek zachowania ustanowiony.',
      holdReleased: 'Obowiązek zachowania zniesiony.',
      holdAttested: 'Obowiązek zachowania potwierdzony na kolejne sześć miesięcy.',
      restrictionPlaced: 'Przetwarzanie ograniczone.',
      restrictionNotified: 'Powiadomienie zapisane.',
      restrictionLifted: 'Ograniczenie zniesione.',
      recorded: 'Wniosek zarejestrowany.',
    },
    extend: {
      title: 'Przedłuż termin',
      body: 'Art. 12 ust. 3 RODO pozwala dwukrotnie przedłużyć termin o miesiąc, gdy wniosek jest złożony lub wniosków jest wiele. Należy poinformować o tym osobę w pierwszym miesiącu, podając powód.',
      remaining: 'Pozostałe przedłużenia: {count}',
      reasonLabel: 'Powód opóźnienia',
      reasonHint: 'Zostanie zapisany przy wniosku. Proszę podać osobie ten sam powód.',
      submit: 'Przedłuż o miesiąc',
      errorReason: 'Proszę podać powód opóźnienia.',
    },
    close: {
      title: 'Zamknij wniosek',
      body: 'Zamkniętego wniosku nie można ponownie otworzyć: jest zapisem tego, jak i kiedy przestrzeń robocza odpowiedziała.',
      statusLabel: 'Jak został zamknięty?',
      outcomeLabel: 'Co zostało zrobione',
      outcomePlaceholder: 'Wybierz…',
      basisLabel: 'Podstawa prawna',
      basisHint: 'Podstawa tego, co zachowano lub czego odmówiono, np. obowiązek przechowywania lub art. 12 ust. 5 RODO.',
      submit: 'Zamknij wniosek',
      errorOutcome: 'Proszę wybrać, co zostało zrobione.',
      errorBasis: 'Odmowa lub częściowa odpowiedź musi wskazywać podstawę prawną.',
      conflict: 'Nie udało się zamknąć wniosku w ten sposób. Obowiązek zachowania danych lub otwarte okno sprzeciwu może blokować usunięcie danych albo wniosek zmienił się w międzyczasie — proszę odświeżyć listę i sprawdzić.',
    },
    record: {
      title: 'Zarejestruj wniosek',
      body: 'Dla wniosku, który wpłynął e-mailem, pocztą lub telefonicznie. Miesięczny termin biegnie od dnia wpływu, a nie od dziś. Zarejestrowany wniosek zaczyna ze statusem wpłynął.',
      choose: 'Wybierz…',
      kindLabel: 'Rodzaj wniosku',
      channelLabel: 'Wpłynął przez',
      receivedLabel: 'Data wpływu',
      receivedHint: 'Dzień, w którym wniosek dotarł do obszaru roboczego — najpóźniej dziś.',
      subjectLabel: 'Osoba, której dotyczy',
      modes: {
        person: 'Osoba w Kadrach',
        candidate: 'Kandydat w Rekrutacji',
        unlinked: 'Brak w systemie',
      },
      personLabel: 'Wyszukaj osobę',
      personHint: 'Szukaj po imieniu, nazwisku lub adresie e-mail.',
      candidateLabel: 'Kandydat lub kandydatka',
      candidateHint: 'Szukaj po imieniu, nazwisku lub adresie e-mail. Wyszukiwani są tylko kandydaci, których może otworzyć Twoja rola w Rekrutacji.',
      candidateRefused: 'Twoje role w Rekrutacji nie pozwalają wyszukiwać kandydatów. Wybierz „Brak w systemie” i podaj imię i nazwisko, które podała osoba.',
      searchPlaceholder: 'Imię, nazwisko lub e-mail',
      picker: {
        searching: 'Wyszukiwanie…',
        typeMore: 'Minimalna liczba znaków: {count}',
        noMatch: 'Brak trafień. Jeśli osoby nie ma nigdzie w systemie, wybierz „Brak w systemie”.',
        error: 'Wyszukiwanie nie powiodło się. Jeśli osoby nie ma nigdzie w systemie, wybierz „Brak w systemie”.',
        refused: 'Twoje role nie pozwalają wyszukiwać kandydatów.',
        rateLimited: 'Zbyt wiele wyszukiwań – proszę spróbować za chwilę',
        resultsAnnouncement: 'Jeden wynik | Wyników: {count}',
        clear: 'Wyczyść wybór',
      },
      nameLabel: 'Podane imię i nazwisko',
      nameHint: 'Tak, jak osoba się podpisała lub przedstawiła.',
      emailLabel: 'Adres e-mail (opcjonalnie)',
      detailLabel: 'Czego dotyczy żądanie?',
      detailHint: 'Opcjonalnie. W miarę możliwości słowami tej osoby.',
      reasonLabel: 'Dlaczego rejestrujesz to w jej imieniu?',
      reasonHint: 'Na przykład: list do działu kadr z 3 maja lub telefon odebrany w recepcji. Zapisywane z Twoim nazwiskiem.',
      submit: 'Zarejestruj wniosek',
      errorKind: 'Wybierz rodzaj wniosku.',
      errorChannel: 'Wybierz, jak wpłynął wniosek.',
      errorReceived: 'Wybierz dzień wpływu wniosku.',
      errorFuture: 'Wniosek nie może wpłynąć w przyszłości. Wybierz dziś lub wcześniejszy dzień.',
      errorPerson: 'Wybierz osobę z wyników wyszukiwania lub „Brak w systemie”.',
      errorCandidate: 'Wybierz kandydata z wyników wyszukiwania lub „Brak w systemie”.',
      errorName: 'Podaj imię i nazwisko, które podała osoba.',
      errorEmail: 'Podaj prawidłowy adres e-mail lub zostaw pole puste.',
      errorReason: 'Podaj, dlaczego rejestrujesz wniosek w imieniu tej osoby.',
    },
    errors: {
      conflict: 'Ten krok nie jest już możliwy — wniosek zmienił się w międzyczasie. Proszę odświeżyć listę.',
      notLinked: 'Ten wniosek nie jest powiązany z żadnym rekordem, więc nie ma kogo objąć zachowaniem ani ograniczeniem.',
    },
    progress: {
      title: 'Usunięcie według modułu',
      show: 'Pokaż postęp usuwania',
      hide: 'Ukryj postęp usuwania',
      loading: 'Wczytywanie rejestru usunięć…',
      loadError: 'Nie udało się wczytać rejestru usunięć.',
      unlinked: 'Ten wniosek nie jest powiązany z żadnym rekordem, więc żaden moduł niczego dla niego nie usunął.',
      lastExecuted: 'zapisano {date}',
      states: {
        done: 'Usunięto',
        heldNothing: 'Nic nie przechowywano',
        pending: 'Jeszcze nie zapisano',
        deferred: 'Odroczone — moduł wyłączony',
      },
      modules: {
        people: 'Kadry',
        ats: 'Aplikacje',
        time: 'Czas pracy',
        apprentice: 'Szkolenie zawodowe',
        payroll: 'Płace',
        privacy: 'Rejestr ochrony danych',
      },
    },
    postpone: {
      title: 'Wstrzymaj przypomnienia',
      body: 'Zatrzymuje e-maile z przypomnieniami do wybranego dnia. Termin ustawowy się nie zmienia — aby go przesunąć, przedłuż wniosek.',
      untilLabel: 'Wstrzymaj do',
      untilHint: 'Najpóźniej do terminu odpowiedzi, {date}.',
      reasonLabel: 'Powód',
      reasonHint: 'Zostanie zapisany przy wniosku, aby można było później uzasadnić wstrzymanie.',
      submit: 'Wstrzymaj przypomnienia',
      errorUntil: 'Proszę wybrać dzień, w którym przypomnienia zostaną wznowione.',
      errorRange: 'Proszę wybrać dzień od jutra do terminu odpowiedzi.',
      errorReason: 'Proszę podać powód wstrzymania.',
    },
    veto: {
      title: 'Otworzyć okres weta?',
      body: 'Przez następne 72 godziny usunięcie jest wstrzymane: wniosku nie można zamknąć jako usuniętego. Wykorzystaj ten czas, aby sprawdzić, czy potrzebny jest obowiązek zachowania lub odmowa. Okresu nie można zamknąć wcześniej.',
      confirm: 'Otwórz okres weta',
    },
    holds: {
      title: 'Obowiązki zachowania',
      intro: 'Obowiązek zachowania uniemożliwia usunięcie danych — na podstawie wniosku, zasad przechowywania lub usunięcia przestrzeni roboczej — do czasu jego zniesienia. Każdy obowiązek trzeba ponownie potwierdzać co sześć miesięcy.',
      placeTenant: 'Zachowaj całą przestrzeń roboczą',
      empty: 'Brak aktywnego obowiązku zachowania.',
      lapsedNotice: 'Obowiązki z przekroczoną datą potwierdzenia: {count}. Nadal blokują usunięcie — potwierdź je lub znieś.',
      scopeTenant: 'Cała przestrzeń robocza',
      scopeSubject: 'Jedna osoba',
      lapsed: 'Potwierdzenie zaległe',
      placedAt: 'Ustanowiony',
      attestationDue: 'Potwierdzić do',
      basis: 'Podstawa prawna',
      attest: 'Nadal potrzebny',
      attestConfirm: {
        title: 'Utrzymać ten obowiązek?',
        body: 'Potwierdzasz, że powód obowiązku zachowania nadal istnieje. Pozostaje w mocy przez kolejne sześć miesięcy.',
        confirm: 'Utrzymaj obowiązek',
      },
      release: {
        open: 'Znieś',
        title: 'Znieś obowiązek zachowania',
        warning: 'Od teraz dane chronione tym obowiązkiem mogą zostać usunięte — na podstawie otwartych wniosków, zasad przechowywania lub usunięcia przestrzeni roboczej. Tego nie można cofnąć.',
        reasonLabel: 'Dlaczego obowiązek nie jest już potrzebny?',
        reasonHint: 'Zostanie zapisany z Twoim nazwiskiem.',
        submit: 'Znieś obowiązek',
        errorReason: 'Proszę podać powód zniesienia.',
      },
      place: {
        titleTenant: 'Zachowaj całą przestrzeń roboczą',
        titleSubject: 'Zachowaj dane tej osoby',
        bodyTenant: 'Dopóki obowiązuje, żadne dane tej przestrzeni roboczej nie mogą zostać usunięte — ani na podstawie wniosków, ani zasad przechowywania, ani usunięcia przestrzeni roboczej.',
        bodySubject: 'Dopóki obowiązuje, żadne dane osoby wskazanej w tym wniosku nie mogą zostać usunięte. Na wniosek i tak trzeba odpowiedzieć w terminie.',
        reasonLabel: 'Powód',
        reasonHint: 'Na przykład postępowanie sądowe lub żądanie organu, które wymaga zachowania danych.',
        basisLabel: 'Podstawa prawna (opcjonalnie)',
        basisHint: 'Krótkie odniesienie, na przykład przepis lub sygnatura akt.',
        submit: 'Ustanów obowiązek',
        errorReason: 'Proszę podać powód obowiązku zachowania.',
      },
      errors: {
        notActive: 'Ten obowiązek nie jest już aktywny — został w międzyczasie zmieniony. Lista została ponownie wczytana.',
      },
    },
    restrictions: {
      title: 'Ograniczenia przetwarzania',
      intro: 'Ograniczony rekord może być przechowywany, ale nie wykorzystywany (art. 18 RODO). Przed zniesieniem ograniczenia osoba musi zostać poinformowana.',
      empty: 'Żadne przetwarzanie nie jest ograniczone.',
      originSystem: 'Ustanowione po usunięciu',
      originRequest: 'Z wniosku',
      notified: 'Osoba poinformowana {date}',
      notNotified: 'Osoba jeszcze nie poinformowana',
      placedAt: 'Ograniczone od {date}',
      notifyOpen: 'Poinformuj osobę',
      notifyAgain: 'Zapisz nowe powiadomienie',
      lift: 'Znieś ograniczenie',
      liftConfirm: {
        title: 'Znieść ograniczenie?',
        body: 'Rekord może znów być wykorzystywany jak wcześniej. Osoba została poinformowana.',
        bodySystem: 'To ograniczenie zostało ustanowione automatycznie na tym, co zachowano po usunięciu danych osoby. Jego zniesienie sprawi, że te rekordy znów będzie można edytować i wykorzystywać. Znieś je tylko wtedy, gdy ograniczenie nie jest już potrzebne.',
        confirm: 'Znieś ograniczenie',
      },
      errors: {
        notActive: 'To ograniczenie nie jest już aktywne albo osoba nie została jeszcze poinformowana. Lista została ponownie wczytana.',
      },
      place: {
        title: 'Ogranicz przetwarzanie',
        body: 'Rekord osoby wskazanej w tym wniosku jest przechowywany, ale nie może być wykorzystywany do czasu zniesienia ograniczenia. Ograniczenie zostanie powiązane z tym wnioskiem.',
        reasonLabel: 'Powód',
        reasonHint: 'Na przykład: osoba kwestionuje prawidłowość danych.',
        submit: 'Ogranicz',
        errorReason: 'Proszę podać powód ograniczenia.',
      },
      notify: {
        title: 'Poinformuj osobę',
        body: 'Osoba musi zostać poinformowana przed zniesieniem ograniczenia (art. 18 ust. 3 RODO).',
        modeLabel: 'Jak osoba zostaje poinformowana?',
        modeSend: 'lumi wysyła e-mail',
        modeManual: 'Już poinformowana w inny sposób',
        manualOnly: 'To ograniczenie nie jest powiązane z żadnym wnioskiem, więc lumi nie zna adresu. Poinformuj osobę samodzielnie i zapisz to tutaj.',
        employerLabel: 'Pracodawca wskazany w e-mailu',
        employerHint: 'Osoba musi widzieć, kto ograniczył jej dane.',
        refLabel: 'Sygnatura',
        refHint: 'Jak ją poinformowano, na przykład „pismo z 3 maja” lub numer sprawy.',
        dateLabel: 'Poinformowana dnia',
        dateHint: 'Pozostaw puste dla dzisiejszej daty.',
        submitSend: 'Wyślij e-mail',
        submitManual: 'Zapisz powiadomienie',
        sendRefused: 'Nie udało się wysłać e-maila: wniosek nie zawiera adresu e-mail. Poinformuj osobę w inny sposób i zapisz to.',
        errorEmployer: 'Proszę podać pracodawcę.',
        errorRef: 'Proszę podać sygnaturę powiadomienia.',
      },
    },
    review: {
      title: 'Sprawdzenie kopii',
      intro: 'Tak osoba przeczyta swoją kopię. O każdym oznaczonym wpisie decydują Państwo osobno: zwolnić go lub zatrzymać (art. 15 ust. 4 RODO). Reszta jest tylko do odczytu.',
      back: 'Powrót do wniosków',
      counter: {
        undecided: 'Do rozstrzygnięcia pozostało {undecided} z {flagged} wpisów',
        allDecided: 'Wszystkie {flagged} oznaczone wpisy zostały rozstrzygnięte',
        noneFlagged: 'Żaden wpis nie jest oznaczony — kopię można zwolnić od razu',
      },
      modules: {
        people: 'Kadry',
        ats: 'Aplikacje',
        time: 'Czas pracy',
        apprentice: 'Szkolenie zawodowe',
      },
      moduleState: {
        notInstalled: 'Ten moduł nie należy do tej przestrzeni roboczej, więc nic tam nie jest przechowywane.',
        removed: 'Ten moduł został usunięty z przestrzeni roboczej; nic o tej osobie w nim nie zostało.',
        unavailable: 'Ten moduł był niedostępny podczas przygotowywania kopii — tego obszaru brakuje w kopii. Proszę ustawić wniosek na „Czekaj na osobę”, a potem ponownie na „Rozpocznij realizację” — wtedy lumi przygotuje kopię od nowa — albo zwolnić ją świadomie bez tego obszaru.',
      },
      moduleEmpty: 'Nie przechowuje się tu nic o tej osobie.',
      delivered: 'Doręczona — lumi za chwilę zamknie wniosek',
      self: {
        title: 'Ten wniosek dotyczy Pana/Pani osobiście',
        description: 'Kopię musi sprawdzić inna osoba odpowiedzialna za ochronę danych. Wniosek można zamiast tego rozpatrzyć ręcznie.',
      },
      unverified: 'lumi nie mógł teraz sprawdzić, czy ten wniosek dotyczy Pana/Pani osobiście. Proszę spróbować ponownie za chwilę.',
      sectionMeta: 'Przetwarzanie: {activity}',
      flagged: 'Oznaczony',
      flagReason: {
        written: 'Napisany przez kogoś innego o tej osobie lub wymienia inne osoby. Proszę rozważyć, czy osoba może przeczytać ten wpis.',
        generic: 'Może zawierać informacje o innych osobach lub pochodzić od innych osób. Proszę rozważyć to według art. 15 ust. 4 RODO.',
      },
      state: {
        undecided: 'Jeszcze nie rozstrzygnięty',
        release: 'Zostanie zwolniony',
        withhold: 'Zostanie zatrzymany',
      },
      decision: {
        group: 'Decyzja dotycząca wpisu w sekcji „{section}”',
        release: 'Zwolnij',
        withhold: 'Zatrzymaj',
        changeReason: 'Zmień powód',
        reasonLabel: 'Powód dla osoby',
        reasonHint: 'Osoba przeczyta ten powód w swojej kopii. Proszę napisać go dla niej i nie powtarzać treści wpisu.',
        reasonSave: 'Zapisz jako zatrzymany',
        reasonRequired: 'Proszę podać powód.',
        saveError: 'Nie udało się zapisać decyzji. Wpis zachowuje poprzedni stan.',
      },
      release: {
        action: 'Zwolnij kopię',
        blocked: 'Najpierw proszę rozstrzygnąć pozostałe oznaczone wpisy ({undecided}), potem można zwolnić kopię.',
        confirmTitle: 'Zwolnić kopię?',
        confirmBody: 'lumi tworzy teraz kopię bez zatrzymanych wpisów ({withheld}), powiadamia osobę i zamyka wniosek.',
        confirmBodyNone: 'lumi tworzy teraz kopię, powiadamia osobę i zamyka wniosek.',
        confirmLabel: 'Zwolnij',
        done: 'Zwolniona — lumi doręcza kopię',
      },
      errors: {
        undecided: 'Nadal są otwarte oznaczone wpisy. Strona została wczytana ponownie.',
        expired: 'Kopia wygasła — lumi tworzy nową, wkrótce znowu ją tu Państwo zobaczą',
        closed: 'Wniosek nie jest już otwarty. Kopii nie można już zwolnić.',
      },
      notFound: {
        title: 'Żadna kopia tu nie czeka',
        description: 'Kopia wygasła lub została już doręczona. Jeśli wniosek jest nadal otwarty, lumi tworzy nową, którą wkrótce znowu zobaczą Państwo na liście.',
      },
    },
  },
  legalNotices: {
    title: 'Informacja o ochronie danych i AI dla pracowników',
    intro: 'Co ten workspace przekazuje swoim pracownikom na temat ochrony danych i wykorzystania AI w pracy.',
    titleLabel: 'Tytuł',
    contentLabel: 'Treść informacji',
    editMode: 'Edytuj',
    previewMode: 'Podgląd',
    state: {
      lumi: 'Tutaj jest aktualny tekst lumi.',
      own: 'Tutaj jest Twój własny tekst.',
      revisionCandidate: 'lumi zmieniła ten tekst. Dopóki go nie przyjmiesz, kandydaci nadal czytają dotychczasowy tekst.',
      revisionEmployee: 'lumi zmieniła ten tekst. Dopóki go nie przyjmiesz, pracownicy nadal czytają dotychczasowy tekst.',
      shownLumi: 'To dawny tekst lumi.',
      shownOwn: 'To Twój własny tekst.',
      unavailable: 'Aktualny tekst lumi nie może być teraz odczytany.',
    },
    editText: 'Dostosuj tekst',
    diffOwn: 'Różnice względem tekstu lumi',
    diffRevision: 'Zobacz różnice',
    diffHide: 'Ukryj różnice',
    returnToLumi: 'Wróć do tekstu lumi',
    takeRevision: 'Przyjmij',
    returnConfirm: { title: 'Wrócić do tekstu lumi?', body: 'Twój tekst zostanie w obu językach zastąpiony aktualnym tekstem lumi, z już wstawionymi danymi Twojego workspace.' },
    takeConfirm: { title: 'Przyjąć zmieniony tekst lumi?', body: 'Aktualny tekst lumi zastąpi tekst w obu językach. Twoje dane – nazwa firmy, adres i inne – pozostają wstawione.' },
    diff: {
      label: 'Różnice w tekście',
      legend: 'Zielone dochodzi wraz z aktualnym tekstem lumi, czerwone przekreślone odpada.',
      same: 'Brak różnic: tekst jest identyczny z aktualnym tekstem lumi.',
      unchanged: '… niezmienione akapity: {count} …',
      inserted: 'Dodano:',
      removed: 'Usunięto:',
    },
    adopted: 'Przyjęto tekst lumi.',
    saved: 'Zapisano.',
    noticeRequired: 'Informacji nie można zapisać pustej.',
    lumiVersionUnavailable: 'Nie udało się teraz pobrać aktualnego tekstu lumi — spróbuj ponownie za chwilę.',
    forbidden: 'Nie masz dostępu do tej informacji.',
    supportRefused: 'Sesja wsparcia nie obejmuje tej informacji.',
    membershipUnavailable: 'Nie udało się teraz sprawdzić Twoich uprawnień — spróbuj ponownie za chwilę.',
    loadFailed: 'Nie udało się wczytać informacji.',
    blanksOpenRefusal: 'Tekst nadal zawiera niewypełnione pola: {list}. Proszę uzupełnić je powyżej lub zastąpić własnym tekstem przed zapisaniem.',
    unsavedWarning: 'Nie zapisano jeszcze zmian w {name}.',
    demoDisclaimer: 'TO JEST WERSJA DEMONSTRACYJNA DLA FIKCYJNEJ FIRMY DEMONSTRACYJNEJ. TO NIE JEST DOKUMENT PRAWNIE WIĄŻĄCY.',
    blanks: {
      lead: 'Szablony lumi potrzebują od Pani/Pana tych informacji. Każdą wystarczy wpisać raz – zostanie wstawiona we wszystkich tekstach poniżej, w obu językach.',
      saved: 'Zapisano.',
      complete: 'Podano wszystkie wymagane informacje.',
      suggested: 'Przejęte z profilu firmy – prosimy sprawdzić i zapisać.',
      retentionOptions: { m3: '3 miesiące', m6: '6 miesięcy', m12: '12 miesięcy' },
      retentionLineMissing: 'Własny tekst w {locales} nie podaje już okresu przechowywania po odrzuceniu. Musi zawierać {words} – proszę edytować tekst i przywrócić to zdanie.',
      retentionInvalid: 'Proszę wybrać 3, 6 lub 12 miesięcy.',
      retentionAnonymises: 'Od tego wyboru lumi anonimizuje odrzucone aplikacje po upływie tego okresu, także już odrzucone. Anonimizacji nie można cofnąć.',
      quoted: '„{text}”',
      whyLabel: 'Dlaczego',
      whereLabel: 'Gdzie to się pojawia',
      keys: {
        company_name: {
          label: 'Nazwa firmy', hint: 'Nazwa prawna tego workspace, w formie, w jakiej ma się pojawić w informacji.',
          why: 'Informacja o ochronie danych musi wskazywać, kto odpowiada za dane.',
          where: 'W sekcji „Administrator” informacji dla kandydatów, w zdaniu kończącym informację o wykorzystaniu SI dla kandydatów oraz w sekcji „Administrator” informacji dla pracowników – czytają to kandydaci i pracownicy.',
        },
        company_address: {
          label: 'Adres firmy', hint: 'Adres pocztowy, pod którym pracownicy i kandydaci mogą się skontaktować.',
          why: 'Kto ma pytanie lub wniosek, musi móc skontaktować się z odpowiedzialną firmą pocztą.',
          where: 'Zaraz po nazwie firmy, w tych samych trzech miejscach.',
        },
        privacy_contact: {
          label: 'Kontakt ds. ochrony danych', hint: 'Do kogo zwrócić się w sprawie ochrony danych — imię i nazwisko, funkcja lub adres e-mail.',
          why: 'Osoby, których dane dotyczą, muszą wiedzieć, do kogo zwrócić się w sprawie ochrony danych i swoich praw.',
          where: 'W zdaniu „W sprawach ochrony danych można kontaktować się z …” w informacji dla kandydatów i w informacji dla pracowników oraz w akapitach o prawach we wszystkich trzech tekstach – czytają to kandydaci i pracownicy.',
        },
        applicant_retention: {
          label: 'Okres przechowywania po odrzuceniu', hint: 'To samo ustawienie co ATS ▸ Ochrona danych ▸ Automatyczna anonimizacja: lumi anonimizuje odrzucone aplikacje po tym okresie, więc informacja może obiecywać tylko to, co robi produkt.',
          why: 'Informacja bez okresu nikogo nie informuje. Dopóki okres nie zostanie wybrany, informacja o ochronie danych dla kandydatów jest uznawana za niekompletną, a portal kariery pozostaje offline.',
          where: 'W zdaniu „Przechowywanie po odrzuceniu: …” informacji dla kandydatów – czytają je kandydaci. Później można ją zmienić na tej stronie lub w ATS ▸ Ochrona danych.',
        },
      },
    },
    // The page's two-step checklist (issue 766): the facts form, then the imprint.
    checklist: {
      title: 'Aby teksty prawne były kompletne',
      progress: 'Ukończono {done} z {total}',
      facts: { title: 'Dane do wszystkich tekstów', hint: 'Nazwa firmy, adres, kontakt ds. ochrony danych i inne – wstawiane w każdy tekst poniżej.' },
      imprintAction: 'Uzupełnij notę prawną',
    },
    candidate: {
      heading: 'Informacje dla kandydatów',
      intro: 'Informacje prawne, które ten obszar roboczy pokazuje kandydatom w portalu kariery.',
      unavailable: 'Informacje dla kandydatów są teraz niedostępne.',
      noticeRequired: 'Ta informacja jest pokazywana kandydatom i nie może być pusta. Proszę zastąpić tekst albo przejąć wersję lumi.',
      imprintRequired: 'Noty prawnej nie można wyczyścić, dopóki portal jest online. Proszę zastąpić tekst zamiast go usuwać.',
      retentionLineRequired: 'Informacja musi podawać okres przechowywania po odrzuceniu. Pochodzi on z ustawienia usuwania – proszę zachować „{words}” w tekście.',
      privacy: {
        title: 'Polityka prywatności najemcy',
        subtitle: 'Ta wersja jest wyświetlana na portalu dla kandydatów.',
      },
      aiUsage: {
        title: 'Informacja o wykorzystaniu SI dla kandydatów',
        subtitle: 'Ten tekst jest wyświetlany kandydatom na portalu kariery.',
      },
      imprint: {
        title: 'Nota prawna portalu kariery',
        subtitle: 'Ten tekst jest linkowany z każdej strony portalu.',
        hint: 'Nota prawna jest wymagana przez prawo (§ 5 DDG). Portal kariery pozostaje offline, dopóki nie zostanie zapisana w jakimkolwiek języku.',
        fallsBack: 'Nota prawna jest zapisana. Języki bez własnej noty prawnej pokazują w portalu wersję {language}.',
      },
      history: {
        title: 'Co pokazywaliśmy w danym dniu?',
        hint: 'Wyszukanie dokładnego tekstu, który znajdował się na tej stronie w wybranym momencie w przeszłości — na pytanie kandydata lub organu nadzorczego.',
        open: 'Wyszukaj',
        hide: 'Zamknij',
        dateLabel: 'Data i godzina',
        localeLabel: 'Język',
        lookUp: 'Pokaż tekst',
        periodClosed: 'Opublikowane od {from} do {until}.',
        periodOpen: 'Opublikowane od {from} — nadal aktualny tekst.',
        sourceLumi: 'Opublikowana przez lumi wersja {version}, słowo w słowo.',
        sourceLumiUnversioned: 'Tekst opublikowany przez lumi.',
        sourceTenant: 'Własny tekst tego obszaru roboczego, odgałęziony od wersji {version} lumi.',
        sourceTenantOwn: 'Własny tekst tego obszaru roboczego.',
        none: 'Zapis nie sięga tak daleko wstecz.',
        provenanceFollowing: 'Wiadomo tyle: ta strona jest kopią wersji {version} lumi i nikt jej tutaj nie nadpisał.',
        provenanceBranched: 'Wiadomo tyle: ta strona pochodzi z wersji {version} lumi i została nadpisana {date}.',
        provenanceUnknown: 'O wcześniejszym okresie nie zapisano nic więcej na temat tej strony.',
        futureRefused: 'Ten zapis mówi, co strona pokazywała, a nie co pokaże. Proszę wybrać moment, który już minął.',
        invalidRefused: 'Proszę wybrać datę i język wyszukiwania.',
        failed: 'Nie udało się teraz odczytać zapisu. Proszę spróbować ponownie.',
      },
    },
  },
  legalNoticePublic: {
    unavailable: 'Ta informacja jest obecnie niedostępna.',
  },
  dataImportHub: {
    segments: {
      import: 'Import',
      export: 'Eksport',
      label: 'Import lub eksport',
    },
    umzug: {
      label: 'Twoja migracja',
      from: 'Migracja z',
      pick: 'Wybierz migrację',
      files: 'Plików: {count}, ostatni {when}',
      startNew: 'Nowa migracja',
      nameIntro: 'Migracja łączy pliki pochodzące z tego samego systemu. Nadaj jej nazwę, najlepiej nazwę dawnego systemu.',
      nameLabel: 'Nazwa dawnego systemu',
      nameHint: 'Małe litery, cyfry, łącznik i podkreślnik; nic więcej nie jest zapisywane.',
      namePlaceholder: 'np. personio',
      begin: 'Rozpocznij migrację',
      nameReserved: 'Lumi nie może użyć tej nazwy. Wybierz inną.',
      together: 'Pliki jednej migracji należą do siebie: późniejsze znajdują to, co utworzyły wcześniejsze. Najpierw podstawy, potem to, co na nich się opiera.',
    },
    order: 'Kolejność migracji',
    entries: {
      orgUnits: {
        title: 'Działy i lokalizacje',
        description: 'Działy, zespoły, lokalizacje i miejsca powstawania kosztów z dawnego systemu.',
        reason: 'Działy i lokalizacje są podstawą wszystkiego innego.',
      },
      persons: {
        title: 'Pracownicy',
        description: 'Wszyscy, którzy u Ciebie pracują, z danymi podstawowymi, działem i przełożonym.',
        reason: 'Pracownicy są potrzebni do umów, czasu pracy i nieobecności.',
      },
      contracts: {
        title: 'Umowy',
        description: 'Umowy o pracę pracowników.',
        needs: 'potrzebuje pracowników',
        reason: 'Umowy są powiązane z pracownikami.',
      },
      ats: {
        title: 'Stanowiska, kandydaci i aplikacje',
        description: 'Otwarte i dawne stanowiska wraz z kandydatami i aplikacjami.',
        needs: 'potrzebuje działów i lokalizacji',
        reason: 'Stanowiska odwołują się do Twoich lokalizacji.',
      },
      time: {
        title: 'Klienci, projekty, czas pracy i nieobecności',
        description: 'Klienci, projekty, zapisany czas pracy i nieobecności.',
        needs: 'potrzebuje pracowników',
        reason: 'Czas pracy i nieobecności należą do pracowników.',
      },
    },
    state: {
      next: 'Następne w kolejności.',
      imported: 'Zaimportowano: {count} · {file} · {when}',
      importedMany: 'Zaimportowano: {count} · plików: {files} · ostatni {when}',
      unfinished: 'Rozpoczęte plikiem {file}',
    },
    actions: {
      resume: 'Kontynuuj',
      supplement: 'Uzupełnij',
      continueHere: 'Kontynuuj od tego',
    },
    drop: {
      title: 'Przeciągnij plik tutaj lub wybierz',
      hint: 'CSV lub Excel; wystarczy eksport z dawnego systemu.',
      after: 'Potem:',
      savedLast: 'nic nie jest zapisywane przed ostatnim krokiem',
    },
    ai: {
      label: 'Lumi poprawia dopasowanie',
      infoLabel: 'Co trafia do Lumi',
      infoSent: 'Do AI trafiają tylko nazwy kolumn i co najwyżej 20 przykładowych wartości na kolumnę. Z kolumn, których nazwa wskazuje na dane wrażliwe, nie trafiają żadne wartości.',
      infoProposal: 'Wynik jest tylko propozycją: każde dopasowanie sprawdzasz i potwierdzasz samodzielnie.',
      infoQuota: 'Poprawa wlicza się do Twojego limitu AI.',
      quotaUsedUp: 'Brak limitu AI do {date}.',
      quotaUsedUpNoDate: 'Brak limitu AI w tym okresie.',
      suspended: 'Lumi jest wyłączony w tej przestrzeni roboczej.',
      raise: 'Zwiększ limit',
      withoutQuota: 'Według reguł',
    },
    lock: {
      body: 'W {module} brakuje Ci uprawnienia {permission}. Należy ono do roli {role}; sam administrator pakietu nie wystarcza. Nadaje je w module Kadry, w sekcji {where}, osoba z rolą: {granters}.',
      permissionImport: 'Importowanie danych',
      permissionExport: 'Eksportowanie danych',
      accessPage: 'Uprawnienia i przypisania',
      adminRole: 'Administrator modułu {module}',
      granters: 'właściciel lub administrator pakietu',
      askSomeone: 'Poproś o to osobę z rolą: {role}.',
      grantSelf: 'Nadaj mi to (Kadry → Uprawnienia i przypisania)',
      mayManage: 'Możesz zarządzać dostępem.',
    },
    lists: {
      imports: 'Importy w tej migracji ({count})',
      others: 'Inne migracje ({count})',
      show: 'Pokaż',
      hide: 'Ukryj',
      noImports: 'W tej migracji nic jeszcze nie zaimportowano.',
      noOthers: 'Brak innych migracji.',
      retention: 'Pliki i raporty są usuwane 30 dni po imporcie; przejęte dane pozostają.',
      report: 'Raport',
      delete: 'Usuń',
      switchTo: 'Przełącz',
      you: 'Ty',
      columns: {
        file: 'Plik',
        entry: 'Pozycja',
        result: 'Wynik',
        when: 'Kiedy',
        by: 'Przez',
      },
    },
    result: {
      done: 'Przejęto',
      review: 'Do sprawdzenia',
      questions: 'Otwarte pytania',
      reading: 'Odczyt',
      checking: 'Sprawdzanie',
      committing: 'Przejmowanie',
      cancelled: 'Anulowano',
      failed: 'Niepowodzenie',
      created: 'nowych: {count}',
      updated: 'zaktualizowanych: {count}',
      unchanged: 'bez zmian',
      toClarify: 'do wyjaśnienia: {count}',
    },
    done: {
      headline: 'Dotarło do modułu {module}: {count} ({things}).',
      headlineRecords: 'Dotarło do modułu {module}: rekordów {count}.',
      numbers: 'Utworzono: {created} · zaktualizowano: {updated}',
      notImported: 'Wiersze nieprzejęte: {count}',
      leftOut: 'Wiersze pominięte: {count}',
      downloadList: 'Pobierz listę',
      laterHint: ' (później nie będzie już dostępna)',
      skipped: 'Wiersze pominięte bez zmian: {count}',
      soFar: 'Dotychczasowy postęp',
      rowsIn: 'Zaimportowano: {count}',
      asNext: 'Następne w kolejności: {reason}',
      whatNext: 'Co dalej?',
      nextTitle: 'Dalej: {entry}',
      nextAction: 'Następny plik',
      orgChartTitle: 'Zobacz schemat organizacyjny',
      orgChartBody: 'Sprawdź, czy działy i przełożeni dotarli tak, jak je znasz.',
      orgChartBuildTitle: 'Zbuduj schemat organizacyjny',
      orgChartBuildBody: 'Na razie każda osoba jest własnym przełożonym. Kto komu podlega, ustawia się teraz w module Kadry.',
      accessTitle: 'Nadaj dostęp',
      accessBody: 'Pracownicy są, ale nikt jeszcze nie może się zalogować. Dostęp nadaje się w module Kadry.',
      openPeople: 'Otwórz w module Kadry',
    },
    export: {
      title: 'Eksport',
      intro: 'Wyprowadź swoje dane z modułu. Każdy eksport działa w ramach Twoich uprawnień w tym module.',
      covers: {
        people: 'Pracownicy, działy, umowy',
        ats: 'Stanowiska, kandydaci, aplikacje',
        time: 'Klienci, projekty, czas pracy, nieobecności',
      },
      locked: 'W {module} brakuje Ci uprawnienia {permission}. Należy ono do roli {role}.',
      last: 'Ostatni eksport {when} · pozycji: {count}',
      none: 'Jeszcze nie eksportowano.',
      past: 'Dotychczasowe eksporty',
      columns: {
        module: 'Moduł',
        by: 'Przez',
      },
      standard: 'Eksport standardowy',
      expired: 'Wygasły',
      archive: '{whole} znajdziesz w: {link}.',
      archiveWhole: 'Cały zbiór danych przestrzeni roboczej',
    },
    run: {
      breadcrumb: 'Migracja z {umzug} › {entry} · {file}',
    },
    nav: 'Import danych',
    title: 'Import i eksport danych',
    locked: 'Brak uprawnień w tym module',
    plan: {
      failed: 'Nie udało się utworzyć dodatkowych danych.',
      companionErrors: 'Podczas tworzenia dodatkowych danych wystąpiły błędy. Proszę sprawdzić je w samym module.',
      projectionTimeout: 'Dodatkowe dane nie dotarły jeszcze do modułu docelowego. Proszę spróbować ponownie później.',
    },
    createField: {
      title: 'Utwórz nowe pole niestandardowe',
      intro: 'Utwórz pole niestandardowe dla kolumny „{column}”. Będzie dostępne w całym ATS.',
      typeHint: 'Pola wyboru (select/wielokrotny wybór) tworzy się w zarządzaniu polami.',
      sensitiveNotImportable: 'Pola kategorii szczególnych (art. 9) są tworzone, ale celowo nie są celem importu.',
      submit: 'Utwórz pole',
      label: 'Etykieta',
      keyLabel: 'Klucz pola (Key)',
      keyHint: 'Tylko małe litery, cyfry i podkreślenia',
      typeLabel: 'Typ',
      types: {
        text: 'Tekst',
        textarea: 'Pole tekstowe',
        number: 'Liczba',
        date: 'Data',
        checkbox: 'Pole wyboru',
      },
      sensitivityLabel: 'Jakiego rodzaju dane zawiera to pole?',
      sensitivityUnanswered: 'Proszę wybrać',
      sensitivityNone: 'Brak szczególnej kategorii',
      sensitivityHint: 'Dane szczególnych kategorii (art. 9 RODO) nie mogą wywoływać zautomatyzowanych decyzji w sprawie aplikacji.',
      sensitivityCategories: {
        racialEthnic: 'Pochodzenie rasowe lub etniczne',
        politicalOpinion: 'Poglądy polityczne',
        religiousPhilosophical: 'Przekonania religijne lub światopoglądowe',
        tradeUnion: 'Przynależność do związków zawodowych',
        genetic: 'Dane genetyczne',
        biometricId: 'Identyfikacja biometryczna',
        health: 'Dane dotyczące zdrowia',
        sexLifeOrientation: 'Życie seksualne lub orientacja seksualna',
      },
      sensitivityRequired: 'Proszę wskazać, jakiego rodzaju dane zawiera to pole.',
    },
    entities: {
      person: 'Pracownicy',
      orgUnit: 'Jednostki org.',
      employmentContract: 'Umowy',
      job: 'Stanowiska',
      candidate: 'Kandydaci',
      application: 'Aplikacje',
      client: 'Klienci',
      project: 'Projekty',
      timeEntry: 'Wpisy czasu',
      leaveRequest: 'Nieobecności',
    },
    // People's enum values in the words People uses for them (people-ui's own
    // labels): the import wizard names allowed values with these.
    peopleValues: {
      gender: {
        male: 'Mężczyzna',
        female: 'Kobieta',
        diverse: 'Inna',
        undisclosed: 'Nie podano',
      },
      maritalStatus: {
        single: 'Stanu wolnego',
        married: 'W związku małżeńskim',
        divorced: 'Rozwiedziony/a',
        widowed: 'Owdowiały/a',
        registered_partnership: 'Związek partnerski',
        separated: 'W separacji',
      },
      contractType: {
        permanent: 'na czas nieokreślony',
        fixed_term: 'na czas określony',
        mini_job: 'mini-job',
        midi_job: 'midi-job (strefa przejściowa)',
        working_student: 'student pracujący',
        apprenticeship: 'nauka zawodu',
        internship: 'staż',
        freelance: 'współpraca / umowa o dzieło',
        managing_director: 'dyrektor zarządzający / członek zarządu',
        other: 'inna',
      },
      workTimeArrangement: {
        full_time: 'pełny etat',
        part_time: 'niepełny etat',
        marginal: 'marginalne (mini-job)',
        variable: 'zmienny / elastyczny',
      },
      status: {
        draft: 'Szkic',
        active: 'Aktywna',
        on_hold: 'Wstrzymana',
        terminated: 'Zakończona',
        inactive: 'Nieaktywny',
      },
      type: {
        department: 'Dział',
        location: 'Lokalizacja',
        team: 'Zespół',
        cost_center: 'Centrum kosztów',
      },
    },
    // People's import fields in People's own words (people-ui's labels), per
    // entity: the wizard's row errors name a field with these, never by its key.
    peopleFields: {
      orgUnit: {
        externalId: 'Identyfikator zewnętrzny',
        type: 'Typ',
        name: 'Nazwa',
        code: 'Kod',
        description: 'Opis',
        parentExternalId: 'Jednostka nadrzędna',
        parentCode: 'Jednostka nadrzędna (Kod)',
        addressLine1: 'Adres',
        postalCode: 'Kod pocztowy',
        city: 'Miasto',
        country: 'Kraj',
        active: 'Aktywny',
      },
      person: {
        externalId: 'Identyfikator zewnętrzny',
        employeeNumber: 'Numer pracownika',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        salutation: 'Forma grzecznościowa',
        gender: 'Płeć',
        email: 'E-mail',
        phone: 'Telefon',
        birthDate: 'Data urodzenia',
        nationality: 'Obywatelstwo',
        maritalStatus: 'Stan cywilny',
        addressLine1: 'Adres',
        addressLine2: 'Dodatkowe informacje adresowe',
        postalCode: 'Kod pocztowy',
        city: 'Miasto',
        country: 'Kraj',
        workCountry: 'Miejsce pracy (kraj)',
        primaryLocale: 'Język',
        status: 'Status',
        primaryOrgUnitExternalId: 'Dział / jednostka',
        primaryOrgUnitCode: 'Dział / jednostka (Kod)',
        supervisorExternalId: 'Przełożony funkcjonalny',
      },
      employmentContract: {
        externalId: 'Identyfikator zewnętrzny',
        personExternalId: 'Osoba',
        contractReference: 'Numer umowy',
        status: 'Status umowy',
        startDate: 'Data rozpoczęcia',
        endDate: 'Data zakończenia',
        probationEndDate: 'Koniec okresu próbnego',
        contractType: 'Rodzaj umowy',
        position: 'Stanowisko / funkcja',
        primaryOrgUnitExternalId: 'Dział / jednostka',
        supervisorExternalId: 'Przełożony',
        workTimeArrangement: 'Wymiar czasu pracy',
        weeklyHours: 'Godziny tygodniowo',
        vacationDaysPerYear: 'Urlop (dni/rok)',
        collectiveAgreementCode: 'Układ zbiorowy pracy',
      },
    },
    // The ATS import's fields in the ATS UI's own words, per entity (the guided import,
    // issue 1063): the mapping step and the row errors name a field with these, never
    // by its key. Every key of ats-api's import-descriptor.ts has one in every locale.
    atsFields: {
      job: {
        externalId: 'Identyfikator zewnętrzny',
        title: 'Nazwa stanowiska',
        departmentName: 'Dział',
        locationName: 'Lokalizacja',
        state: 'Status',
        headcount: 'Liczba etatów',
        employmentType: 'Rodzaj zatrudnienia',
        requiredSkills: 'Wymagane umiejętności',
      },
      candidate: {
        externalId: 'Identyfikator zewnętrzny',
        firstName: 'Imię',
        lastName: 'Nazwisko',
        email: 'E-mail',
        phone: 'Telefon',
        skills: 'Umiejętności',
        availableFrom: 'Dostępny od',
        noticePeriodDays: 'Okres wypowiedzenia (dni)',
        remotePreference: 'Preferowane miejsce pracy',
        salaryExpectation: 'Oczekiwania płacowe (rocznie)',
        seniority: 'Poziom doświadczenia',
        poolTags: 'Tagi puli talentów',
      },
      application: {
        externalId: 'Identyfikator zewnętrzny',
        candidateExternalId: 'Kandydat',
        jobExternalId: 'Stanowisko',
        state: 'Etap',
        appliedAt: 'Data aplikacji',
        note: 'Notatka',
      },
    },
    // The ATS descriptor's fixed enum values in the ATS UI's words (the workflow states and
    // the department/location names are the workspace's own and need none).
    atsValues: {
      remotePreference: {
        onsite: 'Na miejscu',
        hybrid: 'Hybrydowo',
        remote: 'Zdalnie',
      },
      seniority: {
        junior: 'Junior',
        mid: 'Mid',
        senior: 'Senior',
        lead: 'Lead',
      },
    },
    // Time's import fields in Time's own words, per entity (see atsFields).
    timeFields: {
      client: {
        externalId: 'Identyfikator zewnętrzny',
        name: 'Nazwa',
        isInternal: 'Wewnętrzny',
      },
      project: {
        externalId: 'Identyfikator zewnętrzny',
        name: 'Nazwa projektu',
        clientExternalId: 'Klient',
        externalRef: 'Numer referencyjny projektu',
        description: 'Opis',
        status: 'Status',
        isBillable: 'Rozliczalny',
        hourlyRate: 'Stawka godzinowa',
        budgetHours: 'Budżet godzin',
      },
      timeEntry: {
        externalId: 'Identyfikator zewnętrzny',
        userEmail: 'E-mail osoby',
        personnelNumber: 'Numer pracownika',
        date: 'Data',
        startTime: 'Godzina rozpoczęcia',
        endTime: 'Godzina zakończenia',
        durationMinutes: 'Czas trwania (minuty)',
        bookingType: 'Rodzaj wpisu',
        projectExternalId: 'Projekt',
        activity: 'Czynność',
        note: 'Notatka',
        status: 'Status',
      },
      leaveRequest: {
        externalId: 'Identyfikator zewnętrzny',
        userEmail: 'E-mail osoby',
        personnelNumber: 'Numer pracownika',
        leaveType: 'Rodzaj nieobecności',
        startDate: 'Od',
        endDate: 'Do',
        status: 'Status',
        note: 'Notatka',
      },
    },
    // Time's enum values. `status` is shared by projects, time entries and absences, so it
    // carries the union of their values (the value maps are keyed by field, per module).
    timeValues: {
      status: {
        active: 'Aktywna',
        closed: 'Zamknięty',
        paused: 'Wstrzymany',
        completed: 'Zakończony',
        archived: 'Zarchiwizowany',
        draft: 'Wersja robocza',
        submitted: 'Przesłany',
        approved: 'Zatwierdzony',
        pending: 'Oczekujący',
        rejected: 'Odrzucony',
      },
      leaveType: {
        vacation: 'Urlop wypoczynkowy',
        special: 'Urlop okolicznościowy',
        parental: 'Urlop rodzicielski',
        unpaid: 'Urlop bezpłatny',
        training: 'Szkolenie',
      },
    },
  },
  // ── Tenant administration (#432): the five pages that used to be their own
  //     app. Merged verbatim from its catalogue, so the strings are unchanged.
  audit: {
    title: 'Audit Log', subtitle: 'Who did what in your workspace.',
    noAccess: 'No access', noAccessHint: 'You need the audit log permission to view this page.',
    empty: 'No audit events yet', emptyHint: 'Actions in your workspace will appear here.',
    loading: 'Loading…', loadMore: 'Load more',
    filters: { from: 'From', to: 'To', action: 'Action', category: 'Category', actor: 'Actor', outcome: 'Outcome', search: 'Search', searchHint: 'Subject or actor…', apply: 'Apply', reset: 'Reset', all: 'All', actorType: 'Typ podmiotu' },
    columns: { time: 'Time', actor: 'Actor', action: 'Action', subject: 'Subject', outcome: 'Outcome' },
    outcome: { success: 'Success', denied: 'Denied', failure: 'Failure' },
    actorType: { user: 'User', system_admin: 'System Admin', support: 'Support', service: 'Service', system: 'System' },
    categories: { auth: 'Auth', access: 'Access', data: 'Data', admin: 'Admin', lifecycle: 'Lifecycle', export: 'Export', security: 'Security' },
    export: { csv: 'Export CSV', ndjson: 'Export NDJSON' },
    detail: { roles: 'Role', action: 'Action', actorId: 'Actor ID', onBehalfOf: 'On behalf of', ip: 'IP address', source: 'Source', correlationId: 'Correlation ID', changes: 'Changes', before: 'Before', after: 'After', details: 'Details' },
    actions: { login: { succeeded: 'Login succeeded', failed: 'Login failed', attempts_flagged: 'Powtarzające się nieudane próby logowania', locked: 'Konto zablokowane' }, sso: { login_succeeded: 'SSO login succeeded', connection_changed: 'SSO connection changed' }, password: { reset_requested: 'Password reset requested', reset_completed: 'Password reset completed' }, refresh_token: { revoked: 'Session revoked' }, user: { signed_up: 'User signed up', unlocked: 'Konto odblokowane', disabled: 'Konto wyłączone', enabled: 'Konto włączone', closed: 'Konto zamknięte' }, passkey: { revoked: 'Klucze dostępu usunięte przez administratora' }, role: { changed: 'Role changed' }, module_access: { changed: 'Module access changed' }, access: { ownership_transferred: 'Własność przekazana', member_removed: 'Członek usunięty', suite_roles_changed: 'Zmieniono role Suite' }, tenant: { created: 'Utworzono tenanta', lifecycle: 'Tenant lifecycle change', exported: 'Wyeksportowano tenanta' }, module: { activated: 'Module activated', deactivated: 'Module deactivated' }, plan: { changed: 'Plan changed' }, tenant_ai_settings: { changed: 'Zmieniono ustawienia AI' }, tenant_role_editing: { changed: 'Zmieniono edycję ról' }, settings: { changed: 'Settings changed' }, test_data: { seeded: 'Test data seeded', reset: 'Test data reset' }, onboarding: { setup_chosen: 'Wybrano konfigurację', demo_started: 'Uruchomiono tryb demo', demo_seeded: 'Utworzono dane demo', demo_seed_failed: 'Nie udało się utworzyć danych demo', demo_wipe_started: 'Rozpoczęto usuwanie danych demo', demo_wiped: 'Usunięto dane demo', demo_wipe_failed: 'Nie udało się usunąć danych demo', setup_finished: 'Zakończono konfigurację', demo_denied: 'Odmowa trybu demo', module_topup: 'Dodano dane demo dla nowego modułu', demo_reset_started: 'Rozpoczęto resetowanie demo', demo_tier_switch_started: 'Rozpoczęto przejście na pełne demo', demo_rebuilt: 'Odbudowano demo' }, company_profile: { created: 'Utworzono profil firmy', updated: 'Zaktualizowano profil firmy' }, org_scenario: { activated: 'Aktywowano scenariusz organizacyjny' }, people_data: { wiped: 'Usunięto dane kadrowe' }, ats_data: { wiped: 'Usunięto dane rekrutacyjne' }, time_data: { wiped: 'Usunięto dane ewidencji czasu pracy' }, apprentice_data: { wiped: 'Usunięto dane szkoleniowe' }, audit_log: { exported: 'Audit log exported' }, billing_charge: { paid: 'Płatność obciążona', failed: 'Płatność nieudana', refunded: 'Płatność zwrócona', chargeback: 'Otrzymano obciążenie zwrotne' }, invoice: { issued: 'Faktura wystawiona' }, mandate: { created: 'Dodano kartę', replaced: 'Wymieniono kartę' }, promo_code: { redeemed: 'Kod promocyjny wykorzystany' }, billing_account: { converted: 'Okres próbny zmieniony na płatny', delinquent: 'Konto zaległe', purged: 'Dane rozliczeniowe usunięte' }, dunning_case: { opened: 'Rozpoczęto windykację' }, enforcement: { opened: 'Rozpoczęto egzekwowanie', advanced: 'Egzekwowanie zaostrzone', cleared: 'Egzekwowanie zniesione' }, billing_exempt: { changed: 'Zmieniono zwolnienie z opłat' }, billing_data: { wiped: 'Dane rozliczeniowe wymazane', generated: 'Wygenerowano testowe dane rozliczeniowe' }, checkout: { completed: 'Zakup zakończony', denied: 'Zakup odrzucony' }, job: { created: 'Utworzono stanowisko', updated: 'Zaktualizowano stanowisko', submitted: 'Przesłano stanowisko', archived: 'Zarchiwizowano stanowisko', deleted: 'Usunięto stanowisko' }, application: { created: 'Otrzymano aplikację', updated: 'Zaktualizowano aplikację', transitioned: 'Zmieniono status aplikacji', withdrawn: 'Wycofano aplikację', transferred: 'Przeniesiono aplikację na inne stanowisko', transfer_declined: 'Odrzucono przeniesienie aplikacji', rejected: 'Odrzucono aplikację', deleted: 'Usunięto aplikację', emailed: 'Wysłano e-mail w sprawie aplikacji' }, interview: { proposed: 'Zaproponowano terminy rozmowy', confirmed: 'Rozmowa kwalifikacyjna potwierdzona', cancelled: 'Rozmowa kwalifikacyjna odwołana' }, candidate: { anonymized: 'Zanonimizowano kandydata', emailed: 'Wysłano e-mail do kandydata', identity_changed: 'Zmieniono dane kandydata', identity_split: 'Wydzielono kandydata do osobnego profilu', identity_merged: 'Aplikację przeniesiono do kandydata z tym adresem' }, candidate_dossier: { accessed: 'Kandydat wyświetlił swoje dane' }, workflow: { deleted: 'Usunięto workflow', definition: { published: 'Opublikowano workflow' } }, task: { blocking_overridden: 'Pominięto zadanie blokujące', auto_cancelled: 'Zadanie anulowane automatycznie' }, support_access: { requested: 'Poproszono o dostęp wsparcia', approved: 'Dostęp wsparcia zatwierdzony', denied: 'Dostęp wsparcia odrzucony', revoked: 'Dostęp wsparcia zakończony', expired: 'Dostęp wsparcia wygasł', request_expired: 'Prośba o dostęp wsparcia wygasła' }, ai_action: { executed: 'Wykonano akcję AI' }, assistant_run: { proposed: 'lumi zaproponowała działanie', approved: 'Działanie lumi zatwierdzone', refused: 'Działanie lumi odrzucone', failed: 'Działanie lumi nie powiodło się' }, assistant_turn: { fanned_out: 'Żądanie lumi objęło kilka modułów' }, payroll_export_run: { created: 'Eksport płac rozpoczęty', completed: 'Eksport płac zakończony', failed: 'Eksport płac nieudany', downloaded: 'Eksport płac pobrany' }, payroll_period: { closed: 'Miesiąc płacowy zamknięty', reopened: 'Miesiąc płacowy ponownie otwarty' }, payroll_connection: { updated: 'Połączenie płacowe zmienione' }, payroll_master_data: { exported: 'Dane kadrowo-płacowe wyeksportowane' }, wage_type: { created: 'Składnik płacowy utworzony', updated: 'Składnik płacowy zaktualizowany', deleted: 'Składnik płacowy usunięty', starter_catalog_applied: 'Dodano standardowe składniki płacowe' }, wage_assignment: { created: 'Dodano składnik wynagrodzenia', updated: 'Zmieniono składnik wynagrodzenia', deleted: 'Usunięto składnik wynagrodzenia' }, one_time_payment: { created: 'Dodano płatność jednorazową', updated: 'Zmieniono płatność jednorazową', deleted: 'Usunięto płatność jednorazową' }, payslip: { filed: 'Odcinki płacowe zarchiwizowane' } },
  },
  sso: {
    title: 'Single Sign-On',
    subtitle: 'Proszę połączyć swojego dostawcę tożsamości (OIDC), aby Państwa zespół logował się za jego pomocą.',
    issuerUrl: 'URL wydawcy (OIDC discovery)',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    clientSecretKeep: 'Pozostaw puste, aby zachować zapisany sekret',
    label: 'Nazwa wyświetlana',
    allowedDomains: 'Dozwolone domeny e-mail (oddzielone przecinkami)',
    jitEnabled: 'Automatycznie twórz użytkowników przy pierwszym logowaniu (JIT)',
    jitDefaults: 'Domyślny dostęp do modułów dla nowych użytkowników',
    jitModulePlaceholder: 'Wybierz moduł',
    jitRoles: 'Role',
    jitCatalogUnreadable: 'Nie udało się odczytać ról tego modułu. Zapisane role pozostają bez zmian.',
    jitUnknownRole: '{key} (nieznana)',
    addJit: 'Dodaj moduł',
    remove: 'Remove',
    redirectUri: 'URI przekierowania (zarejestruj w swoim IdP)',
    copy: 'Kopiuj',
    test: 'Testuj połączenie',
    testOk: 'Discovery powiodło się.',
    testFailed: 'Test nie powiódł się',
    save: 'Zapisz',
    saved: 'Zapisano.',
    delete: 'Usuń połączenie',
    deleteConfirm: 'Na pewno usunąć to połączenie SSO?',
    enforce: 'Wymagaj logowania tylko przez SSO',
    enforceHint: 'Logowanie hasłem jest wyłączone dla wszystkich z wyjątkiem administratorów systemu i właściciela obszaru roboczego.',
    noConnection: 'Nie skonfigurowano jeszcze żadnego połączenia SSO.',
    deleted: 'Połączenie usunięte.',
    enforceEnabled: 'Logowanie jest teraz możliwe wyłącznie przez SSO.',
    enforceDisabled: 'Logowanie hasłem jest ponownie możliwe.',
    jitNeedsVerifiedDomain: 'Użytkownicy są tworzeni automatycznie tylko dla adresów w zweryfikowanej domenie.',
    domainsTitle: 'Domeny e-mail',
    domainsIntro: 'Domena liczy się przy logowaniu SSO dopiero wtedy, gdy udowodnisz, że należy do was: opublikuj ten rekord TXT w DNS domeny, a następnie go sprawdź. Konta już połączone nadal się w tym czasie logują.',
    domainStatus: { pending: 'Niezweryfikowana', verified: 'Zweryfikowana', legacy: 'Zweryfikuj wkrótce' },
    domainLegacyUntil: 'Zweryfikuj do {date}',
    domainRecordName: 'Nazwa rekordu (TXT)',
    domainRecordValue: 'Wartość rekordu',
    domainVerify: 'Sprawdź rekord',
    domainVerified: 'Domena {domain} jest zweryfikowana.',
    domainError: { record_not_found: 'Pod tą nazwą nie ma jeszcze rekordu TXT. Zmiany w DNS mogą chwilę potrwać.', value_mismatch: 'Rekord TXT istnieje, ale jego wartość się nie zgadza. Skopiuj wartość dokładnie.', dns_error: 'Zapytanie DNS nie powiodło się. Spróbuj ponownie za kilka minut.' },
  },  users: { seatLimit: { bookMore: 'Wszystkie {booked} zarezerwowane stanowiska użytkowników są zajęte. Prosimy zarezerwować co najmniej {required} stanowisk użytkowników, aby zaprosić kolejną osobę.', leaveFreelancer: 'Ten obszar roboczy działa w trybie freelancera: jedna osoba, jedno stanowisko. Wyjście z trybu freelancera oznacza rezerwację {required} stanowisk użytkowników i miejsce dla kolejnych osób.', notified: 'Wszystkie {booked} zarezerwowane stanowiska użytkowników są zajęte. Właściciel obszaru roboczego i Billing Managerowie mogą zarezerwować kolejne stanowiska.', cta: 'Zarezerwuj więcej stanowisk' }, removeSuccess: '{email} został usunięty z tego obszaru roboczego.', saveSuccess: 'Zmiany dostępu dla {email} zostały zapisane.', saveFailedFor: 'Nie udało się zapisać {targets} dla {email}: {reason}', saveFailedOthersSaved: 'Pozostałe zmiany zostały zapisane.', suiteRolesTarget: 'ról suite', unsaved: 'Niezapisane', defaultRoleHint: 'Domyślna rola dla zaproszeń wewnętrznych', refreshFailed: 'Nie udało się odświeżyć listy członków. Proszę odświeżyć stronę, aby zobaczyć zapisany stan.', title: 'Użytkownicy i przypisania', email: 'E-mail', suite: 'Suite', suiteSuiteAdmin: 'Admin', suiteSuiteAdminHint: 'Administrator obszaru roboczego: zarządza członkami, dostępem do modułów, SSO i bezpieczeństwem.', suiteBillingManager: 'Billing Manager', suiteBillingManagerHint: 'Może zarządzać rozliczeniami (faktury, karta, plan).', suiteSupportAgent: 'Support Agent', suiteSupportAgentHint: 'Obsługuje zgłoszenia wsparcia (odpowiadanie, eskalacja, zamykanie).', suiteDataProtection: 'Inspektor ochrony danych', suiteDataProtectionHint: 'Rozpatruje i zatwierdza wnioski osób, których dane dotyczą, oraz usunięcia danych, a także może przeglądać dane członków w każdym aktywnym module.', suiteOwnerLocked: 'Właściciel obszaru roboczego zawsze posiada rolę Admin.', saveFailed: 'Nie udało się zapisać przypisania', inviteSuccess: '{email} został pomyślnie zaproszony', invite: { titleInternal: 'Zaproś członka zespołu', titleExternal: 'Zaproś zewnętrznie', hintInternal: 'Automatycznie otrzymuje domyślną rolę w Czasie i Kadrach — kolejne role można nadać zaraz po zaproszeniu.', hintExternal: 'Brak domyślnych ról: bez roli ta osoba nie ma dostępu do żadnego modułu. Dostęp należy skonfigurować zaraz po zaproszeniu.', submit: 'Zaproś', sentTitle: 'Zaproszenie wysłane', sentLead: '{email} został(a) zaproszony(a) i widnieje jako Zaproszony.', sentBodyInternal: 'Ma już domyślną rolę w Czasie i Kadrach.', sentBodyExternal: 'Nadal bez ról — proszę skonfigurować dostęp tej osoby.', revoke: 'Wycofaj zaproszenie', moreRoles: 'Więcej ról', setupRoles: 'Skonfiguruj role', done: 'Gotowe', revokedTitle: 'Zaproszenie wycofane', revokedBody: '{email} został(a) usunięty(a) z obszaru roboczego. Link zaproszenia jest nieważny.' }, removeUser: 'Usuń', confirmRemove: 'Czy na pewno usunąć {email} z tego tenanta? Wszystkie przypisania modułów zostaną usunięte.', statusActive: 'Aktywny', statusInvited: 'Zaproszony', statusDisabled: 'Wyłączony', transferOwnership: 'Przekaż własność', transferTitle: 'Przekazanie własności obszaru roboczego', transferIntro: '{from} przekazuje ten obszar roboczy użytkownikowi {to}. Właściciel może być tylko jeden – po potwierdzeniu {from} przestaje nim być.', transferConsequences: 'Co się zmieni:', transferConsequenceBreakGlass: 'Awaryjne logowanie przy niedostępnym SSO przechodzi na {to}: gdy dostawca tożsamości nie działa, {to} nadal zaloguje się hasłem, a {from} już nie.', transferConsequenceOutgoing: '{from} zachowuje wszystkie posiadane role, w tym Admin — zmienia się tylko własność. {from} może zostać wyłączony/-a lub usunięty/-a jak każdy inny członek.', transferConsequenceSuiteAdmin: '{to} otrzyma rolę Admin, jeśli jeszcze jej nie ma. Nikt nie traci żadnej roli.', transferSsoWarning: '{email} loguje się przez SSO i nie ma hasła. Jeśli SSO będzie niedostępne, przejmowany dostęp awaryjny pozostanie bezużyteczny – hasło można ustawić w każdej chwili przez „Nie pamiętam hasła”.', transferBlockedPending: '{email} nie przyjął jeszcze zaproszenia. Musi to nastąpić przed przekazaniem własności.', transferBlockedDisabled: 'Konto {email} jest wyłączone. Proszę je włączyć przed przekazaniem własności.', transferConfirmFieldLabel: 'Proszę potwierdzić nowego właściciela', transferConfirmHint: 'Proszę wpisać {email}, aby odblokować przycisk.', transferSuccess: '{email} jest teraz właścicielem tego obszaru roboczego.', transferFailed: 'Nie udało się przekazać własności. Proszę spróbować ponownie.', transferErrorForbidden: 'Własność może przekazać wyłącznie obecny właściciel.', transferErrorNotMember: '{email} nie jest już członkiem tego obszaru roboczego.', transferErrorAlreadyOwner: '{email} jest już właścicielem tego obszaru roboczego.', transferErrorRaced: 'Właściciel zmienił się w trakcie tego przekazania. Proszę odświeżyć listę i spróbować ponownie.', transferErrorIneligible: '{email} nie może teraz przejąć własności. Proszę odświeżyć listę, aby zobaczyć aktualny status.', resendInvite: 'Wyślij zaproszenie ponownie', disable: 'Wyłącz', enable: 'Włącz', confirmDisable: 'Wyłączyć konto {email}? Użytkownik zostanie natychmiast wylogowany i nie będzie mógł się zalogować, dopóki konto nie zostanie ponownie włączone.', resendSuccess: 'Zaproszenie ponownie wysłane do {email}.', resendEmailFailed: 'Nie udało się wysłać wiadomości z zaproszeniem do {email}. Proszę spróbować ponownie.', disableSuccess: 'Konto {email} zostało wyłączone.', enableSuccess: 'Konto {email} zostało włączone.', inviteEmailFailed: 'Dodano {email}, ale nie udało się wysłać wiadomości z zaproszeniem. Można wysłać ją ponownie.', searchPlaceholder: 'Szukaj po adresie e-mail', rolesFilterPlaceholder: 'Filtruj według roli', clearRolesFilter: 'Wyczyść filtr', memberCount: '{count} członków', memberCountFiltered: '{shown} z {count} członków', inviteInternal: 'Zaproś', inviteExternal: 'Zaproś zewnętrznie', removeRoleFilter: 'Usuń rolę z filtra', columns: { account: 'Konto', status: 'Status', roles: 'Role' },moduleNames: { ats: 'Rekrutacja', time_tracking: 'Czas', people: 'Kadry', apprenticeship: 'Ausbildung' }, accessDenied: 'Brak dostępu', moreActions: 'Więcej działań dla {email}', noSearchResults: 'Żaden członek nie pasuje do „{query}”.', editSubtitle: 'Edytuj role i dostęp', suiteConfirmGrantTitle: 'Przyznać rolę suite?', suiteConfirmRevokeTitle: 'Odebrać rolę suite?', suiteConfirmMixedTitle: 'Zmienić role suite?', suiteConfirmLead: 'To zmienia się dla {email}:', suiteConfirmRemoved: 'Traci {role}.', suiteConfirmAccept: 'Tak, zapisz' },
  // The consent page of an agent connection (ADR 0103 rule 10, PDR 0035).
  connectAgent: {
    title: 'Połącz agenta AI',
    heading: 'Agent AI chce działać w Twoim imieniu',
    intro: 'Klient AI, który przedstawia się jako „{client}”, prosi o możliwość pracy w lumi w Twoim imieniu, w przestrzeni roboczej {workspace}.',
    fields: {
      client: 'Przedstawia się jako',
      redirectHost: 'Odeśle Cię do',
      website: 'Podana strona internetowa',
      workspace: 'W przestrzeni roboczej',
    },
    scopesHeading: 'Prosi o:',
    scope: {
      read: 'Odczyt tego, co widzisz w lumi',
      act: 'Proponowanie i wykonywanie działań w Twoim imieniu — każde działanie wymaga Twojego potwierdzenia',
      ask: 'Zadawanie pytań lumi',
    },
    meaning: {
      heading: 'Co oznacza „Zezwól”',
      asYou: 'Działa jako Ty, dokładnie z Twoimi uprawnieniami w tej przestrzeni roboczej — nigdy z większymi.',
      egress: 'Wszystko, co odczyta w lumi, trafia do dostawcy stojącego za „{client}”, poza lumi.',
      revocable: 'Możesz w każdej chwili zakończyć połączenie na stronie swojego konta.',
    },
    standing: {
      label: 'Wykonuj działania na moich własnych rekordach bez pytania za każdym razem',
      hint: 'Nigdy nie obejmuje rekordów innych osób ani niekorzystnych decyzji — wtedy pytanie pada zawsze. Możesz to zmienić w każdej chwili na stronie swojego konta.',
    },
    rolePins: {
      title: 'Rola w module',
      hint: 'Tam, gdzie masz więcej niż jedną rolę, wybierz tę, w której pracuje agent. Nigdy nie może zrobić więcej, niż ta rola pozwala.',
      default: 'Domyślnie w module ({rule})',
      defaultRule: {
        first_assigned: 'Twoja pierwsza przypisana rola',
        first_by_key: 'Twoja pierwsza rola według klucza',
        all_roles: 'wszystkie Twoje role razem',
      },
      modules: {
        ats: 'Rekrutacja',
        time: 'Czas',
        people: 'Kadry',
      },
      notHeld: 'Nie masz już wybranej roli w tym module. Wybierz ponownie.',
    },
    disabled: {
      title: 'Zewnętrzni agenci AI są wyłączeni w tej przestrzeni roboczej',
      body: 'Właściciel lub administrator może ich włączyć w sekcji Administracja → Zewnętrzni agenci AI. Do tego czasu możesz tylko odrzucić tę prośbę.',
    },
    actions: {
      allow: 'Zezwól',
      deny: 'Odrzuć',
    },
    returning: 'Wracasz do {client}…',
    invalid: {
      title: 'Ta prośba o logowanie jest już nieważna',
      hint: 'Rozpocznij połączenie ponownie w swoim kliencie AI.',
    },
  },
  // Administration › External AI agents (ADR 0103 rule 12, PDR 0035 rule 2).
  externalAgents: {
    title: 'Zewnętrzni agenci AI',
    cardTitle: 'Zewnętrzni agenci AI',
    noAccess: 'Brak dostępu',
    noAccessHint: 'Tylko właściciel przestrzeni roboczej i administratorzy pakietu mogą zmienić to ustawienie.',
    intro: 'Po włączeniu członkowie mogą połączyć własnego klienta AI — Claude Code, OpenClaw, … — i pozwolić mu działać w ich imieniu w tej przestrzeni roboczej.',
    points: {
      asMember: 'Agent działa dokładnie z uprawnieniami członka, który go połączył — nigdy z większymi.',
      confirmed: 'Każde proponowane przez niego działanie ten członek potwierdza, zanim zostanie wykonane.',
      adverse: 'Niekorzystne decyzje dotyczące innych osób zawsze wymagają panelu lumi; agent nigdy nie może ich potwierdzić.',
    },
    egress: {
      title: 'Dokąd trafiają dane członków',
      body: 'Wszystko, co odczyta agent, trafia do klienta AI połączonego przez członka — odbiorcy spoza łańcucha podmiotów przetwarzających lumi, wybranego przez Twoją przestrzeń roboczą i członka.',
      worksCouncil: 'To, czy członkowie mogą korzystać z takich klientów, jest Twoją decyzją jako pracodawcy — rozważ zaangażowanie rady pracowników.',
    },
    switchLabel: 'Pozwól członkom łączyć zewnętrznych agentów AI',
    saving: 'Zapisywanie…',
    activeConnections: 'Brak aktywnych połączeń. | 1 aktywne połączenie. | Aktywne połączenia: {n}.',
    offHint: 'Wyłączenie natychmiast kończy każde połączenie w tej przestrzeni roboczej.',
    roleNote: 'Tylko właściciel przestrzeni roboczej lub administrator pakietu może to zmienić.',
    savedOn: 'Zewnętrzni agenci AI są włączeni. Członkowie mogą teraz połączyć swojego klienta AI.',
    savedOff: 'Zewnętrzni agenci AI są wyłączeni. | Zewnętrzni agenci AI są wyłączeni. Zakończono 1 połączenie. | Zewnętrzni agenci AI są wyłączeni. Zakończone połączenia: {n}.',
    disableConfirm: {
      title: 'Wyłączyć zewnętrznych agentów AI?',
      body: 'Obecnie nie ma aktywnych połączeń; członkowie nie będą już mogli się łączyć. | To natychmiast zakończy 1 połączenie. | To natychmiast zakończy połączenia: {n}.',
      confirm: 'Wyłącz',
    },
  },
  supportAccess: {
    revokeConfirm: 'Dostęp wsparcia zostanie natychmiast zakończony. Zespół wsparcia traci dostęp do tej przestrzeni roboczej.',
    title: 'Dostęp wsparcia',
    subtitle: 'Tymczasowy, zatwierdzony przez Ciebie dostęp naszego wsparcia do Twojej przestrzeni.',
    noAccess: 'Brak dostępu',
    noAccessHint: 'Tylko właściciel przestrzeni i administratorzy suite mogą rozpatrywać te prośby.',
    empty: 'Nie poproszono o dostęp wsparcia',
    emptyHint: 'Gdy nasze wsparcie będzie potrzebowało dostępu do Twojej przestrzeni, prośba pojawi się tutaj.',
    pendingTitle: 'Otwarta prośba o dostęp',
    pendingIntro: '{supporter} prosi o {days} dni dostępu do tej przestrzeni.',
    activeTitle: 'Dostęp wsparcia jest aktywny',
    activeIntro: '{supporter} może obecnie pracować w tej przestrzeni.',
    historyTitle: 'Historia',
    revokeHint: 'Zakończenie działa w ciągu minuty.',
    expiringNow: 'Właśnie wygasa',
    remainingDays: 'pozostało {days} d {hours} godz.',
    remainingHours: 'pozostało {hours} godz. {minutes} min',
    remainingMinutes: 'pozostało {minutes} min',
    fields: {
      requestedAt: 'Poproszono',
      ticket: 'Zgłoszenie wsparcia',
      duration: 'Czas trwania',
      durationValue: '{days} dni',
      reason: 'Podany powód',
      approvedBy: 'Zatwierdzone przez',
      expiresAt: 'Wygasa',
      remaining: 'Pozostały czas',
      grantedModules: 'Przyznane role',
    },
    consent: { allRoles: 'Osoba ze wsparcia może przełączać się na każdą rolę oferowaną przez te moduły — widzi to, co widzą Twoi pracownicy, nie tylko widok administratora.', modulesHeading: 'Ten dostęp obejmuje:', via: 'przez {module}',
      heading: 'Na co wyrażasz zgodę',
      data: 'Wsparcie będzie mogło korzystać z danych tej przestrzeni we wszystkich aktywnych modułach, w tym z danych osobowych pracowników i kandydatów.',
      audited: 'Każda czynność jest zapisywana w dzienniku audytu i oznaczana jako działanie wsparcia.',
      duration: 'Dostęp kończy się automatycznie po {days} dniach.',
      revocable: 'Możesz go zakończyć w każdej chwili; działa to w ciągu minuty.',
    },
    actions: { approve: 'Zatwierdź dostęp', deny: 'Odrzuć', revoke: 'Zakończ teraz' },
    status: {
      requested: 'Oczekuje',
      active: 'Aktywny',
      denied: 'Odrzucony',
      revoked: 'Zakończony',
      expired: 'Wygasł',
      request_expired: 'Prośba wygasła',
    },
    columns: { supporter: 'Konto wsparcia', requestedAt: 'Poproszono', status: 'Status', endedAt: 'Zakończono' },
    success: { approved: 'Dostęp wsparcia zatwierdzony.', denied: 'Wniosek odrzucony.', revoked: 'Dostęp wsparcia zakończony.' },
    errors: {
      consentChanged: 'Treść zgody uległa zmianie. Przeczytaj ją ponownie przed zatwierdzeniem.',
      selfApproval: 'Konto wnioskujące nie może zatwierdzić własnej prośby.',
    },
  },
  // Administration › Statutory rules (ADR 0091): the statutory rule catalogue
  // and the workspace's agreements and deviations, moved here from Time's
  // settings with the page.
  statutory: {
    title: 'Przepisy ustawowe i porozumienia',
    intro: 'Przepisy ustawowe obowiązują automatycznie i są centralnie aktualizowane. Tutaj określasz tylko, gdzie Twoja firma od nich odstępuje – każde odstępstwo wymaga podstawy, na przykład układu zbiorowego lub porozumienia zakładowego.',
    disclaimer: 'Wartości orientacyjne według ustawy – to nie porada prawna. Układy zbiorowe mogą być surowsze.',
    // "Checked, fits us" (issue 713): the one-time confirmation of the statutory defaults.
    confirmation: {
      unchecked: {
        title: 'Jeszcze niesprawdzone',
        // The short sentence for someone who may read the page but not confirm (a support grant): no picker, no button.
        body: 'lumi startuje z ustawowymi regułami domyślnymi. Jeśli pasują do Państwa firmy, proszę to potwierdzić. Jeśli obowiązuje u Państwa układ zbiorowy lub porozumienie zakładowe, proszę dodać poniżej odstępstwo.',
        confirm: 'Sprawdzone, pasuje do nas',
        // The mode picker (issue 780) is shown to someone who can confirm; the tile titles are the settings card's own (statutory.workspace.modeFlexible/modeStrict).
        lead: 'lumi startuje z ustawowymi regułami domyślnymi – maksymalny czas pracy, przerwy, odpoczynek. Proszę zdecydować, co się dzieje, gdy wpis narusza którąś z nich, a następnie potwierdzić, że reguły pasują do Państwa firmy.',
        standard: 'Domyślnie',
        later: 'Obie rzeczy mogą Państwo później w każdej chwili zmienić.',
        agreements: 'Czy u Państwa obowiązuje układ zbiorowy lub porozumienie zakładowe, według którego reguła obowiązuje inaczej lub wcale? W takim razie proszę dodać poniżej {basis} – ostrzeżenia się do niego stosują. Trybu bez ostrzeżeń nie ma.',
        agreementsBasis: 'odstępstwo wraz z jego podstawą',
        flexible: {
          personLabel: 'Osoba', personText: 'widzi przy zapisie, którą regułę naruszono i o ile – wpis pozostaje.',
          managerLabel: 'Kierownictwo', managerText: 'widzi naruszenia tygodnia przy zatwierdzaniu i decyduje wspólnie z osobą.',
          recordLabel: 'Dziennik', recordText: 'rejestruje każde naruszenie – dla Państwa, nie przeciwko Państwu.',
        },
        strict: {
          personLabel: 'Osoba', personText: 'nie może zapisać wpisu, który narusza egzekwowaną regułę – i widzi dlaczego. Brakująca przerwa zostaje zapisana i wyświetlona.',
          managerLabel: 'Kierownictwo', managerText: 'przy zatwierdzaniu widzi tylko to, co mimo to powstaje: brakujące przerwy i automatyczne zamknięcia.',
          fitLabel: 'Pasuje, gdy', fitText: 'wyjątki nie mogą u Państwa występować – na przykład w przypadku osób niepełnoletnich.',
        },
      },
      // After a save that is not a review, while unconfirmed (issue 990): the next step, in place.
      afterSave: { body: 'Zapisano. To jeszcze nie potwierdza zasad czasu pracy – potwierdź teraz, że do was pasują.', confirm: 'Potwierdź teraz' },
      confirmed: { title: 'Sprawdzone', body: 'Potwierdzone dnia {date} przez {name}: ustawowe zasady do nas pasują.', bodyNoName: 'Potwierdzone dnia {date}: ustawowe zasady do nas pasują.' },
      ownDeviation: { title: 'Sprawdzone', body: 'Państwa obszar roboczy ma własne odstępstwa, więc zasady zostały już przejrzane.' },
      error: 'Nie udało się zapisać potwierdzenia. Proszę spróbować ponownie.',
    },
    noJurisdictions: 'Nie ustawiono jeszcze żadnej jurysdykcji: nie ma osób z miejscem pracy ani jurysdykcji domyślnej. Wybierz ją poniżej, a pojawią się tu przepisy ustawowe.',
    jurisdictionEu: 'Dyrektywa UE',
    jurisdictionDefault: '{name} (domyślna)',
    // Who the number is (issue 990): active employees in Time judged by this law —
    // on a tab that is not the default, only those whose work location is there;
    // on the default's tab, also everyone who falls back to it.
    headcountLine: 'Jurysdykcja {country}: te zasady nie obejmują obecnie nikogo. | Jurysdykcja {country}: te zasady oceniają czas pracy 1 osoby w module Czas, która pracuje tutaj. | Jurysdykcja {country}: te zasady oceniają czas pracy aktywnych pracowników w module Czas, którzy pracują tutaj – liczba osób: {count}.',
    headcountLineDefault: 'Jurysdykcja {country}: te zasady nie obejmują obecnie nikogo. | Jurysdykcja {country}: te zasady oceniają czas pracy 1 osoby w module Czas, która pracuje tutaj lub podlega jurysdykcji domyślnej. | Jurysdykcja {country}: te zasady oceniają czas pracy aktywnych pracowników w module Czas, którzy pracują tutaj lub podlegają jurysdykcji domyślnej – liczba osób: {count}.',
    fallbackLine: 'Osoby bez miejsca pracy lub z miejscem pracy spoza katalogu: {count} – obowiązuje je {country}.',
    createModels: 'Dodaj modele czasu pracy tego kraju',
    domains: {
      workingTime: 'Czas pracy',
      pay: 'Okna czasowe dodatków',
      overtime: 'Nadgodziny',
      leave: 'Urlop',
    },
    rules: {
      maxDailyHours: 'Maksymalny dobowy czas pracy',
      maxWeeklyHours: 'Maksymalny tygodniowy czas pracy',
      breaks: 'Przerwy',
      minDailyRest: 'Odpoczynek dobowy',
      nightWorkBan: 'Zakaz pracy w nocy',
      minWeeklyRest: 'Odpoczynek tygodniowy',
      avgWeeklyHours: 'Przeciętny tygodniowy czas pracy',
      normalDailyHours: 'Normalny dobowy czas pracy',
      normalWeeklyHours: 'Normalny tygodniowy czas pracy',
      nightWindow: 'Pora nocna dla dodatków',
      nightCoreWindow: 'Ścisła pora nocna dla wyższych dodatków',
      overtimeThreshold: 'Nadgodziny od (godzin tygodniowo)',
      overtimeSurcharge: 'Dodatki za nadgodziny',
      minLeaveDays: 'Minimalny urlop roczny',
    },
    kinds: {
      collectiveAgreement: 'Układ zbiorowy',
      worksAgreement: 'Porozumienie zakładowe',
      authorityPermit: 'Zezwolenie organu',
      companyPolicy: 'Regulacja wewnętrzna',
    },
    value: {
      hoursUnit: 'h',
      days: '{days} dni',
      breakStage: '{minutes} min powyżej {hours} h',
      weeklyAverage: 'średnio {hours} h w okresie {weeks} tygodni',
      nightWorkBan: 'zakaz pracy między {start} a {end}',
      tierFirst: '{percent} % od pierwszej nadgodziny',
      tierAfter: '{percent} % po {hours} nadgodzinach',
      none: 'Brak reguły',
      switchedOff: 'Reguła nie obowiązuje (wyłączona)',
    },
    status: {
      statutory: 'Ustawowo',
      noStatutoryRule: 'Brak reguły ustawowej',
      infoOnly: 'Tylko informacyjnie',
      deviation: 'Odstępstwo',
      deviationStricter: 'Odstępstwo · surowsze',
      deviationLooser: 'Odstępstwo · łagodniejsze',
      deviationMoreFavourable: 'Odstępstwo · korzystniejsze niż ustawa',
      deviationLessFavourable: 'Odstępstwo · mniej korzystne niż ustawa',
      deviationEqual: 'Odstępstwo · jak w ustawie',
      deviationMixed: 'Odstępstwo · częściowo surowsze, częściowo łagodniejsze',
      deviationMixedFavourable: 'Odstępstwo · częściowo korzystniejsze, częściowo mniej korzystne',
    },
    hint: {
      stricter: 'Surowiej niż ustawa – dopuszczalne na każdej podstawie.',
      looser: 'Łagodniej niż ustawa – wymaga to układu zbiorowego, porozumienia zakładowego lub zezwolenia organu jako podstawy.',
      moreFavourable: 'Korzystniej niż ustawa – dopuszczalne na każdej podstawie.',
      lessFavourable: 'Mniej korzystnie niż ustawa – wymaga to układu zbiorowego, porozumienia zakładowego lub zezwolenia organu jako podstawy.',
      mixed: 'Częściowo surowiej, częściowo łagodniej niż ustawa – wymaga to układu zbiorowego, porozumienia zakładowego lub zezwolenia organu jako podstawy.',
      mixedFavourable: 'Częściowo korzystniej, częściowo mniej korzystnie niż ustawa – wymaga to układu zbiorowego, porozumienia zakładowego lub zezwolenia organu jako podstawy.',
      equal: 'Zgodne z wartością ustawową – odstępstwo nie jest potrzebne.',
      incomparable: 'Przy tej regule nie ma „surowiej” ani „łagodniej” – każda podstawa jest możliwa.',
      blocked: 'Regulacja wewnętrzna nie może być mniej korzystna niż ustawa. Wybierz jako podstawę układ zbiorowy, porozumienie zakładowe lub zezwolenie organu – albo wartość co najmniej zgodną z ustawą.',
    },
    table: {
      rule: 'Reguła',
      applies: 'Obowiązuje',
      note: 'Uwaga do stanu prawnego',
      deviate: 'Odstąp',
      backToStatute: 'Wróć do ustawy',
      statutoryWouldBe: 'Ustawowo byłoby: {value}',
      statutoryWouldBeNone: 'Ustawa nie przewiduje tu żadnej reguły.',
      basis: 'Podstawa: {name}',
      basisWithClause: 'Podstawa: {name}, {clause}',
      coveredDeviation: 'Z kodem układu zbiorowego {code}: {value} ({name})',
      futureDeviation: 'Od {date}: {value} ({name})',
      fallbackApplies: 'Ustawa nie określa tu przedziału czasu – obowiązuje ten, dopóki porozumienie nie ustali innego.',
      fallbackWouldBe: 'Ustawa nie określa tu przedziału czasu – bez odstępstwa obowiązywałby: {value}',
      editDeviationOf: 'Edytuj odstępstwo „{name}”',
      backToStatuteOf: 'Zastąp odstępstwo „{name}” ustawą',
    },
    notice: {
      fallback: 'Katalog przepisów ustawowych jest chwilowo niedostępny. Wyświetlany jest wbudowany stan bazowy; ostatnich zmian może brakować.',
      unjudged: 'Osoby, których nie obejmuje obecnie żaden przepis ustawowy: {count}. Nie mają miejsca pracy, a jurysdykcja domyślna nie jest ustawiona – wybierz ją poniżej.',
      upcoming: 'Od {date} przepis ustawowy „{rule}” zmienia się na: {value}.',
      upcomingNone: 'Od {date} przepis ustawowy „{rule}” przestaje obowiązywać.',
      upcomingDeviationStays: 'Twoje odstępstwo pozostaje w mocy.',
      reviewTitle: 'Do sprawdzenia: {rule}',
      review: 'Wartość ustawowa zmieniła się od czasu ustalenia tego odstępstwa ({agreement}). Ustawa przewiduje teraz: {statutory}. Twoje odstępstwo: {deviation}.',
      keepDeviation: 'Zachowaj odstępstwo',
    },
    minors: {
      title: 'Młodociani poniżej 18 lat',
      headcount: 'Osoby: {count}',
      headcountNone: 'obecnie brak',
      hint: 'Wobec osób poniżej 18 lat zamiast przepisów ogólnych obowiązują te ustawowe przepisy o ochronie młodocianych – automatycznie, na podstawie daty urodzenia zapisanej w Kadrach. Porozumienia od nich nie odstępują.',
      generalApplies: 'Jeszcze brak odrębnej reguły – do tego czasu obowiązuje ogólna.',
      upcoming: 'Od {date}: {value}',
      upcomingNone: 'Od {date} ten przepis o ochronie młodocianych przestaje obowiązywać.',
    },
    form: {
      value: 'Wartość odstępstwa',
      daysUnit: 'dni',
      stageAfterHours: 'Czas pracy powyżej (h)',
      stageMinutes: 'Przerwa łącznie (min)',
      tierAfterHours: 'Od nadgodzin w tygodniu (h)',
      tierPercent: 'Dodatek (%)',
      addStep: 'Dodaj próg',
      removeStep: 'Usuń próg {row}',
      stageAfterHoursRow: 'Próg {row}: czas pracy powyżej (h)',
      stageMinutesRow: 'Próg {row}: przerwa łącznie (min)',
      tierAfterHoursRow: 'Próg {row}: od nadgodzin w tygodniu (h)',
      tierPercentRow: 'Próg {row}: dodatek (%)',
      averageHours: 'Średnio godzin tygodniowo',
      averageWeeks: 'Okres rozliczeniowy (tygodnie)',
      windowStart: 'Początek',
      windowEnd: 'Koniec',
      windowHint: 'Jeśli koniec przypada przed początkiem, okno trwa po północy.',
      statutoryIs: 'Ustawa przewiduje: {value}',
      comparisonBase: 'Bez reguły ustawowej obowiązuje {value} – odstępstwo jest mierzone względem tej wartości.',
      basis: 'Podstawa',
      basisHint: 'Porozumienie, na którym opiera się odstępstwo.',
      basisPick: 'Wybierz podstawę…',
      basisNew: 'Utwórz nową podstawę…',
      basisRequired: 'Wybierz podstawę.',
      clause: 'Postanowienie',
      clauseHint: 'Gdzie znajduje się postanowienie, np. „§ 4 ust. 2”. Opcjonalnie.',
      invalid: {
        hours: 'Podaj godziny: więcej niż 0 i najwyżej 168.',
        days: 'Podaj dni: więcej niż 0 i najwyżej 366.',
        breakLadder: 'Sprawdź progi: od 1 do 6, rosnąco według czasu pracy (powyżej 0 do 24 h), przerwa powyżej 0 do 480 min i nigdy krótsza niż w poprzednim progu.',
        weeklyAverage: 'Sprawdź wartości: godziny powyżej 0 i najwyżej 168, okres rozliczeniowy od 1 do 104 tygodni.',
        timeWindow: 'Podaj godzinę początku i końca; muszą się różnić.',
        percentTiers: 'Sprawdź progi: od 1 do 6, pierwszy od 0 nadgodzin, kolejne rosnąco; dodatek od 0 do 300 %, najwyżej z dwoma miejscami po przecinku.',
      },
    },
    agreement: {
      name: 'Nazwa',
      title: 'Porozumienia',
      subtitle: 'Układy zbiorowe, porozumienia zakładowe, zezwolenia i regulacje wewnętrzne – podstawy Twoich odstępstw.',
      new: 'Nowe porozumienie',
      edit: 'Edytuj porozumienie',
      empty: 'Brak porozumień – wszędzie obowiązują przepisy ustawowe.',
      inactive: 'Obecnie nie obowiązuje',
      migrated: 'Przeniesione z wcześniejszych ustawień',
      noDeviations: 'Brak odstępstw. Ustaw je powyżej, przy odpowiedniej regule.',
      needsReview: 'Do sprawdzenia',
      kind: 'Rodzaj porozumienia',
      companyPolicyHint: 'Regulacja wewnętrzna może być wyłącznie surowsza lub korzystniejsza niż ustawa.',
      nameHint: 'Na przykład „Układ zbiorowy dla branży metalowej” lub „Porozumienie o przerwach 2026”.',
      nameRequired: 'Nadaj porozumieniu nazwę.',
      reference: 'Sygnatura / numer',
      referenceHint: 'Opcjonalnie, np. numer rejestru lub numer decyzji.',
      jurisdiction: 'Jurysdykcja',
      validFrom: 'Obowiązuje od',
      validFromRequired: 'Podaj, od kiedy porozumienie obowiązuje.',
      validTo: 'Obowiązuje do',
      validToHint: 'Zostaw puste, jeśli porozumienie obowiązuje bezterminowo.',
      validSince: 'obowiązuje od {from}',
      validRange: 'obowiązuje {from} – {to}',
      scope: 'Dotyczy',
      scopeAll: 'wszystkie osoby w tej jurysdykcji',
      scopeCovered: 'tylko osoby objęte układem zbiorowym',
      scopeCoveredCode: 'tylko kod układu zbiorowego {code}',
      coverageCode: 'Kod układu zbiorowego',
      coverageCodeHint: 'Kod zapisuje się w umowie o pracę danej osoby w Kadrach. Porozumienie dotyczy tylko osób z dokładnie tym kodem.',
      deleteTitle: 'Usunąć „{name}”?',
      deleteConfirm: 'Wraz z porozumieniem zostaną usunięte jego odstępstwa (liczba: {count}). Te reguły będą znów zgodne z ustawą.',
      deleteConfirmEmpty: 'Porozumienie nie zawiera odstępstw; obowiązujące reguły się nie zmienią.',
      editDeviation: 'Edytuj odstępstwo: {rule}',
      removeDeviation: 'Wróć do ustawy: {rule}',
    },
    backConfirm: {
      title: '„{rule}”: wrócić do ustawy?',
      body: 'Odstępstwo zostanie usunięte. Następnie znów będzie obowiązywać wartość ustawowa: {value}.',
      bodyNone: 'Odstępstwo zostanie usunięte. Ustawa nie przewiduje tu reguły – potem nie będzie obowiązywać żadna.',
      bodyFallback: 'Odstępstwo zostanie usunięte. Ustawa nie przewiduje tu reguły – potem znów będzie obowiązywać {value}.',
    },
    workspace: {
      title: 'Ustawienia obszaru roboczego',
      defaultJurisdiction: 'Jurysdykcja domyślna',
      defaultJurisdictionHint: 'Dotyczy osób bez miejsca pracy lub z miejscem pracy, którego katalog nie obejmuje.',
      noDefault: 'Brak domyślnej',
      mode: 'Gdy wpis narusza regułę',
      modeFlexible: 'Ostrzegaj i rejestruj',
      modeFlexibleHint: 'Wpis zostaje zapisany. Naruszenie jest wyświetlane i rejestrowane.',
      modeStrict: 'Zablokuj wpis',
      modeStrictHint: 'Wpisu, który narusza egzekwowaną regułę, nie można zapisać.',
      originSignup: 'Przejęte z kraju, który Twoja firma podała przy rejestracji: {country}.',
      originFallbackPrevious: 'Dopóki kraj podany przez Twoją firmę przy rejestracji nie jest znany i nie ma go w katalogu, obowiązują reguły dla: {current} – te, według których ta przestrzeń robocza była dotąd oceniana.',
      originFallbackUnknown: 'Kraj Twojej firmy nie jest jeszcze znany, dlatego obowiązuje minimum UE, dopóki ktoś nie wybierze tu kraju.',
      originFallbackUncovered: 'Przy rejestracji Twoja firma podała kraj: {country}. Katalog nie zawiera jeszcze dla niego reguł, dlatego obowiązuje minimum UE.',
      originFallbackCovered: 'Przy rejestracji Twoja firma podała kraj: {country}. Jego reguły są już w katalogu – wybierz go tutaj, aby je zastosować. Do tego czasu obowiązuje minimum UE.',
    },
    toast: {
      settingsSaved: 'Ustawienia zapisane',
      deviationSaved: 'Odstępstwo zapisane',
      deviationConfirmed: 'Odstępstwo potwierdzone',
      backToStatute: 'Odstępstwo usunięte – znów obowiązuje ustawa',
      agreementSaved: 'Porozumienie zapisane',
      agreementDeleted: 'Porozumienie usunięte',
      modelsCreated: 'Dodane modele czasu pracy: {count}',
      modelsExist: 'Modele czasu pracy tego kraju już istnieją.',
    },
    errors: {
      rival: '„{name}” ustala już tę regułę dla tych samych osób w nakładającym się okresie.',
      validToBeforeFrom: 'Koniec obowiązywania nie może przypadać przed początkiem.',
      coverageCodeRequired: 'Podaj kod układu zbiorowego, którego dotyczy porozumienie.',
      invalidValue: 'Wartość jest nieprawidłowa dla tej reguły. Sprawdź ją.',
      jurisdictionUnknown: 'Tej jurysdykcji nie ma w katalogu przepisów ustawowych.',
      dateInvalid: 'Podaj prawidłową datę.',
      labelInvalid: 'Sprawdź pola tekstowe: nazwa jest wymagana, a żadne pole nie może mieć więcej niż 160 znaków.',
      noModelPresets: 'Dla tego kraju nie ma przygotowanych modeli czasu pracy.',
      kindInvalid: 'Wybierz rodzaj porozumienia z listy.',
      modeInvalid: 'Wybierz, co się dzieje, gdy wpis narusza regułę.',
      ruleUnknown: 'Ta wersja aplikacji nie zna tej reguły. Odśwież stronę.',
      ruleInfoOnly: 'Ta reguła jest wyświetlana wyłącznie informacyjnie – nie można od niej odstąpić.',
    },
    // The workspace page around the section (Administration › Statutory rules):
    // a workspace without Time, and a viewer time-api does not admit.
    page: {
      timeInactiveTitle: 'Moduł Czas nie jest aktywny w tym obszarze roboczym',
      timeInactive: 'Przepisy ustawowe dotyczą czasu pracy rejestrowanego w Czasie. Gdy Czas stanie się częścią tego obszaru roboczego, tutaj określisz, w czym Twoja firma od nich odstępuje.',
      noAccess: 'Nie możesz zarządzać przepisami ustawowymi tego obszaru roboczego. Mogą to robić właściciel obszaru roboczego, administracja suite oraz członkowie Czasu z uprawnieniem do zarządzania zgodnością.',
    },
  },
  // Administration › Training occupations (ADR 0092).
  trainingOccupations: {
    title: 'Zawody szkoleniowe',
    columns: {
      occupation: 'Zawód szkoleniowy',
      duration: 'Czas trwania',
      regulation: 'Rozporządzenie o kształceniu',
      apprentices: 'Praktykanci',
    },
    duration: '{count} mies.',
    regulationIssued: 'z dnia {date}',
    regulationValidFrom: 'obowiązuje od {date}',
    areas: {
      IH: 'Przemysł i handel (IHK)',
      Hw: 'Rzemiosło (HWK)',
      oeD: 'Służba publiczna',
      Lw: 'Rolnictwo',
      FB: 'Wolne zawody',
      Hausw: 'Gospodarstwo domowe',
      See: 'Żegluga morska',
    },
    branches: {
      specialisations: 'Specjalności',
      focuses: 'Profile',
      any: 'Specjalności / profile',
    },
    requirements: {
      onWall: 'Pozycje rozporządzenia o kształceniu na tablicy umiejętności: {count}',
      version: 'rozporządzenie z dnia {date}',
      none: 'Pozycje rozporządzenia o kształceniu nie są jeszcze dostępne. Pojawią się na tablicy umiejętności, gdy tylko operator platformy je zaimportuje.',
      versions: 'Wersje rozporządzenia, według których kształcą się praktykanci: {count}. Każdego obowiązuje wersja, która była w mocy w chwili rozpoczęcia kształcenia.',
    },
    state: {
      notSelectable: 'Nie można już wybrać',
      notSelectableHint: 'Operator platformy nie oferuje już tego zawodu do nowego wyboru. Twój obszar roboczy zachowuje go wraz z praktykantami – ale po usunięciu nie da się go dodać ponownie.',
      withdrawn: 'Uznanie cofnięte',
      withdrawnHint: 'Państwowe uznanie tego zawodu zostało uchylone albo zawód nie figuruje już w wykazie uznanych zawodów szkoleniowych. Trwające kształcenie zostanie dokończone; zawodu nie można dodać ponownie.',
      unknown: 'Brak w katalogu',
      unknownHint: 'Ten wpis został wpisany ręcznie, zanim powstał katalog, i nie odpowiada żadnemu z jego zawodów. Można go tylko usunąć – zamiast niego dodaj odpowiedni zawód z katalogu.',
    },
    offered: {
      title: 'Nasza oferta',
      intro: 'Uznane zawody szkoleniowe, w których kształci Twoja firma. Tylko je można wybrać dla praktykanta.',
      emptyTitle: 'W ofercie nie ma jeszcze żadnego zawodu szkoleniowego',
      empty: 'Wybierz z katalogu poniżej zawody, w których kształci Twoja firma. Potem możesz przypisać je swoim praktykantom.',
      browse: 'Wybierz z katalogu',
      remove: 'Usuń',
      removeNamed: 'Usuń {title} z oferty',
    },
    catalogue: {
      title: 'Dodaj z katalogu',
      intro: 'Uznane w Niemczech zawody szkoleniowe, których Twój obszar roboczy jeszcze nie oferuje. Katalog jest aktualizowany centralnie.',
      unavailableTitle: 'Katalog jest w tej chwili niedostępny',
      unavailable: 'Twoja oferta powyżej jest wyświetlana na podstawie tego, co zapisał ten obszar roboczy. Zawody będzie można znów dodawać, gdy katalog wróci.',
      allOffered: 'Twój obszar roboczy oferuje już wszystkie zawody z katalogu.',
      searchPlaceholder: 'Nazwa lub specjalność',
      areaLabel: 'Obszar',
      areaAll: 'Wszystkie obszary',
      count: 'Znalezione zawody: {shown} z {total}',
      noMatches: 'Żaden zawód nie pasuje do wyszukiwania.',
      resetFilters: 'Wyczyść wyszukiwanie',
      showMore: 'Pokaż więcej',
      add: 'Dodaj',
      addNamed: 'Dodaj {title} do oferty',
    },
    removeConfirm: {
      title: 'Usunąć „{title}” z oferty?',
      apprentices: 'Praktykanci przypisani obecnie do tego zawodu: {count}. Zachowują swój zawód i kończą kształcenie – nie będzie go tylko można wybrać dla nowych praktykantów.',
      final: 'Po usunięciu tego zawodu nie da się dodać ponownie.',
      confirm: 'Usuń z oferty',
    },
    toast: {
      added: '„{title}” należy teraz do Twojej oferty',
      removed: '„{title}” nie jest już oferowany',
    },
    errors: {
      notOfferable: 'Nie udało się dodać „{title}”: zawód został w międzyczasie wyłączony lub wycofany. Lista została odświeżona.',
      catalogueUnavailable: 'Katalog jest w tej chwili niedostępny, więc nie można nic dodać. Spróbuj ponownie później.',
    },
    page: {
      moduleInactiveTitle: 'Moduł Kształcenie nie jest aktywny w tym obszarze roboczym',
      moduleInactive: 'Zawody szkoleniowe są oferowane praktykantom zarządzanym w module Kształcenie. Gdy stanie się on częścią tego obszaru roboczego, tutaj wybierzesz, w jakich zawodach kształci Twoja firma.',
      noAccess: 'Nie możesz zarządzać zawodami szkoleniowymi tego obszaru roboczego. Mogą to robić właściciel obszaru roboczego, administracja suite oraz członkowie modułu Kształcenie z uprawnieniem do zarządzania nim.',
    },
  },
};
